import React from 'react';

const spanish = {
  readingReceipt: { receivedAt: 'Recibido el: {0}', delayed: 'Lectura recibida con retraso.' },
  capActivity: {
    lastTakeTitle: "Dispositivos por días desde el último uso",
    lastActivityTitle: "Dispositivos por días desde la última actividad",
    activityDays: "Días desde la última actividad",
    noActivity: "Sin actividad: {0}",
    lastActivityDescription: "Número de dispositivos distintos según los días naturales desde su última actividad (0 = hoy). Los dispositivos sin actividad se muestran por separado. No se aplican los filtros de fecha y programa.",
    group: "Actividad de los dispositivos",
    devices: "Dispositivos",
    days: "Días desde el último uso",
    neverUsed: "Nunca usados: {0}",
    snapshot: "Estado actual: {0} ({1}).",
    lastTakeDescription: "Número de dispositivos distintos según los días naturales desde su último evento vital (0 = hoy). Los dispositivos sin eventos vitales se muestran por separado como nunca usados. No se aplican los filtros de fecha y programa.",
    chartType: "Tipo de gráfico",
    bar: "Gráfico de barras",
    area: "Gráfico de áreas",
    line: "Gráfico de líneas",
    pie: "Gráfico circular",
  },
  accessCareUpdates: {
    responsibleClinician: 'Profesional clínico responsable', chooseClinician: 'Seleccione un médico',
    cliniciansFailed: 'No se pudieron cargar los médicos. Cierre y vuelva a abrir esta actualización para intentarlo de nuevo.', noClinicians: 'No hay médicos disponibles con acceso a este paciente.',
    validClinicianRequired: 'Seleccione un médico activo con acceso a este paciente.',
    send: 'Enviar actualización', sendingUnavailable: 'El envío de actualizaciones aún no está disponible. Su borrador no se ha enviado.',
    requiredField: 'Este campo es obligatorio antes de enviar.', planRequired: 'Añada al menos una intervención completa antes de enviar.',
    completeBeforeSending: 'Complete antes de enviar: {0}.',
    optionalActionsHint: 'Las acciones son opcionales. Si se deja en blanco, el PDF muestra "No action needed".',
    refreshPreview: 'Actualizar vista previa', closePreview: 'Cerrar vista previa', previewStale: 'El borrador ha cambiado. Actualice la vista previa para incluir los últimos cambios.',
    previewPdf: 'Vista previa del PDF', downloadPdf: 'Descargar PDF', pdfPreviewTitle: 'Vista previa del PDF de actualización de atención',
    previewHint: 'La vista previa usa los cambios actuales y los datos clínicos actuales sin guardar el borrador. No aprueba ni envía el documento.',
    previewFailed: 'No se pudo generar el PDF. Inténtelo de nuevo.',
    title: 'Actualizaciones de atención', open: 'Abrir actualización de atención', enrollment: 'Inscripción ACCESS', update: 'Actualización de atención',
    assessment: 'Evaluación', interventions: 'Intervenciones', plan: 'Plan', actions: 'Acciones', measure: 'Medida / intervención',
    assessmentHint: 'Resuma el estado clínico actual del paciente, su evolución y cualquier preocupación que deba conocer el profesional que recibe la actualización.',
    actionsHint: 'Describa las acciones solicitadas al médico de atención primaria o al profesional remitente. Déjelo en blanco si no se necesita ninguna acción.',
    availableAt: 'Disponible desde', dueAt: 'Plazo de envío', reload: 'Recargar',
    overdue: 'Plazo vencido',
    dueDate: 'Fecha límite', actionByUpdatedAt: 'Acción (última actualización)',
    createEscalation: 'Escalamiento de atención', escalationCreated: 'Tarea de escalamiento creada.',
    addIntervention: 'Añadir intervención', removeIntervention: 'Eliminar intervención', saveDraft: 'Guardar borrador',
    addInterventionHint: 'Añada una medida o intervención y describa la atención prevista, por ejemplo, el control de la presión arterial o un ajuste de medicación.',
    reloadRequired: 'Esta actualización ha cambiado desde que la abrió. Recargue la versión más reciente antes de guardar.',
    saved: 'Borrador de actualización guardado.',
    requestFailed: 'No se pudieron cargar o guardar las actualizaciones. Inténtelo de nuevo.',
    maxCharacters: 'Máximo {0} caracteres.', discardChanges: '¿Descartar los cambios sin guardar?',
    keepEditing: 'Seguir editando', discard: 'Descartar cambios',
    draftOnly: 'Guardar solo actualiza el borrador. No aprueba el documento, completa la tarea ni envía un mensaje.',
    readOnly: 'Esta actualización es de solo lectura en su estado actual.',
    types: { initiation: 'Inicio de atención', escalation: 'Escalamiento de atención', completion: 'Finalización de atención' },
    statuses: { draft: 'Borrador', ready_for_transmission: 'Listo para enviar', transmission_in_progress: 'Envío en curso', completed: 'Completado', failed_to_transmit: 'Error de envío', cancelled: 'Cancelado' },
  },
  yes: 'Sí',
  no: 'No',
  none: 'None',
  all: 'Todo',
  allKits: 'Todos los kits',
  allEnrollments: 'Todas las inscripciones',
  writePrivileges: 'Permiso de edición',
  orderList: 'Lista de órdenes',
  appEmail: 'support@rxcap.com',
  downloadData: 'Descargar datos',
  downloadAllData: 'Descargar todos los datos',
  downloadResultsData: 'Descargar datos de resultados',
  downloadHistory: 'Descargar historial',
  downloadAllMeds: 'Descargar lista de medicamentos',
  downloadEvents: 'Download Events',
  downloadSummary: 'Download Summary',
  downloadMonthlySummary: 'Descargar resumen mensual',
  downloadDevicesDetails: 'Download Devices Details',
  showingXDevicesAndKits: 'Mostrando {0} de {1} dispositivos • {2} kits',
  downloadInvoicingData: 'Download Invoicing Data',
  downloadNotesAndActions: 'Download Notes and Actions',
  downloadMonitoringReport: 'Download Monitoring Report',
  addPatient: 'Agregar paciente',
  addEnrollAssignMed: 'Add & Enroll Patient, Assign Medication',
  removePatient: 'Remove Patient',
  initiateNewEnrollment: 'Initiate New Enrollment',
  addNickName: 'Editar el nombre',
  sessionTimeout: 'Extender la sesión',
  sessionExpiredMessage: 'Su sesión expiró. Vuelva a iniciar sesión.',
  sessionExpiredTitle: 'Sesión expirada',
  sessionExpiredInactivityMessage: 'Ha sido desconectado por inactividad.',
  sessionExpiredInactivityMessageWithDuration: 'Ha sido desconectado por inactividad durante {0} minutos.',
  sessionExpiredLoginButton: 'Iniciar sesión de nuevo',
  idleSessionCountdown: 'Se cerrará la sesión en {0}.',
  nickName: 'Nombre de la tapa',
  editName: 'Editar el nombre',
  editCapName: 'Editar el nombre de la tapa',
  addPatients: 'Agregar pacientes',
  addRemovePatients: 'Add / Remove Patients',
  fullName: 'Nombre completo',
  date: 'Fecha',
  time: 'Hora',
  editInfo: 'Editar información',
  reloadGraph: 'Volver a cargar gráfico',
  reload: 'Reload',
  showSelectedItems: 'Mostrar los campos seleccionados',
  showSelectedWidgets: ' Mostrar los widgets seleccionados',
  resetToDefaults: 'Restablecer configuración original',
  deleteWarning: '¿Seguro de que quiere borrar el {0}?',
  deletePatientWarning: '¿Seguro de que quiere borrar el paciente',
  updateStatus: '¿Seguro de que quiere actualizar el estado a',
  deleteCapManagerWarning: '¿Seguro de que quiere borrar el administrador de la tapa',
  deleteDoctorWarning: '¿Seguro de que quiere borrar el doctor',
  deleteOrderWarning: '¿Seguro de que quiere borrar la orden',
  deleteOrgWarning: '¿Seguro de que quiere borrar la organización',
  deleteOrgBlockedCaption: 'no se puede borrar',
  deleteOrgBlockedMessage: 'Los siguientes elementos bloquean el borrado de esta organización:',
  deleteOrgNoBlockers: 'Nada bloquea el borrado de esta organización.',
  deleteOrgReadinessFailed: 'No se pudo comprobar qué bloquea el borrado de esta organización.',
  deleteOrgForceCleanWarning: 'Al borrar esta organización también se eliminarán los bloqueos mostrados arriba.',
  deleteOrgForceCleanConfirmationLabel: 'Nombre de la organización',
  deleteOrgForceCleanConfirmationMessage: 'Escriba el nombre de la organización abajo',
  launchOrgWarning: 'Are you sure you want to launch organization',
  unsuspendOrgWarning: 'Are you sure you want to unsuspend organization',
  deleteScheduleWarning: '¿Seguro de que quiere borrar el horario de',
  deleteTaksHistoryWarning: '¿Seguro de que quiere borrar el historial de tareas',
  deleteMedicationWarning: '¿Seguro de que quiere borrar el medicamento',
  deleteScheduleCapWarning: '¿Seguro de que quiere borrar la tapa',
  deleteOrgManagerWarning: '¿Seguro de que quiere borrar al gerente de la organización',
  deleteOrgAdminWarning: '¿Seguro de que quiere borrar al admin de la organización',
  deleteOrgCapsManagerWarning: '¿Seguro de que quiere borrar al gerente de tapas de la organización',
  deleteOrgOutboundAPIWarning: '¿Seguro de que quiere borrar el API saliente de la organización?',
  deleteCapWarning: '¿Seguro de que quiere borrar el dispositivo? ',
  capSendSecurityCode: 'Enviar código de seguridad del dispositivo',
  capSendSecurityCodeSent: 'Se envió el código de seguridad del dispositivo',
  deleteCapWarning: '¿Seguro de que quiere eliminar la tapa',
  deleteHubDeviceWarning: '¿Seguro de que quiere borrar el dispositivo',
  deleteCohortWarning: 'Are you sure you want to delete cohort',
  unassignPatientWarning: 'Are you sure you want to unassign patient from cohort',
  assignCapToScheduleCaption: 'Cap {0} will be assigned to schedule {1}',
  unassignCapToScheduleCaption: 'Cap {0} will be unassigned from schedule {1}',
  deletePrefabReply: 'Are you sure you want to delete prefab response',
  deleteOrgGrpWarning: 'Are you sure you want to delete organization group',
  deleteOrgFromGroupWarningarning: (org, grpName) => ['Are you sure you want to delete organization ', <b>{org}</b>, ` from group ${grpName}?`],
  deleteMaintainerFromGroupWarningarning: (user, grpName) => ['Are you sure you want to delete maintainer ', <b>{user}</b>, ` from group ${grpName}?`],
  deleteUserFromGroupWarningarning: (user, grpName) => ['Are you sure you want to delete user ', <b>{user}</b>, ` from group ${grpName}?`],
  invitePatientWarning: 'Are you sure you want to invite patient {0} to portal?',
  resetBleWarning: 'Are you sure you want to reset BLE chip for selected hub(s)?',
  startEnrollmentWarning: 'Are you sure you want to activate the following program for patient {0}?',
  startEnrollmentMedsWarning:
    'The following schedules are linked to the program and have start date in the future. They will automatically start when the program is activated.',
  resetPatientStatusWarning:
    'Are you sure you want to initiate new enrollment for patient {0}? Patient will appear in Onboarded/Registered state.',
  resetPatientStatusActiveProgramsWarning: 'Patient already has active enrollment programs. Initiating new enrollment will not end the active programs.',
  resetPatientStatusSchedulesWarning:
    'The following schedules have cap assigned. Please select the schedules from which you want to unassign cap.',
  resetPatientStatusActiveAlertsWarning:
    'Some schedules have active alerts. You have to clear them to be able to unassign cap from them and to remove kit from patient. To clear alerts go to',
  patientDashboardTxt: 'Patient Dashboard',
  resetPatientStatusKitWarning:
    'Do you want to remove the kit from the patient? We recommend removing the kit only if the patient will be getting new one.',
  cancelEnrollmentWarning: 'Are you sure you want to cancel enrollment for patient {0}?',
  remindersChangeRequiredCaption: 'Reminders change required',
  remindersChangeRequired:
    'Patient has reminders defined. They will NOT be automatically translated to the newly set language. To change the reminders, please navigate to Medications page and edit each medication that has remiders set to change them. Would you like to be navigated to Medications page?',
  previous: 'Anterior',
  nextWeek: 'Semana próxima',
  downloadPatientData: 'Descargar datos del paciente',
  downloadPatientsEvents: 'Download Patients Events',
  caregiver: 'Cuidador',
  caregivers: 'Cuidadores',
  addCaregiver: 'Add Caregiver',
  editCaregiverList: 'Edit Caregiver List',
  addACaregiver: 'Agregar un cuidador',
  editCaregiver: 'Edit Caregiver',
  numberOfAdministrators: 'Número de administradores',
  addAdmin: 'Invitar Admin',
  rxcapCopyRightText: 'RXCap 2020 – Todos los derechos reservados',
  showingDataFrom: 'Mostrando datos de ',
  trend: 'Tendencia',
  missed: 'Omitido',
  miss: 'Miss',
  complied: 'Cumplido',
  skipped: 'Saltado',
  noData: 'No hay datos',
  last30days: 'Últimos 30 días',
  thisMonth: 'Este mes',
  lastMonth: 'Último mes',
  last6Months: 'Últimos 6 meses',
  thisYear: 'Este año',
  selectAll: 'Seleccionar todo',
  deselectAll: 'Deseleccionar todo',
  selectAllUnavailableForAllReadings: 'Elija "New Readings" o "Archived Readings" para seleccionar todo',
  selectedItems: 'Elementos seleccionados',
  onePatientSelected: '1 paciente seleccionado',
  xPatientsSelected: '{0} pacientes seleccionados',
  archiveUnarchive: 'Archivar/Desarchivar',
  completeMonitoring: 'Completar monitoreo',
  onePatient: '1 paciente',
  xPatients: '{0} pacientes',
  completeMonitoringDescription:
    'Las lecturas de {0} se marcarán como revisadas. Ingrese el tiempo dedicado a la revisión de cada paciente, que se agregará al historial de tareas de los pacientes.',
  completeMonitoringTimeForPatient: 'Se registrará {0} para este paciente',
  completeMonitoringTimeForEachPatient: 'El tiempo se registra para cada paciente: {0} × {1} pacientes',
  last12Months: 'Últimos 12 meses',
  last7DaysAdherence: 'Adherencia últimos 7 días',
  noDescription: 'No hay descripción',
  noDataAvailable: 'No hay datos',
  totalAdherence: 'Adherencia Total',
  weeklyTotalAdherence: 'Total | Weekly Adherence',
  totalAccuracy: 'Exactitud Total',
  accuracy: 'Exactitud',
  appOnly: 'Solo App',
  smartCap: 'SmartCap',
  pillbox: 'Pillbox',
  smartCapUsage: 'Uso de Smart Cap',
  accepted: 'Aceptado',
  accept: 'Aceptar',
  reject: 'Rechazar',
  pending: 'Pendiente',
  createOrder: 'Crear Orden',
  acceptedPendingInvites: 'Invitaciones Aceptadas/Pendientes',
  medication: 'Medicación',
  noMedicationsTaken: 'Ninguna medicación tomada',
  noMedications: 'Sin medicaciones',
  averageTimedelta: 'Delta de Tiempo promedio',
  taken: 'Tomado',
  takes: 'Toma',
  nextMed: 'Next Med',
  unscheduled: 'no programado',
  takeTypes: {
    scheduled: 'Scheduled take',
    unscheduled: 'Unscheduled take',
    missed: 'Missed take',
  },
  delta: 'delta',
  na: 'N/D',
  name: 'Nombre',
  verificationCode: 'Ingresar Código de Verificación',
  send: 'Enviar',
  sendVerificationCode: 'Enviar Código de Verificación',
  reSendVerificationCode: 'Reenviar Código de Verificación',
  sendVerificationLink: 'Enviar Enlace de Verificación',
  reSendVerificationLink: 'Reenviar Enlace de Verificación',
  total: 'Total',
  verified: 'Verificado',
  invalidType: 'Tipo no válido',
  dashboard: 'Panel',
  loading: 'Cargando',
  notificationSettings: 'Configuración de Notificaciones',
  mobilePhone: 'Teléfono Móvil',
  phoneNo: 'No. de teléfono',
  contactNo: 'No. de Contacto',
  hardwareId: 'ID de Hardware ',
  notVerified: 'No verificado',
  emailAddress: 'Dirección de Email',
  inProcess: 'En proceso...',
  saveChanges: 'Guardar Cambios',
  save: 'Guardar',
  update: 'Actualizar',
  firstName: 'Nombre',
  yourName: 'Su Nombre',
  lastName: 'Apellido',
  userName: 'Nombre de usuario',
  patient: 'Paciente',
  selectGender: 'Please select gender',
  gender: 'Género',
  genders: {
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
  },
  userNameEmail: 'Nombre de usuario o Email',
  usingSmartCap: 'Usando Smart Cap',
  studies: 'Estudios',
  patients: 'Pacientes',
  patientView: 'Vista de pacientes',
  enrollmentView: 'Vista de inscripciones',
  view: 'Vista',
  careManagementPrograms: 'Programas de gestión de atención',
  accessPrograms: 'ACCESS',
  clinicalTrials: 'Ensayos clínicos',
  enrollmentProcess: 'Proceso de inscripción / Sin programa asignado',
  enrollmentStatus: 'Estado de inscripción',
  stateSince: 'En este estado desde',
  enrollmentPeriod: 'Período de inscripción',
  ongoing: 'En curso',
  myPatients: 'My Patients',
  enrollAndMonitor: 'Enroll & Monitor',
  alerts: 'Alertas',
  patientAlertFields: {
    pressure_systolic: 'SYS',
    pressure_diastolic: 'DIA',
    forced_expiratory_volume_1s: 'FEV1',
    forced_vital_capacity: 'FVC',
    pm25: 'PM 2.5',
    prothrombin_time: 'PT',
    international_normalized_ratio: 'INR',
  },
  admin: 'Admins',
  caps: 'Tapas',
  signOut: 'Salir',
  today: 'Hoy',
  daily: 'Daily',
  monthly: 'Monthly',
  medications: 'Medicaciones',
  timeDelta: 'Time Delta',
  info: 'Información',
  personalSettings: 'Configuraciones Personales',
  settings: 'Configuraciones',
  support: 'Soporte',
  systemConfiguration: 'Config Sistema',
  superuserHealthCenter: 'Salud de Superusuario',
  superuserHealthDashboardTab: 'Panel',
  superuserHealthMessagesTab: 'Mensajes',
  superuserHealthEventsTab: 'Eventos',
  superuserHealthIssuesTab: 'Incidencias',
  superuserHealthAlertsTab: 'Alertas',
  superuserHealthComingSoon:
    'Esta sección está lista. Los requisitos detallados de esta pestaña se pueden agregar a continuación.',
  superuserHealthNoData: 'Todavía no hay datos.',
  superuserHealthLoadError: 'No se pudieron cargar los datos del monitor de salud.',
  superuserHealthMessagesTitle: 'Resumen de mensajes',
  superuserHealthMessagesSubtitle: 'Volumen de SMS, mezcla actual de estados y tendencias por organización.',
  superuserHealthIssuesTitle: 'Incidencias',
  superuserHealthSearchIssues: 'Buscar incidencias',
  superuserHealthCreateIssue: 'Crear incidencia',
  superuserHealthCreateIssueTitle: 'Crear incidencia',
  superuserHealthIssue: 'Incidencia',
  superuserHealthIssueDetailsTitle: 'Detalle de incidencia',
  superuserHealthLoadIssuesError: 'No se pudieron cargar las incidencias.',
  superuserHealthLoadIssueDetailsError: 'No se pudieron cargar los detalles de la incidencia.',
  superuserHealthLoadAssigneeRoleError: 'No se pudo cargar el rol del asignado.',
  superuserHealthLoadAssignableUsersError: 'No se pudieron cargar los usuarios asignables.',
  superuserHealthTitleAndCategoryRequired: 'El titulo y la categoria son obligatorios.',
  superuserHealthUpdateIssueError: 'No se pudo actualizar la incidencia.',
  superuserHealthAddCommentError: 'No se pudo agregar el comentario.',
  superuserHealthMarkResolved: 'Marcar como resuelta',
  superuserHealthReopenIssue: 'Reabrir',
  superuserHealthResolvedAt: 'Resuelta el',
  superuserHealthResolvedBy: 'Resuelta por',
  healthEventSourceDevice: 'Dispositivo de origen',
  healthEventPeerDevice: 'Dispositivo par',
  healthEventUserID: 'ID de usuario',
  healthEventData: 'Datos',
  healthEventDataJ: 'Datos JSON',
  healthEventFullValue: 'Ver {0} completo',
  healthEventInvalidIDs: 'Introduzca ID positivos separados por comas (máximo 9223372036854775807).',
  healthEventLoadError: 'No se pudieron cargar los detalles del evento.',
  healthEventPermissionError: 'No tiene permiso para ver los detalles del evento.',
  healthEventFailCodeFilter: 'Quitar filtro de código de error: {0}',
  superuserHealthProperties: 'Propiedades',
  superuserHealthLabels: 'Etiquetas',
  superuserHealthCustomerCase: 'Caso de cliente',
  superuserHealthAddComment: 'Agregar comentario',
  superuserHealthCommentPlaceholder: 'Escribe una nota operativa',
  superuserHealthNoComments: 'Aun no hay comentarios.',
  superuserHealthLastHour: 'Última hora',
  superuserHealthLast24Hours: 'Últimas 24 horas',
  superuserHealthPrevious24Hours: '24 horas anteriores',
  superuserHealthLast7Days: 'Últimos 7 días',
  superuserHealthPrevious7Days: '7 días anteriores',
  superuserHealthToday: 'Últimas 24 horas',
  superuserHealthYesterday: '24 horas anteriores',
  superuserHealthThisWeek: 'Últimos 7 días',
  superuserHealthLastWeek: 'Semana pasada',
  superuserHealthLastWeekSamePeriod: '7 días anteriores',
  superuserHealthSmsTodayVsLastWeek: 'SMS: últimas 24 horas vs 24 horas anteriores',
  superuserHealthSmsWeekVsLastWeek: 'SMS: últimos 7 días vs 7 días anteriores',
  superuserHealthSmsLast24HoursVsPrevious24Hours: 'SMS: últimas 24 horas vs 24 horas anteriores',
  superuserHealthSmsLast7DaysVsPrevious7Days: 'SMS: últimos 7 días vs 7 días anteriores',
  superuserHealthStatusBreakdown: 'Desglose por estado',
  superuserHealthStatusBreakdownLast24Hours: 'Desglose por estado · últimas 24 horas',
  superuserHealthFailedReasons: 'Motivos de fallo de SMS',
  superuserHealthFailedReasonsLast24Hours: 'Motivos de fallo de SMS · últimas 24 horas',
  superuserHealthSmsTypesLast24Hours: 'Principales tipos de SMS · últimas 24 horas',
  superuserHealthOrganizationsLast24Hours: 'Principales organizaciones · últimas 24 horas',
  superuserHealthSmsTypes: 'Principales tipos de SMS',
  superuserHealthOrganizations: 'Principales organizaciones',
  superuserHealthTestSms: 'SMS de prueba',
  refresh: 'Actualizar',
  admin: 'Admin',
  users: 'Usuarios',
  archetype: 'Arquetipo',
  roles: 'Roles',
  allArchetypes: 'Todos los Arquetipos',
  allOrganizations: 'Todas las Organizaciones',
  allStatuses: 'Todos los Estados',
  superuser: 'Superusuario',
  organizationManager: 'Gerente de Org',
  shipper: 'Remitente',
  doctor: 'Doctor',
  bot: 'Bot',
  accountType: 'Tipo de cuenta',
  accountTypeUser: 'Usuario',
  accountTypeServiceAccount: 'Cuenta de servicio',
  accountTypeApiKey: 'Clave de API',
  pendingRole: 'Pending Role',
  noUsersFound: 'No se encontraron usuarios',
  supportHeader: '¿Cómo podemos ayudar? (Solo apoyo técnico)',
  howToUseYourSmartCap: 'Cómo usar su smart cap',
  smartCapTitle: 'How to use your smart cap',
  emailUs: 'Email',
  emailText: `If you have a query or specific question, we'd be happy to hear from you. Our customer support team are here to help and can be reached at:`,
  supportText:
    'Si tiene una consulta o pregunta específica, con gusto la recibimos. Nuestro equipo de apoyo al cliente está aquí para ayudarle y puede encontrarlos en ',
  supportEmail: 'contact@rxcap.com',
  supportLidSyncEmail: 'support@lidsync.com',
  supportButton: 'Envíenos un email',
  phone: '+1(818) 618 6375',
  phoneLidSync: '+1(888)-618-0463',
  emailSubject: 'Asistencia Portal Web de RxCap',
  emailLidSyncSubject: 'Asistencia Portal Web de LidSync',
  donwload: 'Descargar',
  calendar: 'Calendario',
  findOutMore: 'Más información',
  cancel: 'Cancelar',
  done: 'Listo',
  confirm: 'Confirmar',
  careGiverInvalidLink: 'El enlace no es válido. Por favor generar un nuevo enlace.',
  takeSimulation: 'Realizar simulación',
  careGiverHeading: 'Actuar como Cuidador RxCap',
  careGiverSubHeading:
    'By entering your details you are accepting to receive txt message notifications from RxCap for the purposes of the CareGiver feature only…',
  invite: 'Invite',
  inviteToPortal: 'Invite to Portal',
  invitationSuccess: 'Invitation sent successfully',
  reInviteToPortal: 'Resend Portal Invitation',
  emailNeededForPortalAccess: 'Only patients with email addresses can be invited to portal',
  upload: 'Upload',
  uploading: 'Uploading',
  uploadSignedForm: 'Upload Signed Form',
  submit: 'Submit',
  close: 'Close',
  skipAndClose: 'Skip & Close',
  studyName: 'Study Name',
  daysOfWeek: 'Days of Week',
  dayOfWeek: 'Day of Week',
  dayOfMonth: 'Day of Month',
  setupCodeTasksHint: 'Required once per enrollment before monitoring codes are billed',
  description: 'Description',
  defaultEnabled: 'Default enabled',
  enabled: 'Enabled',
  disabled: 'Disabled',
  blacklisted: 'Blacklisted',
  masterConfiguration: 'Master Configuration',
  organizationConfiguration: 'Organization Configuration',
  backToHours: 'Back to Hours',
  add: 'Add',
  addPills: 'Add (Pills)',
  totalPills: 'Total (Pills)',
  back: 'Back',
  status: 'Status',
  oldStatus: 'Old Status',
  newStatus: 'New Status',
  usageState: 'Usage State',
  administrativeState: 'Administrative State',
  operationalState: 'Operational State',
  businessState: 'Business State',
  changedStatus: 'Changed Status',
  patientUserName: 'Patient Username',
  alertBySMS: 'Alert by SMS',
  alertByEmail: 'Alert by Email',
  alertByPhone: 'Alert by Phone',
  showAll: 'Show All',
  login: 'Login',
  loginTitle: 'Login to RxCap',
  loginTo: 'Login to',
  securityCode: 'Security Code',
  securityCodeIsRequired: 'Security Code is required, check your email or sms message',
  passwordChangeFailedCheckYourSecurityCode: 'Password change failed, check your security code.',
  show: 'Show',
  reset: 'Reset',
  inviteFirstAdmin: 'Invite your first administrator',
  inviteFirstPatient: 'Invite your first patient',
  inviteAnAdmin: 'Invite an Admin',
  sendInvite: 'Send Invite',
  inviteAdmin: 'Invite Admin',
  personalDetails: 'Personal Details',
  userDetails: 'User Details',
  phoneNumber: 'Phone Number',
  fillMissingPhoneNumber: 'Fill missing phone number',
  fillMissingAddress: 'Fill missing address',
  phone: 'Phone',
  company: 'Company',
  email: 'Email',
  dob: 'Fecha de nacimiento',
  monthYear: 'Mes-Año',
  selectCompletedMonth: 'Seleccione un mes finalizado.',
  age: 'Edad',
  startDate: 'Fecha Inicio',
  endDate: 'Fecha Final',
  endsAt: 'Ends at',
  regimenDetails: 'Detalles del Régimen',
  regimenStartDate: ' Fecha Inicio del Régimen',
  regimenEndDate: ' Fecha Final Régimen',
  regimenLength: 'Duración del Régimen',
  activeFor: 'Activo por',
  usesSmartCap: 'Usa Smart Cap',
  notAvailable: 'no disponible',
  adminAppPrevileges: 'Privilegios Admin del App',
  adminWritePrevileges: 'Permiso Admin de edición',
  adminTimerRights: 'Triggers Timer',
  adminAccess: 'Acceso del admin',
  manageMultipleStudiesText: 'Puede crear y manejar varios estudios a la misma vez.',
  invitePatientMessage: 'Puede invitar pacientes a usar RXCap para monitorear su adhesion a la medicación.',
  medicationAdherenceMessage:
    'Los datos de adhesion a la Medicación se agregan automáticamente en su Portal del Proveedor.',
  showingDataFromAllPatients: 'Mostrando los datos de todos sus pacientes y estudios',
  downloadApp: 'Descargar el App',
  createYourFirstStudy_p1: 'Puede',
  createYourFirstStudy_p2:
    ', ver o editar cualquiera de sus estudios en la pestaña estudios. Con acceso rápido a las cifras de adhesión y tendencias de los pacientes. O profundice más para ver los datos de los pacientes y registros de tiempo de la medicación.',
  addAPatient_p1: 'Puede ',
  addAPatient_p2:
    ', ver y manejar los pacientes desde la pestaña pacientes. Cuando haya creado un ‘estudio’, podrá asignar pacientes directamente a un estudio cuando los agregue al portal.',
  addAPatient_2_p1: 'Agregó un estudió, pero no asignó ningun ',
  addAPatient_2_p2: '. Puede ',
  addAPatient_2_p3:
    ' y manejar todos sus pacientes desde la pestaña pacientes. Este panel se actualizará con datos analíticos y gráficos cuando se haya recolectado suficientes datos de los pacientes asignados.',
  inviteAnAdmin_p1: 'En la pestaña admin puede ',
  inviteAnAdmin_p2: ' y manejar privilegios de administración, y derechos de acceso para médicos e investigadores.',
  dashboardNoDataYet: 'Las funcionalidades del panel se desbloquearán cuando haya más datos disponibles',
  medicationsMap: ' Mapa de Medicaciones ',
  signIn: 'Ingresar',
  signUp: 'Registrarse',
  patientAddedSuccessfully: 'Paciente agregado correctamente',
  patientSavedSuccessfully: ' Paciente guardado correctamente',
  welcomeToRxCap: 'Bienvenido a RxCap',
  welcomeToApp: 'Welcome al Portal para Proveedores de RXCap ',
  welcome: ' Bienvenido',
  loadingFhirSessions: 'Cargando  sesión de FHIR...',
  password: 'Contraseña',
  confirmPassword: 'Confirmar Contraseña',
  passwordChangeFailedCheckYourSercuityCode: 'Password change failed, check your security code.',
  forgotPassword: '¿Olvidó su contraseña?',
  createAccount: 'Crear Cuenta',
  createRxCapAccount: 'Crear Cuenta RXCap',
  create: 'Crear',
  addAPatient: 'Agregar un Paciente',
  appTitle: 'La Plataforma de RXCap ',
  loginToRxCap: 'Ingresar a RX-Cap',
  loginToLidSync: 'Ingresar a Lid Sync',
  loginTo: 'Ingresar a ',
  lidSync: 'Lid Sync',
  setPasswordToRxCap: 'Configurar contraseña',
  invitePatient: 'Invitar Paciente',
  addMedication: 'Add Medication',
  editMedication: 'Edit Medication',
  summary: 'Resumen',
  youAreAllDone: "You're All Done",
  youAreAllDoneName: 'Add next patient(s)/medication',
  youFinishedSetup: "You've finished the set up for {0}",
  finishedRpmSetup: "You've finished the set up for your organization",
  mobileVersionNotSupported: 'Versión móvil no tiene soporte',
  editProfile: 'Editar Perfil',
  editPatientInfo: 'Editar Info del Paciente ',
  deletePatient: 'Eliminar Paciente',
  changePassword: 'Cambiar la Contraseña',
  adherence: 'Adherencia',
  adherenceForPeriod: 'Adherence for period',
  accuracy: 'Exactitud',
  study: 'Estudio',
  search: 'Búsqueda',
  searchLog: 'Search Log',
  leave: 'Salir',
  patientCount: 'Cantidad de Pacientes',
  createStudy: 'Crear un Estudio',
  editStudy: 'Editar un Estudio',
  country: 'País',
  introduction: 'Introducción',
  editPersonalSettings: 'Editar su configuración personal',
  dateOfBirth: 'Fecha de nacimiento',
  city: 'Ciudad',
  mobileNumber: 'Número de Móvil',
  confirmPassword: 'Confirmar Contraseña',
  confirmDelete: 'Confirmar Borrar',
  confirmAssignment: 'Confirm Assignment',
  newPassword: 'Nueva Contraseña',
  showPassword: 'Mostrar Contraseña',
  hidePassword: 'Ocultar Contraseña',
  oldPassword: 'Contraseña Anterior',
  resetPassword: 'Restablecer Contraseña',
  careProviderOrganization: 'Care Provider Organization',
  reassignCareProvider: 'Reassign Care Provider',
  reassignCareProviderSuccess: 'Care Provider reassigned successfully',
  removeCareProviderWarning: 'Are you sure you want to remove care provider {0}?',
  careProvidersHeader: 'Care Providers (users available to this organization that can be assigned to patient enrollment)',
  careProviderAssignmentWarning: 'Care provider organization is assigned to active enrollments',
  careProviderAssignmentWarningDetails:
    'Remove or update these patient enrollments before deleting this care provider organization or click "Unassign and Remove" to have them unassigned.',
  inactiveCareProviderWarning: 'Inactive or deleted care provider organization',
  inactiveCareProviderWarningDetails:
    'This care provider organization is inactive or deleted and can no longer be used for new assignments.',
  careProviders: 'Care Providers',
  unassignAndRemove: 'Unassign and Remove',
  byEmail: 'Por Email',
  bySMS: 'Por SMS',
  next: 'Siguiente',
  later: 'Más tarde',
  watchNow: 'Mirar Ahora',
  allDay: 'Todo el día',
  yourAllDone: 'Listo!',
  videoInst:
    'Genial, su dispositivo está configurado y listo para usar. Antes de comenzar a usarlo, recomendamos que mire un tutorial rápido sobre cómo usarlo.',
  esiDoctorInviteText:
    'Está invitado a ser admin en RxCap. Para completar el proceso de verificación, ingrese su número de móvil, y luego el código de verificación.',
  esiDoctorCodeText:
    'Le enviamos un código de verificación de 6 dígitos. Ingréselo abajo para verificar su cuenta. El código vencerá en: ',
  esiDoctorAlmostDone: 'Casi listo; use las credenciales que se le enviaron por email para ingresar a su cuenta.',
  resetByEmail: 'Restablecer por Email',
  resetBySMS: 'Restablecer por SMS',
  resend: 'Reenviar',
  withYourAccount: 'con su cuenta',
  weSentYouEmail: 'Le enviamos un Email',
  ok: 'Ok',
  enterNewPasswordMessage: 'Ingrese la nueva contraseña que desea usar para',
  weSentVerificationCode: ' Le enviamos un código de verificación',
  yourRxCapAccountBelow: 'su cuenta de RXCap abajo',
  congratulations: 'Felicitaciones',
  enterBelowToContinue: 'Ingréselo abajo para continuar',
  thisOptionIsrequired: 'Esta opción es obligatoria',
  notFound: 'No se encontró',
  hi: 'Hola',
  lblResetPassword: 'Ingrese la dirección de email asociada con',
  lblResetPasswordRx: 'la siguiente cuenta de RX-CAP:',
  enterEmailAddressAssociated: 'Ingrese el email asociado',
  enterPhoneNumberAssociated: 'Ingrese el número de móvil asociado con su cuenta.',
  enterPhoneNumber2nd: ' Si tiene problemas, contacte:',
  resetPasswordMessage: ' Si olvidó su contraseña, elija uno de estos métodos para restablecerla:',
  appSubtitle:
    'Monitoree el uso de su medicación, o si es médico, obtenga información valiosa sobre la adherencia de su paciente a la medicación con nuestra app móvil y la solución SmartCap.',
  requestDeleteText: 'Usted solicitó borrar su cuenta RXCap. ',
  requestConfirmText:
    'Confirme que comprende que esta operación es <span class="color-brand-red"><strong>irreversible</strong></span> ',
  requestToContinue: 'y presione el botón para continuar.',
  iAmAwareText: 'Comprendo que si continúo ',
  irreversiblyText: 'se borrarán de forma irreversible todos los datos',
  aboutMeText: 'almacenados sobre mí en RXCap.',
  deleteBtn: 'Borrar la cuenta',
  verificationCompleteText: 'Verificación completada ',
  reviewThePatientText:
    'Revise la información del perfil del paciente, luego presione el botón siguiente para revisar sus medicaciones actuales.',
  nextBtnText: 'Siguiente',
  weAreSorryText:
    'Lo lamentamos, pero el punto final de su variable clínica FHIR  no parece coincidir con el punto final de la orden de medicamento.Contacte a su administrator EHR para obtener más información.',
  reviewYourPatient: 'Revise la medicación de su paciente para seleccionar las que quiere asociar con su cuenta RXCap.',
  sendInviteText: 'Enviar Invitación',
  patientNameText: 'Nombre del Paciente',
  inviteBySMSText: 'Invitar por SMS',
  toFinishTheSetupText:
    'Para terminar el proceso de configuración, agregue el número de teléfono del paciente y haga clic',
  invitationSentText: 'Invitación enviada',
  adminInviteSent: 'Invitación de Admin enviada',
  youHaveBeenInvitedText: 'Su médico le invita a usar RXCap para cumplir',
  trackOfYourMedicineText: ' el regimen de su medicación. Ingrese la información solicitada por',
  toVerifyYourAccountText: ' para verificar su cuenta.',
  verifyAccountText: 'Verifique su cuenta',
  yourDSAccountActivatedText:
    'Su cuenta RXCap ya está activa; puede ingresar en el app de RXCap. Busque en la casilla de correos de su teléfono el enlace de Descarga para bajar el app en su teléfono iPhone o Android',
  yourDSAccActivatedText: 'Su cuenta RXCap ya está activa.',
  checkYourInbox: 'Busque en su casilla de correos o haga clic en el link correspondiente abajo para descargar el app.',
  loadingFHIRSession: 'Cargando sesión de FHIR...',
  enterPhoneNumberThatCanBeUsedToVerifyYourIdentity:
    'Ingrese un número de teléfono que se pueda usar para verificar su identidad con un mensaje de texto.',
  noSMSReminderText: '¿Sin recordatorios por SMS?',
  weHaveSentCodeText: 'Enviamos un código de verificación temporal a:',
  enterTheCodeText: '. Ingrese el código a continuación para verificar el número.',
  didnText: '¿No',
  tReceiveACode: ' recibió el código?',
  digitVerificationCode: 'Código de verificación de 6 dígitos',
  yourText: 'Su ',
  verifiedText: ' se ha verificado correctamente.',
  editNotifcationSettingsText: 'Editar configuración de notificaciónes',
  chagneSettingForText: 'Cambiar configuración para',
  dsUsesSmartText:
    'RXCap usa notificaciones inteligentes que irán intensificandose para enviarle recordatorios de medicación, via email, mensajes texto SMS, o llamadas telefónicas. Podremos enviarle también información sobre actualizaciones importantes.',
  selectWhichNotificationText: 'Seleccionar las notificaciones que quiere recibir de RXCap',
  emailsText: 'Emails',
  smsText: 'SMS',
  voiceText: 'Voz',
  takenAt: 'Tomado A',
  dailyDataText: 'Los datos diarios comienzan a las 6 am',
  clickToTakeText: '¡Haz clic para tomarlo ahora!',
  dateText: 'Fecha',
  timeDueText: 'Hora a la que se debe tomar',
  medicationNameText: 'Nombre de la Medicación',
  medicationSearchUnavailable:
    'La búsqueda de medicamentos no está disponible temporalmente. Inténtelo de nuevo más tarde o agregue el medicamento manualmente.',
  frequencyText: 'Frecuencia',
  areYouSure: '¿Está seguro?',
  areYouSureText: '¿Seguro de que quiere borrar ',
  addMedicationText: 'Agregar Medicación',
  dosageText: 'Dosis - ',
  daysText: 'Días - ',
  timesText: 'Horas -',
  dosage: 'Dosis',
  times: 'Horas',
  delete: 'Borrar',
  edit: 'Editar',
  launch: 'Launch',
  unsuspend: 'Unsuspend',
  createYourFirstStudy: 'Crear su primer estudio',
  whenToTakeMedicine: '¿Cuándo tomar el medicamento?',
  frequency: 'Frecuencia',
  doseFrequency: 'Frecuencia de dosificación',
  asNeeded: 'Cuando se necesite',
  everyDay: 'Todos los días',
  everyXDays: 'Every {0} Days',
  specificDays: 'Días específicos',
  interval: 'Intervalo',
  howLongToTakeMedicine: '¿Cuánto tiempo tomar el medicamento?',
  days: 'Días',
  weeks: 'Semanas',
  daysOfweek: 'Días de la semana',
  afterHowManyDays: '¿Después de cuántos días?',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  timeForTakingMedicine: 'Hora de tomar el medicamento',
  administrationWindow: 'Ventana administrativa',
  medicineName: 'Nombre del medicamento',
  startsAlongWithEnrollment: 'Starts along with enrollment',
  dose: 'Dosis',
  attach: 'Adjuntar',
  review: 'Revisar',
  capName: 'Nombre de la tapa',
  capId: 'ID de la tapa',
  hubId: 'ID del Hub',
  devicesPlural: {
    hub: 'Hubs',
    ble: 'BLE Caps',
    lte: 'LTE Caps',
    lsc: 'LSC Caps',
  },
  devicesEnum: {
    Kit: 'Kit',
    Datahub: 'Datahub',
    'Bluetooth Cap': 'Bluetooth Cap',
    'LTE Pillbox': 'LTE Pillbox',
    'LTE Smart Cap': 'LTE Smart Cap',
    'Injectable Medication Tracker': 'Injectable Medication Tracker',
    'MDP Dispenser': 'MDP Dispenser',
    'LTE Medication Organizer': 'LTE Medication Organizer',
    'Blood Pressure Monitor': 'Blood Pressure Monitor',
    'Weighing Machine': 'Weighing Machine',
    'Wrist Band': 'Wrist Band',
    Glucometer: 'Glucometer',
    Thermometer: 'Thermometer',
    Inhaler: 'Inhaler',
    Spirometer: 'Spirometer',
    'Pulse Oximeter': 'Pulse Oximeter',
    'Air Quality Monitor': 'Air Quality Monitor',
    'Hailie Inhaler': 'Hailie Inhaler',
    'PT/INR Monitor': 'PT/INR Monitor',
  },
  devicePluralsEnum: {
    Kit: 'Kits',
    Datahub: 'Datahubs',
    'Bluetooth Cap': 'Bluetooth Caps',
    'LTE Pillbox': 'LTE Pillboxes',
    'LTE Smart Cap': 'LTE Smart Caps',
    'Injectable Medication Tracker': 'Injectable Medication Trackers',
    'MDP Dispenser': 'MDP Dispensers',
    'LTE Medication Organizer': 'LTE Medication Organizers',
    'Blood Pressure Monitor': 'Blood Pressure Monitors',
    'Weighing Machine': 'Weighing Machines',
    'Wrist Band': 'Wrist Bands',
    Glucometer: 'Glucometers',
    Thermometer: 'Thermometers',
    Inhaler: 'Inhalers',
    Spirometer: 'Spirometers',
    'Pulse Oximeter': 'Pulse Oximeters',
    'Air Quality Monitor': 'Air Quality Monitors',
    'Hailie Inhaler': 'Hailie Inhalers',
    'PT/INR Monitor': 'PT/INR Monitors',
  },
  id: 'ID',
  hubName: 'Nombre del Hub',
  or: 'O',
  capsAdmin: 'Administrador de las tapas',
  searchNewCap: 'Buscar una tapa nueva',
  addCapsAdmin: 'Agregar un administrador de las tapas',
  addDoctor: 'Agregar médico',
  doctors: 'Médicos',
  serviceAccounts: 'Cuentas de servicio',
  attachCapsToAdmin: 'Adjuntar tapas al Administrador',
  attachCap: 'Adjuntar tapa',
  attachCap: 'Adjuntar tapa',
  attachDevice: 'Adjuntar tapa',
  devicesToAttach: 'Devices to attach',
  SendDeviceSecurityCode: 'Enviar código de seguridad del dispositivo',
  AddEditHardware: 'Ingresar la ID del dispositivo',
  enter6DigitCode: 'Ingresar el código de 6 caracteres o el ID de hardware impreso en la tapa',
  eventTimestamp: 'Fecha del evento',
  lastEventTimestamp: 'Fecha del ultimo evento',
  eventTime: 'Hora del evento',
  eventDate: 'Fecha del evento',
  eventType: 'Tipo de evento',
  physioParams: 'Parámetros fisiológicos',
  max: 'Max',
  min: 'Min',
  condition: 'Condición',
  conditions: 'Conditions',
  attachCapToAdmin: 'Adjuntar tapa al Admin',
  locations: 'Lugares',
  location: 'Lugar',
  state: 'Estado',
  street: 'Street',
  zipCode: 'Zip Code',
  organizationName: 'Nombre de la organización',
  devices: 'Dispositivos',
  deletedDevices: 'Deleted Devices',
  temperature: 'Temperatura',
  charge: `Cargo', or ‘Cargar`,
  action: 'Acción',
  eventList: 'Lista de eventos',
  version: 'Versión ',
  timezone: 'Zona horaria',
  selectStartAdministrativeWindow: 'Seleccionar la ventana administrativa de inicio',
  selectEndAdministrativeWindow: 'Seleccionar la ventana administrativa de fin',
  idleSessionMessage: 'Su sesión está por vencer debido a inactividad.',
  extend: 'Extender',
  recoverPassword: 'Recuperar la contraseña',
  showingXOf: 'Showing {0} of {1} {2}',
  showingX: 'Showing {0} {1}',
  showingXHubs: {
    showing: 'Mostrando',
    of: 'de',
    hubs: 'Hubs',
  },
  showingXKits: 'Showing {0} of {1} Kits',
  showingXDevices: 'Mostrando {0} de {1} Dispositivos',
  showingXPatients: 'Mostrando {0} de {1} Patients',
  showingXCohorts: 'Showing {0} of {1} Cohorts',
  devicesInThisArea: 'Dispositivos en el área',
  activeHubs: 'Hubs activos',
  pendingHubs: 'Hubs pendientes',
  hubs: 'Hubs',
  scales: 'Balanza',
  bpMonitors: 'Monitores BP',
  bp: 'BP',
  pendingCalls: 'Pending Calls',
  pendingMessages: 'Pending Messages',
  enrolledPatients: 'Enrolled Patients',
  pendingEnrollment: 'Pending Enrollment',
  totalKits: 'Total Kits',
  inLast: 'En el/los ultimo/s',
  noReadings: 'No hay lecturas',
  showingWait: 'Mostrando...',
  deviceReadings: 'Lecturas del dispositivo',
  yourKits: 'Tus equipos',
  kits: 'Equipos',
  widgets: {
    yourKitsChart: 'Gráfico de tus equipos',
    deviceReadingsChart: 'Gráfico de lecturas de tu/s dispositivo/s',
    numberOfDevices: 'Cantidad de dispositivos',
    numberOf: 'Number of {0} ({1})',
    real_time: 'real-time',
    daily: 'daily',
    monthly: 'monthly',
    locationsOfYourKits: 'Ubicaciones de tus equipos',
    hubsWithoutReadings: 'Hubs sin lecturas',
    monthlyOperatingRate: 'Monthly Operating Rate',
    patientActions: 'Patient Actions',
    unreadMessages: 'Unread Messages',
    patientsEnrollment: 'Patients Enrollment',
    totalKits: 'Total Kits',
    patientsWithNoReadings: 'Activated Patients with no readings',
    patientsWithNoReadingsInTheLastDays: 'Activated Patients with no readings in the last {0} days',
    patientsWithNewNotes: 'Patients with new notes',
    enrollmentHistory: 'Enrollment History',
    patientsToCall: 'Patients to Call',
    details: 'Details',
    people: 'People',
    daysComplied: 'Days Complied',
    daysLeftInCycle: '{0} days left in cycle',
    devicesActivatedToday: '{0} Activated Today',
    patientStatus: 'Patient Status',
    programDistribution: 'Program Distribution',
    patientsWithMandatoryTasksMissing: 'Pacientes sin tareas de facturación requeridas',
    ordersPendingReview: 'Orders Pending Review',
    recentDeliveries: 'Recent Deliveries',
    recentDeliveriesTooltip: 'In the last 30 days',
  },
  widgetsTooltips: {
    active_number_real_time: 'Number of {0} which sent at least one measurement in the last 24 hours',
    new_number_real_time: 'Number of {0} that have never sent a reading since they were assigned to the organization',
    offline_number_real_time: "Number of {0} which didn't connect to the network in the last 7 days",
    online_number_real_time: 'Number of {0} connected to the network in the last 7 days',
    total_number_real_time: 'Number of all {0} assigned to the organization',
    activated_number_real_time: 'Number of {0} activated today',
    active_number_daily: 'Number of {0} which sent at least one measurement yesterday',
    new_number_daily:
      'Number of {0} that have never sent a reading since they were assigned to the organization as of yesterday',
    offline_number_daily: "Number of {0} which didn't connect to the network yesterday",
    online_number_daily: 'Number of {0} connected to the network yesterday',
    total_number_daily: 'Number of all {0} assigned to the organization as of yesterday',
    activated_number_daily: 'Number of {0} activated yesterday',
    active_number_monthly: 'Number of {0} which sent at least one measurement in the previous month',
    new_number_monthly:
      'Number of {0} that have never sent a reading since they were assigned to the organization as of previous month',
    offline_number_monthly: "Number of {0} which didn't connect to the network in the previous month",
    online_number_monthly: 'Number of {0} connected to the network in the previous month',
    total_number_monthly: 'Number of all {0} assigned to the organization as of previous month',
    activated_number_monthly: 'Number of {0} activated in the previous month',
    monthlyOperatingRate:
      'Average of connected rate (Days having a connection at least once / eligible days in the previous month) of all activated hubs',
    activated_number_24h: 'Number of {0} activated in the last 24 hours',
    numberOfDaysComplied: 'Number of days complied since {0} (for code {1})',
    inTheLastXDays: 'In the last {0} days',
  },
  editDashboardTooltip: 'Edit dashboard (remove, rearrange, resize widgets)',
  errors: {
    requiredStudyNameAndDescription: 'Su estudio requiere un nombre y una descripción',
    longStudyName:
      'Los nombres largos de los estudios pueden no mostrarse completos, dependiendo de la resolución de pantalla en la que se vea.',
    invalidCapId: 'Id de tapa inválida',
    invalidDeviceId: 'Invalid Device id',
    enterAnyOne: 'Ingresar la id de cualquier tapa',
    endTime: 'Hora final debe ser mayor que la hora de inicio',
    timeInTheFuture: 'Start time and end time should not be a future date',
    timeBeforeEnrollment: 'La hora de la tarea debe estar dentro del período de inscripción (comienza el {0})',
    taskDurationMinutes: 'Introduce un número entero de minutos mayor o igual a 0',
    taskDurationSeconds: 'Introduce un número entero de segundos entre 0 y 59',
    taskDurationRequired: 'La duración de la tarea debe ser de al menos 1 segundo',
    taskDurationInFuture: 'La hora de inicio más la duración no puede estar en el futuro',
    taskDurationTooLong: 'La duración de la tarea no puede superar las 24 horas',
    dateInTheFuture: 'Date should not be a future date',
    dateInThePast: 'Date should be a future date',
    emptyOrgId: 'Seleccionar la organización',
    emptyCapId: 'Se debe ingresar un id de tapa válido',
    emptyDeviceId: 'Valid device id is required',
    emptyMedicineName: 'Se debe ingresar el nombre del medicamento',
    emptyHowLongToTakeMedicine: 'Se debe ingresar la cantidad de días',
    emptyHowLongToTakeMedicineWeek: 'Se debe ingresar la cantidad de semanas',
    validHowLongToTakeMedicine: 'Ingresar una cantidad válida de días/semanas',
    validHowLongToTakeMedicineDays: 'Ingresar una cantidad válida de días (menos de 999)',
    validHowLongToTakeMedicineWeeks: 'Ingresar una cantidad válida de semanas (menos de 999)',
    scheduleTypeRequired: 'Seleccione cuándo tomar el medicamento',
    invalidDays: 'Ingresar días válidos',
    duplicateTimeForTake: 'La hora de tomar el medicamento está duplicada',
    administrativeWindowRequiredForMultipleTakes: 'Ingresar la ventana administrativa para tomar el medicamento',
    timeBetweenMedicineTooShort: 'El tiempo entre medicamentos es muy corto',
    emptyValidHowManydays: 'Ingresar una cantidad válida de días',
    emptyTakenTime: 'Ingresar la hora para tomar el medicamento',
    emptyDaysOfWeek: 'Seleccionar los días de la semana',
    connectionError: 'Revise su conexión a internet e intente nuevamente',
    internalError: 'Algo salió mal. Intente nuevamente',
    unknownError: 'Error desconocido. Intente nuevamente',
    invalidEmail: 'Ingrese una dirección de email válida',
    emptyEmailAddress: 'Ingresar dirección de email',
    emptyNickName: 'Ingresar el sobrenombre',
    emptyFirstName: 'Ingresar el nombre',
    emptyOrgName: 'Ingresar el nombre de la organización',
    emptyIsRequired: 'Ingresar',
    emptyOldPassword: 'Ingresar la contraseña anterior',
    emptyConfirmPassword: 'Confirmar la contraseña',
    emptyNewPassword: 'Ingresar la nueva contraseña',
    passwordsDontMatch: 'Las contraseñas no coinciden',
    emptyLastName: 'Ingresar el apellido',
    emptyCode: 'Ingresar el código',
    emptyPhoneNumber: 'Ingresar el número de teléfono',
    emptyName: 'Ingresar el nombre',
    emptyDosage: 'Ingresar la dosis.',
    emptyPatient: 'Ingresar el paciente.',
    selectOneDay: 'Seleccionar al menos un día.',
    addMedicationTime: 'Agregar al menos un horario de medicación.',
    invalidPhoneNumber: 'El número de teléfono no es válido',
    passwordNotMatched: 'Error en el nombre de usuario o la contraseña',
    pleaseTryAgain: 'Intente nuevamente.',
    invalidDOB: 'Ingrese una fecha de nacimiento válida.',
    enterValidText: 'Ingresar válido',
    invalidPassword:
      'Su contraseña debe tener al menos 8 caracteres de largo e incluir 1 número, 1 símbolo (~!*^@#$%&), 1 mayúscula y 1 minúscula.',
    invalidActivationCode: 'El código de activación no es válido.',
    noPhoneNoEmail: 'Debe ingresar su email o número de teléfono',
    phone: {
      notValid: 'El teléfono no es válido',
      invalidCountryCode: 'El código de país no es válido',
      notANumber: 'No es un número',
      tooLong: 'El número es demasiado largo',
      tooShort: ' El número es demasiado corto',
    },
    unrecognisedNumber: 'No se reconoce el número',
    unrecognisedNumberText:
      'El número de teléfono que ingresó no coincide con el que tenemos para usted en nuestro sistema.',
    unrecognisedNumberEsiPatientText: [
      'Vuelva a ingresar el número de teléfono o llámenos para obtener asistencia. ',
      <a href="mailto:support@lidsync.com">support@lidsync.com</a>,
      ' or ',
      <a href="tel:+1 888-618-0463">+1 888-618-0463</a>,
    ],
    invalidCode: 'Código inválido',
    invalidCodeText:
      'El código que ingresó no es válido, intente nuevamente, o presione reenviar para recibir un código nuevo.',
    invalidCodeEsiPatientText: [
      'El código que ingresó no es válido, intente nuevamente o pida ayuda en ',
      <a href="mailto:support@lidsync.com">support@lidsync.com</a>,
      ' or ',
      <a href="tel:+1 888-618-0463">+1 888-618-0463</a>,
    ],
    invalidName: 'Ingresó un nombre inválido',
    invalidFirstName: 'Ingresó un nombre inválido',
    invalidLastName: '‘Ingresó un apellido inválido',
    invalidOrgName: 'Ingresó un nombre de organización inválido',
    nothingToChange: 'There is nothing to change',
    deviceIdError: 'Device id shall be shorter than 100 characters',
    settingLimitsError: 'Setting limits error',
    maxValueExceeded: 'Maximum allowed value is {0}',
    startDateCantBeInThePast: 'Start date can not be in the past',
    endDateMustBeAfterStartDate: 'End date must be after start date',
    endDateMustBeTomorrow: 'End date must be tomorrow or later',
    endDateMustBeBeforeEnrollmentEndDate: 'End date must be before enrollment end date',
    enrollmentEndMustBeAfterenrollmentStart: 'Enrollment end date must be after enrollment start date',
    duplicateThreshold: 'Threshold should be unique',
    somethingWentWrong: 'Something went wrong. Please try reloading the page. If the problem persists, contact support.',
    nothingToUpdate: 'There is nothing to update',
  },
  warnigs: {
    cantBeUndone: 'Cuidado: esta acción no puede deshacerse.',
    deleteCaregiver: '¿Seguro de que quiere borrar el cuidador',
    adminAppPrevilegesWarning: '¿Seguro de que quiere cambiar los privilegios de Admin del App para este médico?',
    adminDelete: 'Esta acción no puede deshacerse. ¿Está seguro de que quiere borrar al siguiente administrador?',
    adminResetPassword: '¿Está seguro de que quiere restablecer la contraseña para el siguiente usuario?:',
    resendInvite: 'Are you sure you want to resend the invitation to the following user:',
    inviteFirstAdminWarning: ' Para invitar a su primer administrador ingrese la dirección de email.',
    inviteFirstPatientWarning: ' Para invitar a su primer paciente ingrese la dirección de email.',
    longStudyName:
      'Los nombres largos de los estudios pueden no mostrarse completos, dependiendo de la resolución de pantalla en que la que se vea.',
    deletePatientWarning:
      'When patient is deleted, all their Medication schedules and notifications will be stopped and all active alerts will be cleared.',
  },
  success: {
    deleteAccountSuccess: 'La cuenta se ha borrado correctamente.',
    dataSavedSuccessfully: 'Los datos se han guardado correctamente.',
    passwordResetSuccess:
      'Su contraseña de RXCap se ha restablecido, presione ingresar a continuación para acceder a su cuenta con sus nuevas credenciales',
    invitationConfirmedSuccessfully: 'Su invitación se ha confirmado con éxito.',
    medicationSaved: 'Medication saved successfully',
  },
  placeholder: {
    phoneNumber: 'Ingresar número de teléfono',
    emailAddress: 'Ingresar dirección de email',
    medicationName: 'Ingresar nombre de la medicación',
    dosageName: 'Ingresar dosis aquí',
    newTimeZone: 'Agregar nueva hora',
    userName: 'Nombre de usuario',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    code: 'Código',
    cgPhoneNumber: 'Número de teléfono',
    notesArea: 'Notas',
  },
  battery: {
    level: 'Nivel de batería',
    battery: 'Batería',
    high: 'Bueno',
    medium: 'Medio',
    low: 'Bajo',
    noData: 'No disponible',
  },
  charging: {
    charging: 'Cargando',
    notCharging: 'No está cargando',
    fullUsbConnected: 'Carga completa — USB conectado',
    lastBatteryLevel: 'Último nivel de batería: {0}% ({1})',
    lastChargingStatus: 'Último estado de carga: {0} ({1})',
    chargingStarted: 'Carga iniciada',
    chargingFinished: 'Carga finalizada',
    chargingOngoing: 'Carga en curso',
    beforeCharging: 'Antes de cargar: {0}% · {1} V',
    afterCharging: 'Después de cargar: {0}% · {1} V',
  },
  esiPatientStatus: {
    capInUse: 'La tapa está en uso',
    pending: 'Pendiente',
    shipping: 'En proceso de envío',
    inProgress: 'En progreso',
    ready: 'Listo',
    active: 'Activo',
  },
  patientDashboard: {
    upcomingReminders: 'Próximos recordatorios',
    activeMedications: 'Medicaciones activas',
    stockManagement: 'Pastillas disponibles',
    seeAll: 'Ver todo',
    seeDetails: 'Ver detalles',
    calendar: 'Calendario',
    viewHistory: 'Ver historial',
    lastWeek: 'Semana pasada',
    lastMonth: 'Mes pasado',
    allMeds: 'Todos los medicamentos',
    all: 'Todo',
    allOrg: 'Todas las organizaciones',
    noOrg: 'Ninguna organización',
    selectOrg: 'Seleccionar organización',
    doses: 'Pastillas',
    dose: 'Pastilla',
  },
  esiPatientInfo: {
    street: 'Calle',
    appartment: 'Apartmento/Suite',
    zip: 'ZIP',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    schedule: 'Horario',
    device: 'Dispositivo',
    time: 'Hora',
    activeFrom: 'Activo desde',
  },
  patient_medications: {
    noInsuranceEntered: 'Este paciente no tiene ningún seguro registrado. Agréguelo en la sección Seguro del paciente y luego selecciónelo aquí.',
    medication: 'Medicamento',
    activeMedications: ' Medicamentos activos',
    stockDoses: 'Stock (dosis)',
    active: 'Activo',
    inActive: 'Inactivo',
    schedule: 'Horario',
    name: 'Nombre',
    frequency: 'Frecuencia',
    timesPerDay: 'veces por día',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    createdOn: 'Creado el',
    editedOn: 'Editado el',
    lastTaken: 'última vez Tomado',
    nextReminder: 'Próximo recordatorio',
    stock: 'Stock',
    numberOfPill: 'Cantidad de pastillas',
    dosesInStock: 'Dosis disponibles',
    pillsInHand: 'Pastillas disponibles',
    tooMayPillsWaring: 'Se agregaron demasiadas pastillas. Se redujo la cantidad de pastillas a ',
    willLastFor: 'Alcanzan para ',
    expiresOn: 'Expira el',
    edit: 'Editar',
    hardwareId: 'ID de hardware',
    device: 'Dispositivo',
    battery: 'Batería',
    activationDate: 'Fecha de activación',
    learnMore: 'Más información',
    refill: 'Reabastecer',
    fillDate: 'Fill Date',
    rxNumber: 'RX Number',
    sig: 'SIG',
    medicationNotes: 'Notas del medicamento',
    patientMedication: 'Medicamento del paciente',
    noPatientMedication: 'Ninguno',
    otherMedications: 'Otros medicamentos',
    status: 'Estado',
    statusScheduled: 'Programado',
    statusNotScheduled: 'Sin programar',
    statusNotInMedicationList: 'No está en la lista de medicamentos',
    addSchedule: 'Agregar horario',
    editSchedule: 'Editar horario',
    removeSchedule: 'Eliminar horario',
    attachCap: 'Asignar tapa',
    detachCap: 'Desasignar tapa',
    addScheduleTitle: 'Agregar horario',
    editScheduleTitle: 'Editar horario',
    prescriber: 'Prescriptor',
    editInMedicalHistory: 'Editar en el historial médico',
    removeFromMedicalHistory: 'Eliminar del historial médico',
    removeFromMedicalHistoryWarning: '¿Está seguro de que desea eliminar {0} de la lista de medicamentos del paciente?',
    removeFromMedicalHistoryScheduleKept: 'Su horario se mantiene y aparecerá como no incluido en la lista de medicamentos.',
    removedFromMedicalHistory: 'Medicamento eliminado del historial médico',
    selectPatientMedication: 'Seleccione un medicamento de la lista del paciente',
    noPatientMedications: 'La lista de medicamentos del paciente está vacía. Primero agregue el medicamento a la lista del paciente (Add Medication).',
    noMedicationsToSchedule: 'Todos los medicamentos de la lista del paciente ya tienen un horario. Primero agregue el medicamento a la lista del paciente (Add Medication).',
    duplicateMedication: 'el paciente ya tiene un medicamento con este nombre y NDC',
    ndcChecking: 'verificando el NDC',
    ndcNotFound: 'NDC no encontrado: déjelo en blanco para medicamentos sin NDC (p. ej., ensayos clínicos) e ingrese el código en Notas',
    ndcCheckUnavailable: 'No se pudo verificar el NDC en este momento. Asegúrese de que el nombre del medicamento coincida con el NDC.',
    selectNdcMedication: 'Seleccione el medicamento para este NDC',
    time: 'Hora',
    times: 'Time(s)',
    am: 'AM',
    pm: 'PM',
    addPills: 'Agregar (Pastillas)',
    totalPills: 'Total (Pastillas)',
    zero: '0',
    doseRemaining: 'pastillas restantes',
    thisWillLastFor: 'Esto alcanzará hasta el',
    downloadFullMedlist: 'Descargar lista completa de medicamentos',
    downloadFilteredMedList: 'Descargar lista filtrada de medicamentos',
    downloadProgramAnalytics: 'Download Program Analytics',
    last2Months: 'Últimos 2 meses',
    last6Months: 'Last 6 Months',
    lastWeek: 'Semana pasada',
    lastMonth: 'Mes pasado',
    assignedCap: 'Assigned cap',
    reminders: {
      early: 'Early Reminder',
      on_time: 'On-Time Reminder',
      late: 'Late Reminder',
      missed_doses: 'Missed Doses Reminder',
      first_take: 'First Take Achievement',
      streak_achievement: 'Streak Achievement',
      back_on_track: 'Back on Track',
      dose_confirmed: 'Dose Confirmed',
      first_dose_reminder: 'First Dose Reminder',
      daily_evening_missed_dose: 'Daily Evening Missed Dose',
    },
    remindersTypes: {
      early: 'Early',
      on_time: 'On-Time',
      late: 'Late',
      missed_doses: 'Missed doses',
    },
    messageFor: 'Message for {0}',
    numberOfDoses: '# of doses',
    defaultDoses: '3 doses',
    tagsForReminders: 'Tags to be used in reminders messages',
    clickOnTag: '(Click on tag to add it to the message)',
    reminderCharLimit: 'Messages must be less than 320 charecters long',
    enter3Chars: 'Enter at least 3 characters to search',
    messageSettings: 'Message Settings',
    useSeparateMessage: 'Use separate message for each threshold',
    useSameMessage: 'Use same message for all thresholds',
    notificationsOffWarning:
      'Sending notifications to this patient is disabled. Reminders and milestone messages will be saved but not sent until you turn notifications on. You can enable notifications in the patient info page.',
  },
  endUserLicenseAgreement: 'Acuerdo de licencia de usuario final',
  privacyPolicy: 'POLÍTICA DE PRIVACIDAD EN INTERNET',
  privacyPolicyTrust: 'Política de privacidad',
  termsOfUse: 'Condiciones de uso',
  termsAndConditions: 'Terms and Conditions',
  spec: 'Spec',
  esiPatientLoginStep1: 'Para acceder a su cuenta Lid Sync, ingrese su número de teléfono móvil a continuación.',
  esiPatientLoginStep2:
    'Le enviamos un código de verificación de 6 dígitos. Ingréselo a continuación para verificar su cuenta. El código vencerá en: ',
  yourTrustIsImportantToUs: 'Su confianza es importante para nosotros',

  toProceedYouNeedToAcceptTheFollowing: 'Para continuar, debe aceptar lo siguiente',
  capsRequiredList: {
    '38mm': 'Se necesitan tapas LS002',
    '42mm': 'Se necesitan tapas LS001',
  },
  capsTitles: {
    '38': 'Tapas 38 mm',
    '42': 'Tapas 42 mm',
  },
  updateOrder: 'Actualizar la orden',
  updateCap: 'Actualizar la tapa',
  updateCap: 'Actualizar la tapa',
  registerCap: 'Registrar la tapa',
  hardwareIdUpdatedSuccessfully: 'Se actualizó correctamente el ID de Hardware',
  registerYourSmartCap: 'Registre su Tapa Inteligente',
  activateYourDeviceTitle: 'Active su dispositivo',
  activateYourDevice:
    'Active su dispositivo por SMS. Su código de activación único de 6 dígitos está impreso en la etiqueta adherida a su dispositivo. Envíe un texto con el código a:',
  setYourTimezone: 'Configure su zona horaria',
  setTimezoneInst:
    'Por último, seleccione su zona horaria para que podamos asegurar que los horarios de sus medicamentos sean correctos. Puede cambiar esto más adelante en la configuración.',
  smartCapInst:
    'Encuentre el ID de la tapa con 6 dígitos que está impreso encima del empaque de su tapa (y en la parte de atrás del folleto de instrucciones), e ingrese el número a continuación para registrarla.',
  findTheSmartCapID:
    'Encuentre el ID de la tapa inteligente impreso afuera del empaque de su tapa, e ingrese el número a continuación para registrarla.',
  packageTrackingID: 'ID para rastrear el paquete',
  trackingStatus: 'Estado del envío',
  fieldIsRequired: 'Este campo es necesario',
  fieldIsBelowZero: 'El campo tiene que ser mayor a cero',
  valueMustBeLessThan: 'Value must be less than {0}',
  orderStatuses: {
    created: 'Creado',
    inTransit: 'En tránsito',
    shipped: 'Despachado',
    delivered: 'Entregado',
  },
  orderID: 'ID del pedido',
  orderDate: 'Fecha del pedido',
  trackingID: 'ID de rastreo',
  capsRequired: 'Tapas requeridas',
  twoFAFormCodeText: 'El código de una contraseña se envió a su teléfono móvil. Este código vencerá en: ',
  editSchedule: 'Editar horario',
  editStock: 'Editar pastillas disponibles',
  myDetails: 'Mis datos',
  myAddress: 'Mi dirección',
  address: 'Dirección',
  outreachPhoneNumber: 'Outreach Phone No.',
  myMedications: 'Mis medicamentos',
  editAddress: 'Editar dirección',
  apartmentSuiteOptional: 'Apartmento/Suite (opcional)',
  streetAddress: 'Dirección física',
  streetAddressLine2: 'Street Address Line 2',
  editDetails: 'Editar detalles',
  scheduledRemindersAreTurningOff:
    'No se recomienda realizar esta acción que detendrá todos los recordatorios para todos sus medicamentos activos actualmente.',
  scheduledRemindersAreTurningOn: 'Recibirá todos los recordatorios para todos sus medicamentos activos actualmente.',
  medicationReminders: 'Recordatorios de medicación',
  receiveWeeklyReports: 'Recibir informes semanales',
  addressUpdatedSuccessfully: 'dirección Actualizada correctamente',
  codeHasBeenResent: 'Código reenviado. Vencerá en: ',
  profileUpdated: 'perfil Actualizado',
  selectTimezone: 'Seleccionar zona horaria',
  history: 'Historial',
  stateHistory: 'State History',
  timeTaken: 'Hora que se tomó',
  scheduledDate: 'Scheduled Date',
  downloadLast24Months: 'Descargar los últimos 24 meses',
  downloadFilteredHistory: 'Descargar el historial filtrado',
  exportFormat: 'Formato de Exportación',
  addFilter: 'Agregar el filtro',
  refresh: 'Refrescar',
  imei: 'IMEI',
  deviceImei: 'Device IMEI',
  capShortName: 'Cap Short Name',
  lastActivity: 'Last Activity',
  lastReading: 'Last Reading',
  pairingStatus: 'Pairing Status',
  pairingTime: 'Pairing Time',
  updated_at: 'Updated At',
  reminders: 'Reminders',
  reminder: 'Reminder',
  showReminders: 'Show Reminders',
  factoryMode: 'Factory mode',
  factory: 'Factory',
  customerMode: 'Customer mode',
  customer: 'Customer',
  sleepMode: 'Sleep mode',
  pairingMode: 'Pairing mode',
  on: 'On',
  off: 'Off',
  fota: 'FOTA',
  pins: 'Pins',
  readings: 'Lecturas',
  signalStrength: 'Intensidad de la señal',
  signalQualityEnum: {
    Excellent: 'Excellent',
    Good: 'Good',
    Medium: 'Medium',
    Weak: 'Weak',
  },
  problems: 'Problem(s)',
  signal: 'Señal',
  activity: 'Actividad',
  activityType: 'Tipo de actividad',
  value: 'Valor',
  qrCode: 'Código QR',
  faults: 'Faults',
  passwordInfo:
    'Su contraseña debe tener 8 caracteres y por lo menos 1 número, 1 símbolo (~!*^@#$%&), 1 mayúscula y 1 minúscula.',
  AGN: 'AGN',
  enrollmentDate: 'Fecha de inscripción',
  activationStartEnd: 'Inicio/Fin de Activación',
  registeredDate: 'Fecha de registro',
  lastKnownBattery: 'Última batería conocida',
  lastKnownTemperature: 'Última temperatura conocida',
  lastKnownSignalStrength: 'Última intensidad de señal conocida',
  lowSignal: 'Señal baja',
  moderateSignal: ' Señal moderada',
  highSignal: 'Señal alta',
  lastKnownLocation: 'Último lugar conocido',
  valueHwCode: 'Valor (Código de HW)',
  current: 'Actual',
  remove: 'Eliminar',
  dosesRemaining: 'pastillas restantes',
  thisWillLastUntil: 'Esto durará hasta ',
  great: 'Genial ',
  youAreAllDone: 'Listo',
  requestDownloadData: 'Solicitó descargar sus datos. ',
  pleasePressTheButton: 'Presione el botón a la derecha para guardar el archivo en su disco duro.',
  scheduled: 'Programado',
  allTimes: 'Todos los horarios',
  allMedications: 'Todos los medicamentos',
  statusAll: 'Estado - Todo',
  statusMissed: 'Estado - Omitidos',
  statusUpcoming: 'Estado - Próximos',
  statusTaken: 'Estado - Tomados',
  readyOnly: 'Solo lectura',
  readAndWrite: 'Leer y escribir',
  enterPhoneNumber: 'Ingresar número de teléfono',
  learnMoreAboutInfo:
    'Más información sobre este medicamento, incluyendo las instrucciones de uso, efectos secundarios, interacciones medicamentosas, precauciones y conservación. Con tecnología de ',
  medicationC: 'Medication©',
  day: ' Día',
  daysStreak: ' Racha',
  errorEnterCapId: 'Ingresar el Id de la tapa',
  errorEnterDeviceId: 'Ingresar el Id del dispositivo',
  errorPaitentMedication: 'Error al guardar los datos de medicación del paciente',
  errorSavingPatient: 'Error al guardar los datos del paciente',
  allDays: ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SØBADO', 'DOMINGO'],
  orderUpdatedSuccessfully: 'orden Actualizada correctamente',
  downloadCalendar: 'Descargar el calendario',
  download: 'Descargar',
  downloadCsv: 'Descargar CSV',
  downloadXlsx: 'Descargar Excel',
  openInNewWindow: 'Abrir',
  left: 'restantes',
  yourSuccessPreviousMonth: 'Su precisión durante el mes pasado',
  yourSuccessMonthly: 'Su precisión este mes',
  yourSuccessWeekly: 'Su precisión esta semana',
  good: 'Bien',
  average: 'Aceptable',
  bad: 'Mal',
  getTheApp: 'Obtener el App',
  tutorialTexts: {
    skipBtn: 'Saltar',
    dashTitle: 'Panel',
    dashboardInfo:
      'El panel brinda un resumen rápido de cómo está cumpliendo su regimen, los próximos recordatorios, los medicamentos activos y las alertas de stock.',
    medicationsTitle: 'Medicamentos',
    medicationsInfo:
      'Aquí puede ver y editar sus medicamentos activos e inactivos, ver sus horarios y ver de un vistazo los medicamentos que ha tomado u omitido.',
    calendarTitle: 'Calendario',
    calendarInfo:
      'El calendario es la forma más rápida de ver los medicamentos que tiene para tomar cualquier día específico, y para ver qué días tiene agendados en todo el mes.',
    historyTitle: 'Historial',
    historyInfo:
      'Si necesita confirmar si tomó u omitió un medicamento un día anterior, o revisar o descargar cualquier período de tiempo vaya al Historial. ',
    settingsTitle: 'Configuración',
    settignsInfo:
      'Configuración le permite revisar sus datos personales (y editar algunos), y cambiar su idioma o zona horaria,  y repasar los recordatorios.',
    supportTitle: 'Soporte',
    supportInfo:
      'Si necesita asistencia técnica para su tapa, el app o el sitio web, estamos aquí para ayudarlo en el chat, el centro de ayuda, o por email o teléfono.',
  },
  adminDashboard: {
    numberOfParticipants: 'Participantes',
    numberOfActivatedCaps: 'Tapas activadas',
    missed2ConsecutiveDoses: 'omitidas 2 dosis consecutivas',
    missed5ConsecutiveDoses: 'omitidas 5 dosis consecutivas',
    medicationTaken: 'Tomado',
    medicationMissed: 'Omitido',
    top5LocationByEvents: '5 lugares principales (según los eventos)',
    evolutionOfCapActivations: 'Evolución de las activaciones de tapas',
    adherenceStats: 'Adherence Statistics',
  },
  organization: 'Organización',
  organizationSelected: '{0} organización seleccionada',
  reason: 'Razón',
  users: 'Users',
  organizations: 'Organizaciones',
  organizationsSelected: '{0} organizaciones seleccionadas',
  selectOrganizations: 'Seleccionar organizaciones',
  organizationGroup: 'Organization Group',
  editOrganizationGroup: 'Edit Organization Group',
  createOrganizationGroup: 'Create Organization Group',
  userAddedToOrgGroup: 'User {0} added to organization group',
  maintainers: 'Maintainers',
  cantDeleteOrgFromGroup: 'Organization can\'t be deleted, because there are users or maintainers associated with this organization. Please remove them first.',
  cantDeleteMaintainerUser: 'This user can\'t be deleted, because he is maintainer of this organization group. Please remove him from maintainers list first.',
  youDontHaveRightsToEditGroup: 'You don\'t have rights to edit this group',
  youDontHaveRightsToDeleteGroup: 'You don\'t have rights to delete this group',
  provisioning: 'Suministro',
  testDevice: 'Probar el dispositivo',
  apiURL: 'URL del API',
  fotaURL: ' URL de FOTA ',
  features: 'Funcionalidades',
  deviceManagement: 'Dispositivos',
  bluetooth: 'BLE Cap',
  weightScales: 'Balanzas',
  wristBand: 'Wrist Band',
  glucometer: 'Glucometer',
  spirometer: 'Spirometer',
  inhaler: 'Inhaler',
  sleepReport: 'Sleep report',
  sleepDuration: 'Sleep duration',
  exerciseDetails: 'Exercise details',
  heartRate: 'Frecuencia cardíaca',
  airQuality: 'Calidad del aire',
  movementReport: 'Movement report',
  stepsLowerCase: 'steps',
  steps: 'Steps',
  inhalations: 'Inhalations',
  lte: 'Pillbox',
  lsc: 'LTE Cap',
  injectableTracker: 'Injectable Medication Tracker',
  mdp: 'Smart MDP Dispenser',
  lmo: 'LTE Medication Organizer',
  bloodPressureMonitor: 'Blood Pressure Monitor',
  hub: 'Datahub',
  otherDevices: 'Otros dispositivos',
  report: 'Reporte',
  businessReport: 'Reporte de Negocio',
  addOrganization: 'Agregar organización',
  editOrganization: 'Editar organización',
  organizationName: 'Nombre de la organización',
  enterOrganizationName: 'Ingresar nombre de la organización',
  organizationManagers: 'Gerentes de la organización',
  organizationContact: 'Organization Contact',
  pharmacistInCharge: 'Pharmacist in charge',
  pharmacyIds: 'Pharmacy Ids',
  buildInformation: 'Información de Compilación',
  addRemoveOrganizations: 'Add / Remove Organizations',
  addRemoveMaintainers: 'Add / Remove Maintainers',
  noOrganizationsFound: 'No organizations found',
  noMaintainersFound: 'No maintainers found',
  noUsersFound: 'No users found',
  capManagers: 'Administrador de las tapas',
  configuration: 'Configuración',
  saveConfigAsTemplate: 'Guardar configuración como plantilla',
  saveConfigAsTemplateTitle: 'Guardar configuración como plantilla',
  templateNamePlaceholder: 'Nombre de la plantilla',
  templateNameRequired: 'El nombre de la plantilla es obligatorio',
  templateNameDuplicateWarning: 'A template with this name already exists. Click "Save Anyway" to override existing template.',
  saveTemplate: 'Guardar plantilla',
  saveTemplateConfirm: 'Guardar de todos modos',
  templateSaved: 'Plantilla guardada correctamente',
  editTemplate: 'Editar plantilla',
  deleteTemplateWarning: 'Eliminar plantilla',
  templates: 'Templates',
  owner: 'Propietario',
  createTemplate: 'Crear plantilla',
  templateSource: 'Origen de plantilla',
  createEmptyTemplate: 'Crear plantilla vacía',
  createTemplateFromOrganization: 'Crear desde organización existente',
  careProviderForOrganizations: 'Care Provider For',
  organizationType: 'Tipo de organización',
  organizationTemplate: 'Plantilla de organización',
  createOrganizationFromTemplate: 'Create organization from template',
  createEmptyOrganization: 'Crear organización vacía',
  parentOrganization: 'Organización principal',
  addToOrganizationGroup: 'Agregar al grupo de organizaciones',
  dontAddToOrganizationGroup: "Don't add to organization group",
  noOrganizationGroupAccess: 'No puedes agregar esta organización porque no tienes acceso a ningún grupo de organizaciones. Crea un grupo o contacta con soporte.',
  noClientOrganizationAccess: 'No puedes agregar esta organización porque no tienes acceso a ninguna organización cliente o socia.',
  saveConfigAsTemplate: 'Guardar configuración como plantilla',
  saveConfigAsTemplateTitle: 'Guardar configuración como plantilla',
  templateNamePlaceholder: 'Nombre de la plantilla',
  templateNameRequired: 'El nombre de la plantilla es obligatorio',
  templateNameDuplicateWarning: 'Ya existe una plantilla con este nombre. Vuelva a guardar para confirmar.',
  saveTemplate: 'Guardar plantilla',
  saveTemplateConfirm: 'Guardar de todos modos',
  templateSaved: 'Plantilla guardada correctamente',
  editTemplate: 'Editar plantilla',
  deleteTemplateWarning: 'Eliminar plantilla',
  templates: 'Templates',
  owner: 'Propietario',
  createTemplate: 'Crear plantilla',
  templateSource: 'Origen de plantilla',
  createEmptyTemplate: 'Crear plantilla vacía',
  createTemplateFromOrganization: 'Crear desde organización existente',
  organizationType: 'Tipo de organización',
  organizationTemplate: 'Plantilla de organización',
  useTemplate: 'Usar plantilla',
  createEmptyOrganization: 'Crear organización vacía',
  parentOrganization: 'Organización principal',
  addToOrganizationGroup: 'Agregar al grupo de organizaciones',
  noOrganizationGroupAccess: 'No puedes agregar esta organización porque no tienes acceso a ningún grupo de organizaciones. Crea un grupo o contacta con soporte.',
  noClientOrganizationAccess: 'No puedes agregar esta organización porque no tienes acceso a ninguna organización cliente o socia.',
  dates: 'Fechas',
  startImmediately: 'Comenzar inmediatamente',
  date: 'Fecha',
  twoFAEnabled: '2FA',
  twoFAEnabledStatus: '2FA habilitadas',
  twoFADisabledStatus: '2FA deshabilitadas',
  capManager: 'Administrador de la tapa',
  adminTab: 'Admin',
  admins: 'Admins',
  devicesTab: 'Dispositivos',
  outboundAPITab: 'API saliente',
  externalApiOauthTab: 'API externo OAuth',
  externalApiAccessControlTab: 'Control de acceso a API externo',
  careProviderApiTab: 'Care Provider API',
  athenaConfigurationTab: 'Athena',
  athenaBaseUrl: 'URL base de Athena',
  athenaClientId: 'ID de cliente',
  athenaClientSecret: 'Secreto de cliente',
  athenaScope: 'OAuth Scope',
  athenaPractices: 'Prácticas de Athena',
  addAthenaPractice: 'Añadir práctica de Athena',
  editAthenaPractice: 'Editar práctica de Athena',
  athenaPracticeId: 'ID de práctica',
  athenaPracticeDisplayName: 'Nombre mostrado',
  athenaPracticeEnabled: 'Habilitado',
  athenaCredentialsSaved: 'Credenciales de Athena guardadas',
  athenaPracticeSaved: 'Práctica de Athena guardada',
  athenaPracticeDisabled: 'Práctica de Athena deshabilitada',
  athenaPracticeIdInvalid: 'El ID de práctica debe ser un entero positivo',
  athenaConfigurationSaveFailed: 'No se pudo guardar la configuración de Athena',
  athenaConfigurationLoadFailed: 'No se pudo cargar la configuración de Athena',
  athenaReferringProviderMappings: 'Mapeos de proveedores remitentes de Athena',
  athenaReferringProviderMappingsHint: 'Asocia el NPI de un proveedor externo con el ID de proveedor remitente de athenaOne para cada práctica.',
  athenaReferringProviderMappingNpi: 'NPI del proveedor externo',
  athenaReferringProviderId: 'ID de proveedor remitente de Athena',
  athenaReferringProviderMappingInvalid: 'Introduce un NPI de 10 dígitos e IDs positivos de práctica y proveedor remitente.',
  athenaReferringProviderMappingSaved: 'Mapeo de proveedor remitente de Athena guardado.',
  athenaClinicianProviderMappings: 'Mapeos de profesionales de Athena',
  athenaClinicianProviderMappingsHint: 'Asocia cada miembro inmutable de la lista ACCESS con su ID de proveedor de athenaOne.',
  athenaRosterMemberId: 'ID de miembro de la lista ACCESS',
  athenaSelectRosterMember: 'Selecciona un profesional de ACCESS',
  athenaRosterMemberNotCurrent: 'Miembro de una lista anterior',
  athenaSelectPractice: 'Selecciona una práctica de Athena',
  athenaClinicianRosterNotConfigured: 'Publica una lista de profesionales de ACCESS antes de crear este mapeo.',
  athenaProviderId: 'ID de proveedor de Athena',
  athenaClinicianProviderMappingInvalid: 'Selecciona un profesional de ACCESS y una práctica de Athena e introduce un ID de proveedor de Athena positivo.',
  athenaClinicianProviderMappingSaved: 'Mapeo de profesional de Athena guardado.',
  athenaClaimSubmissions: 'Envíos de cargos a Athena',
  athenaClaimSubmissionsLoadFailed: 'No se pudieron cargar los envíos de cargos a Athena',
  athenaClaimSubmissionDispositionId: 'ID de disposición',
  athenaClaimHistoryEvents: 'Eventos del envío',
  athenaClaimHistoryObservations: 'Observaciones de estado',
  athenaClaimHistoryActor: 'ID del operador',
  athenaClaimHistoryMappingVersion: 'Versión de mapeo de estado',
  athenaClaimHistoryOlder: 'Historial anterior',
  athenaClaimSubmissionPatientId: 'UUID del paciente',
  athenaClaimSubmissionGCode: 'Código G',
  athenaClaimSubmissionDos: 'Fecha de servicio',
  athenaClaimSubmissionStatus: 'Estado',
  athenaClaimSubmissionAthenaClaimId: 'ID de claim de Athena',
  athenaClaimSubmissionAttempts: 'Intentos',
  athenaClaimSubmissionError: 'Error',
  athenaClaimSubmissionExternalStatus: 'Estado en Athena',
  athenaClaimSubmissionExternalStatusNote: 'Nota de estado de Athena',
  athenaClaimSubmissionPollAttempts: 'Intentos de consulta',
  athenaClaimSubmissionPollError: 'Error de consulta',
  athenaClaimPollingPauseReason: 'Motivo de pausa de consultas',
  athenaClaimPollingPausedAt: 'Consultas pausadas el',
  athenaClaimPollingResume: 'Reanudar consultas',
  athenaClaimPollingResumeWarning: 'Confirme que revisó este cargo incierto en Athena. Solo se reanudan las consultas de este envío durante otros 30 días. No se vuelve a enviar el cargo.',
  athenaClaimPollingResumed: 'Consultas reanudadas. No se volvió a enviar el cargo.',
  athenaClaimPollingResumeFailed: 'No se pudieron reanudar las consultas de Athena. Actualice la lista e inténtelo de nuevo.',
  athenaClaimSubmissionTimestamps: 'Marcas de tiempo',
  athenaClaimSubmissionClaimedAt: 'Reservado el',
  athenaClaimSubmissionSubmittedAt: 'Enviado el',
  athenaClaimSubmissionLastPolledAt: 'Última consulta',
  athenaClaimSubmissionNextPollAt: 'Próxima consulta',
  athenaClaimSubmissionTerminalAt: 'Finalizado el',
  samlConfigurationTab: 'SAML',
  externalApiLogsTab: 'Registros de API externo',
  externalApiEnabled: 'External API Enabled',
  samlMetadataUrl: 'URL de metadata del IdP',
  samlMetadataUrlPlaceholder: 'https://example.com/saml/metadata',
  samlAllowIdpInitiated: 'Permitir inicio iniciado por IdP',
  samlSignAuthnRequests: 'Firmar Authn Requests',
  samlSpMetadataUrl: 'URL de metadata del SP',
  samlSpEntityId: 'Entity ID del SP',
  samlSpAcsUrl: 'URL ACS del SP',
  samlNotConfiguredForOrganization: 'Todavia no hay un proveedor SAML configurado para esta organizacion.',
  samlMetadataUrlRequired: 'La URL de metadata del IdP es obligatoria',
  showAllPatients: 'Mostrar todos los pacientes (independientemente del consentimiento)',
  masterLog: 'Registro maestro',
  addOrganizationManager: 'Agregar gerente de la organización',
  editOrganizationManager: 'Editar gerente de la organización',
  active: 'Activo',
  urls: 'URLs',
  key: 'Clave',
  dateOfCreation: 'Fecha de creación (días)',
  addOutboundAPI: 'Agregar API saliente',
  editOutboundAPI: 'Editar API saliente',
  secretKey: 'Clave secreta',
  host: 'Anfitrión',
  url: 'URL',
  ip: 'IP',
  activeSessions: 'Sesiones activas',
  authenticationLog: 'Registro de autenticación',
  signedInOn: 'Inició sesión el',
  timestamp: 'Timestamp',
  device: 'Dispositivo',
  capActivityDetails: 'Detalles de actividad de la tapa',
  hubActivityDetails: 'Detalles de actividad del Hub',
  selectOrganization: 'Seleccionar',
  deviceId: 'ID del dispositivo',
  deviceName: 'Nombre del dispositivo',
  systolicPressure: 'Presión sistólica',
  diastolicPressure: 'Presión diástolica',
  meanArterialPressure: 'Promedio de presión arterial',
  deviceType: 'Tipo de dispositivo',
  deviceModel: `Modelo de dispositivo`,
  weight: 'Peso',
  glucose: 'Glucosa',
  pulse: 'Pulso',
  saturation: 'Saturación',
  oxygenSaturation: 'Saturación de oxígeno',
  heartRate: 'Frecuencia cardíaca',
  airQuality: 'Calidad del aire',
  movementReport: 'Movement report',
  stepsLowerCase: 'steps',
  steps: 'Steps',
  viewDetails: 'Ver detalles',
  hubDetails: 'Detalles del Hub',
  bloodPressure: 'Presión arterial',
  weeklyAvgBloodPressure: 'Weekly Avg. Blood Pressure',
  avgBloodPressure: 'Avg. Blood Pressure',
  heartRateAndBloodPressure: 'Frecuencia cardíaca y presión arterial',
  schedules: {
    schedules: 'Horarios',
    scheduleName: 'Nombre del horario',
    patient: 'Paciente',
    scheduleType: 'Tipo de horario',
    time: 'Hora',
    accuracy: 'Precisión',
    medication: 'Medicación',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    addCap: 'Agregar tapa',
    medication: 'Medicación',
    capId: 'ID de tapa',
    capName: 'Nombre de tapa',
    timeFor: 'Tiempo desde la última toma',
    lastActivityDate: 'Fecha de la última actividad',
    lastActivityTime: 'Hora de la última actividad',
    battery: 'Batería',
    addName: 'Agregar nombre',
    enterName: 'Ingresar nombre',
    search: 'Buscar',
    title1: 'Agregar horario a:',
    title2: 'Seleccionar medicamento',
    title3: 'Fijar horario',
    title4: 'Fechas',
    title5: 'Revisar',
    enableEndDate: 'Habilitar fecha final',
    disableEndDate: 'Deshabilitar fecha final',
    errorScheduleName: 'Ingresar nombre del horario',
    errorMedicationName: 'Seleccionar nombre del medicamento',
    errorSelectTime: 'Seleccionar hora',
    errorSelectTimezone: 'Seleccionar zona horaria',
    errorSelectStartDate: 'Seleccionar fecha de inicio',
    timezone: 'Zona horaria',
  },
  bpMonitor: 'Monitor de presión',
  scale: 'Balanza',
  ble: 'Bluetooth',
  billing: {
    billing: 'Facturación',
    reportDateRangeTooltip:
      'El intervalo de fechas incluye las reclamaciones de facturación que se superponen con el período seleccionado. Una reclamación puede comenzar antes o terminar después de estas fechas.',
    lte: 'LTE',
    ble: 'Bluetooth',
    hub: 'HUB',
    ID: 'ID',
    nickname: 'Sobrenombre',
    costMonth: 'Costo/mes',
    added: 'Agregado',
    device: 'Tipo',
    tasks: 'Tareas',
    deviceEvents: 'Eventos del dispositivo',
  },
  capPatient: {
    endEnrollmentWhen: 'Finalizar inscripción',
    enrollmentEnded: 'Inscripción finalizada para {0}',

    watchedBy: 'Watched by',
    patientName: 'Nombre del paciente',
    enterPatientName: 'Ingresar nombre del paciente',
    enterFirstName: 'Ingresar nombre',
    enterLastName: 'Ingresar apellido',
    enrollment: 'Inscripción',
    enrollmentDate: 'Fecha de inscripción',
    organType: 'Tipo de órgano',
    downloadPatientData: 'Descargar datos del paciente',
    downloadNotesAndActions: 'Download Notes and Actions',
    mobileNumber: 'Mobile Number',
    phoneNumber: 'Número de teléfono',
    textPhoneNumber: 'Número de teléfono para mensajes de texto',
    primaryPhoneNumber: 'Número de teléfono primario',
    email: 'Email',
    address: 'Dirección',
    addressFromImport: 'Dirección (importada)',
    insurance: 'Seguro',
    insuranceName: 'Nombre del seguro',
    enterInsuranceName: 'Ingresar nombre del seguro',
    policyId: 'ID de póliza',
    enterPolicyId: 'Ingresar ID de póliza',
    groupNumber: 'Número de grupo',
    enterGroupNumber: 'Ingresar número de grupo',
    payerId: 'ID del pagador',
    enterPayerId: 'Ingresar ID del pagador',
    insuranceAndBillingNotes: 'Notas del seguro y facturación',
    centerDetails: 'Detalles del centro',
    centerPracticeName: 'Nombre del centro/consultorio',
    enterCenterPracticeName: 'Ingresar nombre del centro/consultorio',
    orderingProvider: 'Proveedor',
    enterOrderingProvider: 'Ingresar proveedor',
    clinicContact: 'Número de teléfono de la clínica',
    enterClinicContact: 'Ingresar número de teléfono de la clínica',
    medicalHistory: ' Historia médica',
    primaryCondition: 'Diagnóstico primario',
    enterPrimaryCondition: 'Ingresar diagnóstico primario',
    secondaryCondition: 'Diagnóstico secondario',
    enterSecondaryCondition: 'Ingresar diagnóstico secundario',
    noConditionsSelected: 'No conditions selected',
    conditionAssignedToActiveEnrollment: 'This condition is assigned to an active enrollment and cannot be removed.',
    unknownConditionCannotBeAssignedToEnrollment: 'Unknown condition cannot be assigned to enrollment.',
    addMedicalHistory: 'Agregar historia médica',
    transplantDetails: ' Detalles del transplante ',
    transplantOrganType: 'Tipo de órgano del transplante',
    enterTransplantOrganType: 'Ingresar tipo de órgano del transplante',
    task: 'Tarea',
    addOrgan: 'Agregar órgano',
    transplantDate: 'Fecha del transplante',
    taskName: 'Nombre de la tarea',
    notes: 'Notas',
    notesFromPharmacyProvider: 'Notes from pharmacy/provider',
    status: 'Estado',
    taskTime: 'Hora de la tarea',
    duration: 'Duración',
    durationMinutes: 'Minutos',
    durationSeconds: 'Segundos',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    deviceId: 'ID del dispositivo',
    deviceName: 'Nombre del dispositivo',
    deviceType: 'Tipo del dispositivo',
    lastEventType: 'Último evento',
    registeredDate: 'Fecha registrada',
    activationDate: 'Fecha de activación',
    battery: 'Batería',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    dose: 'Dosis',
    logTime: 'Hora de registro',
    viewHistory: 'Ver historial',
    loggedThisMonth: 'Registrado este mes',
    goal: 'Meta',
    goalThisMonth: 'Goal this month',
    startTimer: 'Start Timer',
    stopTimer: 'Stop Timer',
    patientId: 'Patient ID',
    athenaPatientId: 'ID de paciente de Athena',
    practiceId: 'ID de la práctica',
    mrn: 'MRN',
    medicareBeneficiaryId: 'ID de beneficiario de Medicare (MBI)',
    dob: 'DOB/fecha de nacimiento',
    patientDetails: 'Detalles del paciente ',
    summary: 'Resumen',
    dateOfBirth: 'Fecha de nacimiento',
    firstName: 'Nombre',
    middleName: 'Segundo nombre',
    lastName: 'Apellido',
    errorReadingFile: 'Error while reading file',
    errorInvalidFile: 'Invalid file selected, valid file format:',
    errorPatientName: 'Ingresar nombre del paciente',
    errorFirstName: 'Ingresar nombre',
    errorLastName: 'Ingresar apellido',
    errorDOB: 'Seleccionar fecha de nacimiento',
    errorTextPhoneNumber: 'Ingresar número de teléfono para mensajes de texto',
    errorPrimaryPhoneNumber: 'Ingresar número de teléfono primario',
    errorEmail: 'Ingresar email',
    errorTimezone: 'Seleccionar zona horaria',
    errorAddress: 'Ingresar dirección',
    errorInsuranceName: 'Ingresar nombre del seguro',
    errorPolicyId: 'Ingresar id de póliza',
    errorGroupNumber: 'Ingresar número de grupo',
    errorFacility: 'Please select Facility',
    errorCenterName: 'Ingresar nombre del centro',
    errorProvider: 'Ingresar proveedor',
    errorClinicContact: 'Ingresar número de teléfono de la clínica',
    errorPrimaryCondition: 'Ingresar diagnóstico primario',
    errorSecondaryCondition: 'Ingresar diagnóstico secundario',
    errorOrganType: 'Ingresar tipo de órgano',
    errorTransplantDate: 'Ingresar fecha del transplante',
    addInsurance: 'Agregar seguro',
    addCenterDetails: 'Agregar detalles del centro',
    providerCenterDetails: 'Provider/Center Details',
    month: 'Mes',
    months: 'Months',
    numberOfTask: 'Cantidad de tareas',
    numberOfDays: 'Días con evento',
    tcClaims: 'ReclamacionesTC',
    date: 'Fecha',
    dateOfService: 'Fecha del servicio',
    reviewerName: 'Nombre del revisor',
    type: 'Tipo',
    note: 'Nota',
    tcId: ' ID de TC',
    billableDate: 'Fecha facturable:',
    billableTime: 'Billable time',
    updateTask: 'Actualizar tarea',
    addTask: 'Añadir tarea',
    addTaskDisabledTooltip: 'Disponible cuando el paciente tenga un programa inscrito activo',
    allTasks: 'Todas las tareas',
    allPrograms: 'Todos los programas',
    allDoctors: 'Todos los doctores',
    filteredTasks: 'Tareas ({0})',
    filteredPrograms: 'Programas ({0})',
    filteredDoctors: 'Doctores ({0})',
    filterOptionsLoadFailed: 'No se pudieron cargar los filtros del historial de tareas',
    totalTime: 'Tiempo total',
    cptCodes: 'Códigos CPT',
    cptCode: 'CPT Code',
    diagnosticsCode: 'Código de diagnóstico',
    data: 'Datos',
    defaultTimeZone: 'America/New_York',
    cycleStartDate: 'Fecha de inicio',
    cycleEndDate: 'Fecha de finalización',
    fileWithXRecords: '{0} with {1} records(s)',
    errorRequiredFields: 'Required fields missing',
    errorFile: 'Unable to read file ',
    errorFiles: 'File errors encountered',
    missingFieldFormat: 'Field missing: {0}',
    incorrectFieldFormat: 'Incorrect format',
    wrongFieldLengthFormat: 'Field too long. Maximum length is {0}',
    incorrectFieldValue: 'Incorrect value: {0}',
    missingTransplantDetails: 'No transplant details',
    missingInsurance: 'No insurance',
    missingCenterDetails: 'No center details',
    missingMedicalHistory: 'No medical history',
    invalidRecords: 'invalid records(s)',
    patientNotAdded: 'patient(s) not added',
    uploadSucceeded: 'Upload succeeded',
    patientAlreadyExists: 'Patient already exists',
    readyForUpload: 'Ready for upload',
    noNewPatients: 'No patients found to be assigned to cohort.',
    patientStatusInCohort: {
      assigned: 'Already in cohort',
      toAssign: 'Will be assigned to cohort',
      toRemove: 'Will be removed from cohort',
      nothingToDo: '-',
      successAdd: 'Sucessfully added to cohort',
      successRemove: 'Sucessfully removed from cohort',
      error: 'Error',
    },
    assignCohort: 'Assign Cohort',
    unassignFromCohort: 'Unassign from Cohort',
    patientStatus: {
      enrolled: 'Enrolled',
      onboarded: 'Onboarded',
      verified: 'Registered',
      activated: 'Activated',
      ended: 'Disenrolled',
      notEnrolled: 'Not Enrolled',
    },
    notEnrolledReason: {
      didNotRespond: 'Did not respond',
      declined: 'Declined',
      ineligible: 'Ineligible',
    },
    disenrolledReason: {
      patientRequested: 'Patient requested',
      nonCompliant: 'Non-compliant',
      lostContact: 'Lost contact',
      deceased: 'Deceased',
      other: 'Other',
    },
    terminatedReason: {
      clinicalGoalsAchieved: 'Clinical Goals Achieved',
      noLongerRequiresMonitoring: 'No Longer Requires Monitoring',
      duplicateEnrollmentIdentified: 'Duplicate Enrollment Identified',
      enrolledInAnotherRPMProgram: 'Enrolled in Another RPM Program',
      lossOfCoverageInsuranceChange: 'Insurance Change',
      movedOutOfServiceAreaTransferredCare: 'Transferred Care',
      noContactWithPatient: 'No Contact with Patient',
      noLongerMeetsEligibilityCriteria: 'No Longer Meets Eligibility Criteria',
      nonAdherentToMonitoringRequirements: 'Non-Adherent to Monitoring Requirements',
      patientRequestedDisenrollment: 'Patient Requested Disenrollment',
      patientDeceased: 'Patient Deceased',
      other: 'Other',
      nonCompliant: 'Non-Compliant',
      patientDeleted: 'Patient Account Deleted',
      patientAccountDeleted: 'Patient Account Deleted',
    },
    onboardedDate: 'Onboarded Date',
    enrolledDate: 'Enrolled Date',
    activatedDate: 'Activated Date',
    disenrolledDate: 'Disenrolled Date',
    notEnrolledDate: 'Not Enrolled Date',
    numberOfEnrollmentsInState: 'Number of enrollments in {0} state',
    enrollFlowStages: {
      onboarding: 'Onboarding',
      registration: 'Registering',
      enrolling: 'Enrolling',
      activating: 'Activating',
    },
    youDontHaveRightsToEnroll: 'You don\'t have rights to enroll patients',
    youDontHaveRightsToActivate: 'You don\'t have rights to activate patients',
    cantAssignKitToPatientWithShipment: 'Cannot assign kit to patient with shipment in progress',
    noMedicationSchedule: 'No medication schedule',
    noMedicationScheduleTooltip: 'No medication schedule is linked to this enrollment, so its adherence can\'t be measured.',
    noMedicationScheduleFilterTooltip: 'RTM/CTAM enrollments whose kit has a medication device but no medication schedule.',
    noMedicationScheduleWarning: 'No medication schedule is linked to the {1} enrollment of {0}. Without one, adherence for this enrollment can\'t be measured.',
    medicationNotLinkedWarning: 'This medication won\'t be linked to the {0} enrollment, which still has no medication schedule.',
    activateAnyway: 'Activate anyway',
    closeAnyway: 'Close anyway',
    saveAnyway: 'Save anyway',
    contactInformation: 'Contact Information',
    patientSaved: 'Patient Details for {0} have been saved',
    assignSmartCap: 'Assign Smart Cap',
    linkWithProgram: 'Link with Program',
    noProgram: 'No Program',
    welcomeMessage: 'Welcome Message',
    enableWelcomeMessage: 'Enable Welcome Message',
    welcomeMessageScheduledDate: 'Welcome Message scheduled date',
    welcomeMessageScheduledTime: 'Welcome Message scheduled time',
    welcomeMessageScheduledTimeAmPm: 'Welcome Message scheduled time AM/PM',
    sendWhenEnrollmentActivates: 'Send when enrollment activates',
    sendOnFirstEvent: 'Send on first event',
    endOfEnrollmentMessage: 'End of Enrollment Message',
    enableEndOfEnrollmentMessage: 'Enable End of Enrollment Message',
    selectProgramsToEnd: 'Select Programs to End',
    programsToEnd: 'Programs to End',
    scheduleTelevisit: 'Schedule Televisit',
    televisitScheduledDate: 'Televisit scheduled date',
    rescheduleTelevisit: 'Reschedule Televisit',
    scheduledTelevisits: 'Scheduled Televisits',
    televisitRescheduled: 'Televisit has been rescheduled',
    addConditionsFacilitiesCohorts:
      'Please setup your organization (add conditions, facilities and cohorts) before adding your first patient',
    patientAgreed: 'Patient agreed',
    patientNotConsented: 'Patient not consented',
    patientConsentIsRequired: 'Patient consent is required',
    consentForNotifications: 'Consent for Notifications',
    provider: 'Provider',
    careProvider: 'Care Provider',
    careProviders: 'Care Providers',
    newPatient: 'New Patient',
    activateEnrollment: 'When to Activate Enrollment',
    enrollmentWillActivate: 'Enrollment will activate',
    enrollmentActivationModesEnum: {
      FirstEvent: 'On first event',
      OnDayAfterFirstEvent: 'On day after first event',
      Manual: 'Custom date',
    },
    enrollmentEndDateIsSet: 'Enrollment end date is set',
    enrollmentIsReadyToStart: 'Enrollment is ready to start',
    missedReadingReminder: 'Missed Reading Reminder',
    missedReadingsTreshold: 'Missed Readings Threshold',
    reminderEveryDays: 'Recordatorio cada (días)',
    reminderEveryDaysHelp: 'Enviado después de {0} días desde la última lectura o recordatorio',
    missedReadingsMessage: 'Missed Readings Message',
    reminderForMissedReadings: 'Reminder for {0}',
    noAlertsToShow: 'No alerts to show',
    sendAlertNotificationTo: 'Send alert notification to',
    alertRecipientsTooltip: 'Caregivers can be configured in Info → Caregivers section.<br />Care Provider phone can be configured in Info → Center Details → Clinic Phone Number.',
    caregiversAndCareprovider: 'Caregivers and care provider',
    reminderForMissedReadingsEnabled: 'Reminder for {0} missed readings enabled',
    xDays: '{0} days',
    selectDevice: 'Select Device',
    enrollmentIsCancelled: 'Enrollment is cancelled',
    engagementMessages: 'Engagement Messages',
    adherenceMilestonesMessages: 'Adherence Milestones Messages',
    adherenceMilestones: 'Adherence Milestones',
    alertTypes: {
      enrollment: 'Billing Alerts',
      vitals: 'Vitals Alerts',
      medications: 'Adherence Alerts',
      openActions: 'Open Actions',
    },
    enrollmentAlerts: {
      missing_mandatory_tasks: 'Missing mandatory tasks',
      missing_cpt: 'Missing CPT',
    },
    alertsTooltips: {
      enrollmentOn: 'Billing alerts - there are impediments to generating CPT codes',
      vitalsOn: 'Vitals alerts - patient has abnormal vitals readings',
      medicationsOn: 'Adherence alerts - patient has missed medication doses',
      openActionsOn: 'There are open actions for patient',
      enrollment: 'Billing alerts - there are no impediments to generating CPT codes',
      vitals: 'Vitals alerts - patients vitals readings are within normal range',
      medications: 'Adherence alerts - patient has no missed medication doses',
      openActions: 'There are no open actions for patient',
    },
    openActions: 'Open Actions',
    missingMandatoryTasksForBilling: 'Missing mandatory tasks for billing',
    selectPatientStatus: 'Select Patient Status',
    selectAtLeastOneEnrollmentToEndError: 'Please select at least one program to end',
    takeTimes: 'Take Times',
    manualSmsEnabled: 'Manual SMS enabled',
    manualSMS: 'Manual SMS',
    notificationsEnabled: 'Notifications enabled',
    notifications: 'Notifications',
    disabledWithExeptionOfManualSMS: 'Disabled (with exception of manual SMS)',
    notesAndActions: 'Notes & Actions',
    selectProgramToGetDefaultWelcomeMessage: 'Select program to get default welcome message',
  },
  fieldsRequired: 'fields required',
  messages: {
    archived: 'Archivado',
    messages: 'Mensajes',
    new: 'New',
    inbox: 'Casilla de entrada',
    number: 'Número',
    name: 'Nombre',
    from: 'De',
    to: 'Para',
    toFrom: 'Para/De',
    conversation: 'Conversación',
    date: 'Fecha',
    time: 'Hora',
    newMessage: 'Nuevo mensaje',
    displaySystemMessages: 'Mostrar mensajes del sistema',
    typeMessage: 'Tipo de mensaje',
    archive: 'Archivar',
    unarchive: 'Desarchivar',
    read: 'Leído',
    unread: 'Marcar como no leído',
    markAs: 'Mark as',
    prefabReplies: 'Prefab Responses',
    prefabReply: 'Prefab Response',
    shortcut: 'Shortcut',
    author: 'Author',
    shared: 'Shared',
    private: 'Private',
    shareWithCollegues: 'Share prefab with colleagues',
    addToPrefabs: 'Add to prefab responses',
    addAsPrefab: 'Add reply as a prefab',
    addReply: 'Add Reply',
    createNewPrefab: 'Create new prefab response',
    editPrefab: 'Edit prefab response',
    recipients: 'Recipients',
    manualSmsDisabled: 'Sending text messages to this patient is disabled. You can enable it in patient info page.',
  },
  esi: {
    active: 'Activo',
    pending: 'Pendiente',
    termed: 'Terminado',
    activatedDate: 'Fecha de activación',
    termedDate: 'Fecha terminado',
  },
  textDays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  settingPage: {
    details: 'Details',
  },
  timer: 'Timer:',
  alltime: 'All-time',
  selectTimezone: 'Please select timezone',
  patientInfo: 'Patient Info',
  frequecyType: {
    asNeeded: 'As Needed',
    everyday: 'Every day',
    specificDays: 'Specific days',
    interval: 'Interval',
    onceDaily: 'Cada día',
    twiceDaily: 'Dos veces al día',
    threeTimesDaily: 'Tres veces al día',
    fourTimesDaily: 'Cuatro veces al día',
    fiveTimesDaily: 'Cinco veces al día',
    sixTimesDaily: 'Seis veces al día',
    everyFourHours: 'Cada 4 horas',
  },
  searchConversation: 'Buscar conversación',
  editCapManager: 'Editar administrador de la tapa',
  capManagerUpdated: 'Se actualizó el administrador de la tapa',
  activateYourDeviceBySMSText: `Active su dispositivo vía SMS. Puede encontrar su código único de activación de 6 dígitos impreso en la etiqueta adherida a su dispositivo. Envíe el código a:`,
  refreshTheDataAL: 'Actualice los datos"',
  pleaseEnterCodeAL: 'Ingrese el código ',
  charachterAL: 'carácter',
  selectMedicineAL: 'Seleccione el medicamento de la lista',
  timepickerAL: 'Seleccione la zona horaria en el selector',
  medicationScreenAL: 'navegue a la pantalla de medicamentos',
  refreshDataAL: 'Actualice los datos',
  navigateToScreenAL: {
    navigateTo: 'navegue a',
    screen: 'pantalla',
  },
  refreshAL: 'Refresh the data',
  chooseStartDateAL: 'Choose start Date',
  chooseEndDateAL: 'Choose end Date',
  addFilterPlus: 'Add filter',
  noFilter: 'No Filter',
  clear: 'Clear',
  unsupportedDevice: 'This device type is not fully supported yet. Please contact customer support.',
  rem: `REM`,
  deepSleep: 'Deep',
  lightSleep: 'Light',
  awake: 'Awake',
  opportunity: 'Opportunity',
  percentChange: '% Change',
  ended: 'Ended',
  length: 'Lenght',
  sleepAt: 'Sleep at',
  wakeUpAt: 'Wake-up at',
  unit_minutes: 'mins',
  selectedTimezone: ' selected timezone',
  billingStatus: {
    pending: 'Pending',
    submitted: 'Submitted',
    onhold: 'On-Hold',
  },
  reading: 'Reading',
  custom: 'Custom',
  calories: 'Calories',
  distance: 'Distance',
  exerciseTime: 'Exercise time',
  exerciseIntensity: 'Exercise intensity',
  restHR: 'Rest HR',
  alertsEnum: {
    bloodPressure: 'Blood Pressure Alerts',
    oxygenSaturation: 'Saturation Alerts',
    weight: 'Weight Alerts',
    glucose: 'Glucose Concentration Alerts',
    spirometry: 'Spirometry Alerts',
    temperature: 'Temperature Alerts',
    heartRate: 'Heart rate Alerts',
    pm25: 'PM 2.5 Alerts',
    coagulation: 'Coagulation Alerts',
  },
  unit: 'Unit',
  alertThreshold: 'Alert Threshold',
  alertThresholds: 'Alert Thresholds',
  goals: 'Goals',
  goal: 'Goal',
  lowWeight: 'Low Weight',
  highWeight: 'High Weight',
  lowSystolic: 'Low Systolic',
  highSystolic: 'High Systolic',
  lowDiastolic: 'Low Diastolic',
  highDiastolic: 'High Diastolic',
  lowGlucose: 'Low Glucose',
  highGlucose: 'High Glucose',
  lowFev1: 'Low FEV1',
  highFev1: 'High FEV1',
  lowFvc: 'Low FVC',
  highFvc: 'High FVC',
  change: 'Change',
  changeSinceLastReading: 'Change since last reading',
  latestReadings: 'Latest Readings',
  patientLog: 'Patient Log',
  time: 'Time',
  ampm: 'AM/PM',
  pulseOx: 'Pulse Ox',
  language: 'Language',
  new: 'New',
  documents: 'Documents',
  supportDocuments: {
    general: 'Documentos generales',
    documentsLoadFailed: 'No se pudieron cargar los documentos de soporte. Inténtelo de nuevo.',
    foldersLoadFailed: 'No se pudieron cargar las carpetas de documentos. Se ha conservado la selección guardada.',
    noFolders: 'No hay carpetas de documentos disponibles. Se ha conservado la selección guardada.',
    folderUnavailable: 'no disponible',
    currentFolderUnavailable: 'La carpeta guardada no está disponible. Seleccione una carpeta disponible para cambiarla.',
    refreshFolders: 'Actualizar carpetas',
    retry: 'Reintentar',
  },
  pulseMeasures: 'Pulse measures',
  stepsBy: 'Accumulated steps by',
  chooseFile: 'Choose file',
  readingDataFromFile: 'Reading data from file...',
  dropOr: 'Drag and drop file, or',
  fileUploadedSuccessfully: 'File uploaded successfully',
  manualUploadProcessInfo:
    'As this is a manual patient upload process, please communicate to the to the coordinator that data has been uploaded.',
  fileUploadFail: 'File upload failed',
  fileExceedMaximumSizeOf: 'File exceed maximum size of',
  documentsGeneralProblem: 'Problem with getting access to documents',
  refreshAL: 'Actualice los datos',
  chooseStartDateAL: 'Elija la fecha de inicio',
  chooseEndDateAL: 'Elija la fecha de finalización',
  allFacilities: 'All Facilities',
  english: 'inglés',
  spanish: 'español',
  languagesEnum: {
    en: 'English (UK)',
    'en-us': 'English (US)',
    es: 'Spanish',
    ar: 'Arabic',
    zh: 'Chinese',
    'yue': 'Chinese (Cantonese)',
    vi: 'Vietnamese',
    ko: 'Korean',
  },
  actions: 'Actions',
  addNote: 'Agregar Nota',
  editNote: 'Editar Nota',
  createActionItem: 'Crear Elemento de Acción',
  enterManualVitals: 'Ingresar Signos Vitales Manuales',
  moreVitals: 'Más signos vitales…',
  hideMoreVitals: 'Ocultar signos vitales adicionales',
  measuredBy: 'Medido Por',
  measurementTimestamp: 'Fecha y Hora de Medición',
  bloodGlucose: 'Glucosa en sangre',
  height: 'Altura',
  systolic: 'Sistólica',
  diastolic: 'Diastólica',
  prothrombinTime: 'TP',
  inr: 'INR',
  peakExpiratoryFlow: 'Flujo espiratorio pico',
  fev1: 'FEV1',
  fvc: 'FVC',
  shakes: 'Sacudidas',
  count: 'Cantidad',
  duration: 'Duración',
  neurological: 'Neurológico',
  orientation: 'Orientación',
  coordination: 'Coordinación',
  inhalationDuration: 'Duración de la inhalación',
  exercise: 'Ejercicio',
  amount: 'Cantidad',
  burnedCalories: 'Calorías quemadas',
  editAction: 'Editar Acción',
  emailPatient: 'Email Patient',
  title: 'Title',
  note: 'Note',
  description: 'Description',
  category: 'Categoria',
  severity: 'Severidad',
  completedAction: 'Completed Action',
  openAction: 'Open Action',
  created: 'Created',
  edited: 'Edited',
  complete: 'Complete',
  resolved: 'Resuelta',
  open: 'Open',
  completed: 'Completed',
  reOpen: 'Re-Open',
  actionStatus: 'Action Status',
  statusDate: 'Status Date',
  limitVisibility: 'Limit {0} visibility to:',
  noteCharLimit: '{0} must be less than {1} charecters long',
  xMustBeLessThenY: '{0} must be less than {1}',
  logitemType: 'Log Item Type',
  downloadTemplateCsv: 'Download template cvs file',
  downloadTemplateXslx: 'Download template xlsx file',
  andXmore: '... and {0} more',
  createKit: 'Create Kit',
  kit: 'Kit',
  kitId: 'Kit ID',
  kitIds: 'Kit IDs',
  kitStatus: 'Kit Status',
  selectKit: 'Select Kit',
  attachKit: 'Attach Kit',
  reassignKit: 'Reassign Kit',
  kitToReplace: 'Kit que se reemplazará',
  removeKit: 'Remove Kit',
  attachDeviceToKit: 'Attach Device to a Kit',
  attachDevicesToKit: 'Attach Devices to a Kit',
  kitName: 'Kit Name',
  enrollmentId: 'Enrollment ID',
  editEnrollment: 'Edit Enrollment',
  attachAdditionalKitWarning: 'This patient already has {0} kit(s). Confirm that you want to attach another kit.',
  activeSince: 'Active Since',
  deleteKit: 'Delete Kit',
  deleteKitWarning: 'Are you sure you want to delete this kit?',
  editKit: 'Edit Kit',
  healthMonitorAlerts: {
    title: 'Alertas del estado del sistema',
    description:
      'Las reglas definen qué métrica del sistema se supervisa y cuándo se considera que presenta problemas. Cuando se cumple la condición de una regla, se abre un incidente y sus suscripciones activas determinan quién recibe notificaciones por SMS o correo electrónico.',
    rules: 'Reglas',
    incidents: 'Incidentes',
    fieldHelp: 'Ayuda de {0}',
    descriptionLabel: 'Descripción',
    descriptionTooLong: 'Debe tener {0} caracteres o menos',
    metricType: 'Tipo de métrica',
    detectorKey: 'Clave del detector',
    detectorKeyHelp:
      'La tasa de fallos de SMS mide los mensajes SMS salientes fallidos como porcentaje de todos los mensajes SMS. La tasa de fallos de eventos mide los eventos de dispositivos fallidos como porcentaje de todos los eventos de dispositivos. El recuento de eventos fallidos cuenta los registros que no se pudieron procesar y admite filtros por categoría e ID de CAP.',
    operator: 'Operador',
    thresholdOperator: 'Operador de umbral',
    thresholdValue: 'Valor de umbral',
    severity: 'Severidad',
    timeWindow: 'Ventana de tiempo',
    windowPreset: 'Ventana predefinida',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    editRule: 'Editar regla de alerta',
    createRule: 'Crear regla de alerta',
    updateRule: 'Actualizar regla',
    createRuleButton: 'Crear regla',
    ruleSaveFailed: 'No se pudo guardar la regla de alerta',
    ruleUpdated: 'Regla de alerta actualizada',
    ruleCreated: 'Regla de alerta creada',
    failureCategoriesInclude: 'Categorías de fallo que se incluirán',
    failureCategoriesIncludeOptional: 'Categorías de fallo que se incluirán (opcional)',
    failureCategoriesIncludeHelp:
      'Cuando se seleccionan categorías, solo se cuentan los eventos fallidos de esas categorías.',
    failureCategoriesExclude: 'Categorías de fallo que se excluirán',
    failureCategoriesExcludeOptional: 'Categorías de fallo que se excluirán (opcional)',
    failureCategoriesExcludeHelp:
      'Los eventos fallidos de las categorías seleccionadas se ignoran. Las exclusiones se aplican después de las inclusiones.',
    allCategories: 'Todas las categorías',
    noExcludedCategories: 'Ninguna categoría excluida',
    failureCategoriesLoadFailed: 'No se pudieron cargar las categorías de fallo',
    noCategoriesAvailable: 'No hay categorías disponibles',
    capIdPattern: 'Patrón de ID de CAP',
    capIdPatternOptional: 'Patrón de ID de CAP (opcional)',
    capIdPatternPlaceholder: 'p. ej., CAP-%',
    capIdPatternHelp:
      'Busca coincidencias de ID de CAP sin distinguir mayúsculas y minúsculas. Utilice % para cualquier cantidad de caracteres y _ para un carácter. Por ejemplo, CAP-% coincide con todos los ID de CAP que comienzan por CAP-.',
    detectors: {
      smsFailureRate: 'Tasa de fallos de SMS',
      eventFailureRate: 'Tasa de fallos de eventos',
      failedEventsCount: 'Recuento de eventos fallidos',
    },
    operators: {
      greaterThan: 'Mayor que (>)',
      greaterThanOrEqual: 'Mayor o igual que (>=)',
      lessThan: 'Menor que (<)',
      lessThanOrEqual: 'Menor o igual que (<=)',
    },
    severityLevels: {
      info: 'Información',
      warning: 'Advertencia',
      critical: 'Crítica',
    },
    timeWindows: {
      last1Hour: 'Última hora',
      last24Hours: 'Últimas 24 horas',
      last7Days: 'Últimos 7 días',
      last28Days: 'Últimos 28 días',
      last30Days: 'Últimos 30 días',
    },
    subscription: {
      edit: 'Editar suscripción',
      create: 'Crear suscripción',
      update: 'Actualizar suscripción',
      description:
        'Una suscripción determina quién recibe notificaciones cuando se activa esta regla de alerta. Seleccione un usuario del portal como destinatario o introduzca una dirección de correo electrónico o un número de teléfono para un destinatario personalizado. A continuación, elija si desea enviar notificaciones por SMS, correo electrónico o ambos.',
      recipientUser: 'Usuario destinatario',
      recipientUserOptional: 'Usuario destinatario (opcional)',
      recipientUserHelp:
        'Se utilizan el correo electrónico y el número de teléfono guardados del usuario seleccionado, salvo que se introduzca un valor alternativo.',
      searchPlaceholder: 'Buscar por nombre, usuario o correo electrónico...',
      enterAtLeast2Characters: 'Introduzca al menos 2 caracteres',
      noUsersFound: 'No se encontraron usuarios',
      searchFailed: 'No se pudieron cargar los usuarios',
      unnamedUser: 'Usuario sin nombre',
      label: 'Etiqueta de suscripción',
      labelOptional: 'Etiqueta de suscripción (opcional)',
      labelHelp:
        'Nombre interno utilizado para reconocer esta suscripción en la lista. No afecta a la entrega.',
      emailOverride: 'Correo electrónico alternativo',
      emailOverrideOptional: 'Correo electrónico alternativo (opcional)',
      emailOverrideHelp:
        'Reemplaza el correo electrónico guardado del usuario destinatario para esta suscripción. También puede utilizarse sin un usuario destinatario.',
      phoneNumberOverride: 'Número de teléfono alternativo',
      phoneNumberOverrideOptional: 'Número de teléfono alternativo (opcional)',
      phoneNumberOverrideHelp:
        'Reemplaza el número de teléfono guardado del usuario destinatario para esta suscripción. También puede utilizarse sin un usuario destinatario.',
      smsEnabled: 'SMS habilitados',
      emailEnabled: 'Correo electrónico habilitado',
      contactMethod:
        'Usuario destinatario, correo electrónico alternativo o número de teléfono alternativo',
      notificationChannel: 'SMS o correo electrónico habilitados',
      contactMethodRequired:
        'Obligatorio: seleccione un usuario destinatario o introduzca un correo electrónico o número de teléfono alternativo.',
      notificationChannelRequired:
        'Una suscripción activa debe tener habilitados los SMS o el correo electrónico.',
      invalidEmail: 'Formato de correo electrónico no válido',
      invalidPhone: 'Formato de número de teléfono no válido',
      saveFailed: 'No se pudo guardar la suscripción',
      updated: 'Suscripción actualizada',
      created: 'Suscripción creada',
    },
  },
  myAlerts: 'My Alerts',
  showingXPendingAlerts: 'Showing {0} Pending Alerts',
  showingXofXPendingAlerts: 'Showing {0} of {1} Pending Alerts',
  showingXAlerts: 'Showing {0} Alerts',
  showingXofXAlerts: 'Showing {0} of {1} Alerts',
  priority: 'Priority',
  type: 'Type',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  measurements: 'Measurements',
  missedDoses: 'Missed Doses',
  itemSaved: '{0} saved successfully',
  characters: 'characters',
  vitals: 'Vitals',
  capType: 'Cap Type',
  selectDevice: 'Select Device',
  heartRateDevice: 'Heart-rate device',
  heartRateFromBloodPressureCuff: 'From the blood-pressure cuff (no extra device)',
  heartRateFromPulseOximeter: 'From the pulse oximeter (no extra device)',
  heartRateSeparateDevice: 'Separate all-day device, e.g. a wrist band (adds one unless the order already has one)',
  includedWith: 'Included with {0}',
  separateDevice: 'separate device',
  separateHeartRateDevice: 'Separate heart-rate device',
  separateHeartRateDeviceNotMapped: "Smart ordering can't ship a separate device: no available wrist band is listed under Heart rate in this organization's Device Mappings. Ask an administrator to add one, or take heart rate from the current device.",
  checkingSeparateHeartRateDevice: 'Checking which heart-rate devices smart ordering can ship for this organization…',
  separateHeartRateDeviceNeedsHub: "Smart ordering can't ship a separate device: the wrist band it would add needs a hub, and no hub is orderable for this organization. Ask an administrator to make one orderable, or take heart rate from the current device.",
  separateHeartRateDeviceCheckFailed: "Couldn't check which heart-rate devices this organization can ship. Saving the enrollment still checks the choice.",
  offeredVitalsCheckFailed: 'No se pudo comprobar para qué constantes vitales esta organización tiene dispositivos, así que se muestran todas.',
  noVitalDevicesOffered: 'No hay dispositivos de constantes vitales disponibles para esta organización',
  cohorts: 'Cohorts',
  cohort: 'Cohort',
  activePatients: 'Active Patients',
  inactivePatients: 'Inactive Patients',
  assignedTo: 'Assigned to',
  facilities: 'Facilities',
  facility: 'Facility',
  providerFacility: 'Provider / Facility',
  addEditProvidersFacilities: 'Add / Edit Facilities',
  selectFacility: 'Select Facility',
  providersFacilities: 'Facilities',
  selectManager: 'Select Manager',
  selectCohort: 'Select Cohort',
  select: 'Select',
  noOptionSelected: 'No option selected',
  createCohort: 'Create Cohort',
  editCohort: 'Edit Cohort',
  cohortName: 'Cohort Name',
  cohortId: 'Cohort Id',
  primaryCohortManager: 'Primary Cohort Manager',
  primaryManager: 'Primary Manager',
  secondaryManager: 'Secondary Manager',
  numberOfEnrollments: 'Number of Enrollments',
  createdBy: 'Created by',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  updatedBy: 'Updated by',
  uuid: 'UUID',
  skip: 'Skip',
  flowVolumeCurve: 'Flow Volume Curve',
  volumeTimeCurve: 'Volume Time Curve',
  clearAlert: 'Clear alert',
  clearAlertError: 'Clear alert error',
  clearAlertsToSetVitalsLimitsAndGoals: 'Clear alerts to set vitals limits and goals',
  clearAlertsToSetMissedReadingsReminder: 'Clear alerts to set missed readings reminder',
  activeAlertThresholdsWarning: 'An alert is currently active. Updated thresholds will trigger new notifications only after you clear the current alert.',
  setReminder: 'Set reminder',
  spirometry: 'Espirometría',
  program: 'Program',
  programEnrollment: 'Program Enrollment',
  confirmations: 'Confirmations',
  programs: {
    rtm: 'RTM',
    ccm: 'CCM',
    rpm: 'RPM',
    pcm: 'PCM',
    ctam: 'CTAM',
    eckm: 'eCKM',
    ckm: 'CKM',
    msk: 'MSK',
    bh: 'BH',
  },
  subprograms: {
    rtm: {
      musculoskeletal: 'Musculoskeletal',
      respiratory: 'Respiratory',
      behavioralHealth: 'Cognitive Behavioral',
    },
    ccm: {
      basic: 'Basic',
      complex: 'Complex',
    },
  },
  defaultProgram: 'Default Program',
  otherPrograms: 'Other Programs',
  writtenConsentGiven: 'Written consent given',
  verbalConsentGiven: 'Verbal consent given',
  selectProgram: 'Select Program',
  selectCondition: 'Select Condition',
  selectOrganizationTemplate: 'Select Organization Template',
  selectOrganizationType: 'Select Organization Type',
  selectPrograms: 'Select Programs',
  patientWillBeAssigned: 'Patient will be assigned to:',
  searchKit: 'Search Kit',
  scanBarcodeOrEnterId: 'Scan barcode on the box, or enter id',
  redings: 'Readings',
  deviceTypes: {
    bpm: 'BP Monitor',
    scales: 'Scales',
    glucometer: 'Glucometer',
    wristBand: 'Wrist Band',
    spirometer: 'Spirometer',
    hailieInhaler: 'Hailie Inhaler',
    thermometers: 'Thermometers',
    pulseOximeter: 'Pulse Oximeter',
    bluetoothCap: 'Bluetooth cap',
    hub: 'Hub',
    lte: 'LTE',
    lsc: 'LSC',
    inhaler: 'Inhaler',
    airQualityMonitor: 'Air Quality Monitor',
    ptInrMonitor: 'PT/INR Monitor',
  },
  readingStatus: {
    allReadings: 'All Readings',
    newReadings: 'New Readings',
    archivedReadings: 'Archived Readings',
  },
  normal: 'Normal',
  abnormal: 'Abnormal',
  alert: 'Alert',
  batteryReading: 'Battery reading',
  localization: 'Localization',
  firmwareVersion: 'Firmware version',
  signalQuality: 'Signal quality',
  sleep: 'Sleep',
  pillsTaken: 'Pills taken',
  inhalationTaken: 'Inhalation taken',
  zephyRxDashboard: 'ZephyRx Dashboard',
  editConditionList: 'Edit Condition List',
  editFacilityList: 'Edit Facility List',
  patientAlerts: 'Patient Alerts',
  thermometer: 'Thermometer',
  lowTemperature: 'Low Temperature',
  highTemperature: 'High Temperature',
  lowSaturation: 'Low Saturation',
  lowHR: 'Low Heart rate',
  highHR: 'High Heart rate',
  highPm25: 'High PM 2.5',
  lowPt: 'Low PT',
  highPt: 'High PT',
  lowInr: 'Low INR',
  highInr: 'High INR',
  missedDosesAlerts: 'Missed doses Alerts',
  reviewBy: 'Review By',
  last2days: 'Last 48 hours',
  hour: 'hour',
  hours: 'hours',
  saveWithNoKit: 'Save with no kit',
  xObjectsAssignedtoY: '{0} {1} assigned to {2}',
  xObjectsUnassignedfromY: '{0} {1} unassigned from {2}',
  enroll: 'Enroll',
  continueEnrollment: 'Continue Enrollment',
  cancelEnrollment: 'Cancel Enrollment',
  moveToNotEnrolled: 'Move to Not Enrolled',
  moveToOnboarded: 'Move to Onboarded',
  moveToNotEnrolledWarning: 'Are you sure you want to move patient {0} to Not Enrolled?',
  moveToOnboardedRegisteredWarning: 'Are you sure you want to move patient {0} to Onboarded/Registered state?',
  selectNotEnrolledReason: 'Select reason for not enrolling',
  selectDisenrolledReason: 'Select reason for disenrollment',
  selectTerminatedReason: 'Select reason for ending enrollment',
  setEnrollmentEndDate: 'Set enrollment end date',
  disenroll: 'Disenroll',
  activateNow: 'Activate enrollment',
  register: 'Register',
  unregister: 'Unregister',
  unregisterEnrollmentWarning:
    '¿Está seguro de que desea anular el registro de la inscripción del paciente {0}? La inscripción volverá al estado Onboarded.',
  enrollmentUnregistered: 'La inscripción del paciente {0} volvió al estado Onboarded.',
  pharmacyNotesToProvider: 'Pharmacy notes to Provider',
  changeEnrollmentEndDate: 'Change enrollment end date',
  enrollmentFor: 'Enrollment for',
  enrollmentCondition: 'Enrollment Condition',
  enrollmentProgram: 'Enrollment Program',
  enrollmentType: 'Tipo de inscripción',
  enrollmentConsent: 'Enrollment Consent',
  consentChecklist: {
    title: 'Patient consent',
    status: 'Consent status',
    statusNotObtained: 'Not obtained',
    statusVerbal: 'Verbal consent given',
    statusWritten: 'Written consent given',
    statusDeclined: 'Declined',
    dateObtained: 'Date obtained',
    obtainedBy: 'Obtained by',
    givenBy: 'Consent given by',
    givenByPatient: 'Patient',
    givenByCaregiver: 'Caregiver',
    informedThat: 'Patient was informed that:',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    templateFooter: 'Consent template: {0} · {1} · all items are required to activate the enrollment',
    badgeNotObtained: 'Not obtained',
    badgeDeclined: 'Declined',
    badgeVerbal: 'Verbal consent recorded',
    badgeWritten: 'Written consent recorded',
    badgeProgress: '{0} of {1} confirmed',
    selectProgramFirst: 'Select a program to see the consent checklist.',
    errorStatus: "Record the patient's verbal or written consent to activate the enrollment.",
    errorDate: 'Enter the date consent was obtained.',
    errorFutureDate: 'The consent date cannot be in the future.',
    errorObtainedBy: 'Enter who obtained the consent.',
    errorItems: 'Confirm every item before activating the enrollment.',
    label: 'Consent',
    pillVerbal: 'Verbal',
    pillWritten: 'Written',
    pillNotObtained: 'Not obtained',
    obtainedByName: 'by {0}',
    details: 'Details',
    hide: 'Hide',
    recorded: 'Recorded',
    recordedAtBy: '{0} by {1}',
    template: 'Template',
    informedThatCount: 'Patient was informed that ({0} of {1}):',
    requiredBeforeActivation: 'Required before activation',
    recordConsent: 'Record consent',
    recordedBeforeChecklist: 'Recorded before the consent checklist',
  },
  enrollmentConsentNotSetError: 'Either written or verbal consent must be given to enroll patient',
  accessTrack: 'Programa ACCESS',
  accessGCodesTitle: 'Códigos G de ACCESS',
  accessGCodesCandidate: 'Candidato ACCESS',
  accessGCodesStatus: 'Estado del candidato',
  accessGCodesCode: 'Código G',
  accessGCodesPeriod: 'Período de atención',
  accessGCodesDos: 'Fecha de servicio',
  accessGCodesDeadline: 'Fecha límite de envío',
  accessGCodesDisposition: 'Disposición de facturación',
  accessGCodesDiagnosis: 'Diagnóstico',
  accessGCodesPolicy: 'Política de diagnóstico',
  accessGCodesQualification: 'Calificación de diagnóstico',
  accessGCodesQualificationDecision: 'Decisión',
  accessGCodesQualifyingCodes: 'Códigos calificadores',
  accessGCodesExclusionCodes: 'Códigos de exclusión',
  accessGCodesEnrollmentCodes: 'Códigos de diagnóstico de inscripción',
  accessGCodesPos: 'Lugar de servicio',
  accessGCodesPosReason: 'Motivo del lugar de servicio',
  accessGCodesServiceStartedOn: 'Primera fecha de servicio',
  accessGCodesConfirmCareDelivery: 'Confirmar prestación activa de atención',
  accessGCodesCreateDisposition: 'Crear disposición de facturación',
  accessGCodesAssignClinicians: 'Asignar profesionales',
  accessGCodesRenderingClinician: 'Profesional prestador',
  accessGCodesSupervisingClinician: 'Profesional supervisor',
  accessGCodesNoSupervisingClinician: 'Sin profesional supervisor',
  accessGCodesApproveDisposition: 'Aprobar disposición',
  accessGCodesDispositionActions: 'Acciones de disposición',
  accessGCodesAction: 'Acción',
  accessGCodesSendToReview: 'Enviar a revisión',
  accessGCodesResolveReview: 'Resolver revisión',
  accessGCodesCancelDisposition: 'Cancelar disposición',
  accessGCodesUpdateDisposition: 'Actualizar disposición',
  accessGCodesReason: 'Motivo',
  accessGCodesAcceptedSnapshot: 'Instantánea de facturación aceptada',
  accessGCodesAuditHistory: 'Historial de auditoría',
  accessGCodesNoEvents: 'No se registraron eventos de auditoría.',
  accessGCodesActionFailed: 'No se pudo completar la acción del código G de ACCESS.',
  accessGCodesCompleteRequiredFields: 'Complete los campos requeridos antes de confirmar la prestación de atención.',
  accessGCodesCareDeliveryConfirmed: 'Prestación activa de atención confirmada.',
  accessGCodesDispositionCreated: 'Disposición de facturación creada.',
  accessGCodesRenderingRequired: 'Seleccione un profesional prestador.',
  accessGCodesCliniciansAssigned: 'Profesionales de facturación asignados.',
  accessGCodesDispositionApproved: 'Disposición de facturación aprobada.',
  accessGCodesReasonRequired: 'Se requiere un motivo para esta acción.',
  accessGCodesDispositionUpdated: 'Disposición de facturación actualizada.',
  careUpdateConsent: 'Consentimiento del paciente para enviar actualizaciones de atención al PCP y a los médicos remitentes',
  primaryCareProviderName: 'Nombre del proveedor de atención primaria',
  primaryCareProviderNpi: 'NPI del proveedor de atención primaria',
  primaryCareProvider: 'Proveedor de atención primaria',
  referringProvider: 'Proveedor remitente',
  referredByProvider: '¿El paciente fue remitido por un proveedor?',
  externalProviderDirectory: {
    searchBy: 'Buscar por',
    npi: 'NPI',
    name: 'Nombre',
    firstName: 'Nombre',
    middleName: 'Segundo nombre',
    lastName: 'Apellido',
    state: 'Estado',
    search: 'Buscar',
    match: 'Proveedor encontrado',
    providerName: 'Nombre del proveedor',
    status: 'Estado',
    specialty: 'Especialidad',
    specialtyCode: 'Código de especialidad',
    organization: 'Organización',
    directAddress: 'Dirección de mensajería segura Direct',
    faxNumber: 'Número de fax',
    useProvider: 'Usar este proveedor',
    useEnteredProvider: 'Usar los datos introducidos',
    changeProvider: 'Cambiar proveedor',
    addProviderTitle: 'Agregar {0}',
    changeProviderTitle: 'Cambiar {0}',
    removeProviderTitle: 'Eliminar {0}',
    removeProviderConfirmation: '¿Eliminar {0}? El proveedor seguirá disponible en el directorio de proveedores.',
    providerSaved: 'Se guardó {0}.',
    providerRemoved: 'Se eliminó {0}.',
    searchAnother: 'Buscar otro proveedor',
    enterManually: 'Introducir manualmente',
    editManually: 'Editar manualmente',
    removeProvider: 'Eliminar proveedor',
    active: 'Activo',
    deactivated: 'Desactivado',
    manualEntryHelp: 'Introduzca los datos del proveedor y al menos un canal de entrega.',
    selectProviderRequired: 'Busque y seleccione un {0}, o introdúzcalo manualmente.',
    requiredProviderData: 'Se requieren el nombre, el apellido, un NPI válido y una dirección de mensajería segura Direct o un número de fax.',
    communicationChannelRequired: 'Se requiere una dirección de mensajería segura Direct o un número de fax.',
    nameRequired: 'Se requieren el nombre y el apellido del proveedor.',
    npiRequired: 'Se requiere el NPI del proveedor.',
    noResults: 'No se encontraron proveedores coincidentes.',
    searchFailed: 'La búsqueda del proveedor falló. Inténtelo de nuevo.',
    resolveFailed: 'La búsqueda del PCP falló. Puede buscar el proveedor manualmente.',
    partialResults: 'No se pudo acceder a algunos directorios de proveedores. Revise los resultados disponibles antes de continuar.',
    resolvedFromAthena: 'Se encontró el PCP en athenaOne. Revise los datos propuestos antes de usarlos.',
    pcpNotFound: 'No se encontró ningún PCP en athenaOne. Busque el proveedor manualmente.',
    pcpChannelMissing: 'El PCP encontrado en athenaOne no tiene un canal de comunicación utilizable. Busque otra fuente a continuación.',
    pcpNpiMissing: 'El PCP encontrado en athenaOne no tiene NPI. Busque el proveedor manualmente.',
    athenaMappingMissing: 'Este paciente no está vinculado a athenaOne. Busque el PCP manualmente.',
    athenaDisabled: 'La búsqueda de proveedores en athenaOne no está habilitada. Busque el PCP manualmente.',
  },
  invalidNpi: 'Ingrese un NPI válido de 10 dígitos.',
  invalidNpiChecksum: 'La suma de comprobación del NPI no coincide.',
  treatmentPlan: 'Plan de tratamiento',
  accessRegistrationSubmitted: 'La solicitud se envió correctamente a CMS. El estado de la inscripción puede cambiar después de la respuesta de CMS.',
  accessEligibilityAwaitingConfirmation: 'En espera de la confirmación de elegibilidad de CMS',
  accessEligibilityFailed: 'Fallida',
  accessEnrollmentEligibilitySubmitted: 'El diagnóstico se envió a CMS para otra verificación de elegibilidad. El estado de la inscripción puede cambiar después de la respuesta de CMS.',
  accessAlignmentSubmitted: 'El paciente fue inscrito y la solicitud de alineación se envió a CMS.',
  accessAlignmentAwaitingConfirmation: 'En espera de la confirmación de alineación de CMS',
  alignment: 'Alineación',
  lastAlignmentResult: 'Último resultado de alineación',
  enrollmentStart: 'Enrollment Start',
  enrollmentEnd: 'Enrollment End',
  enrollmentDateTimezoneTooltip: '{0} - {1} timezone',
  agreementToSpeakWithProvider: 'Agreement to speak with Provider',
  consent: 'Consent',
  outreachStatus: 'Outreach Status',
  outreachStatusDate: 'Outreach Status Date',
  nextOutreachDate: 'Next Outreach Date',
  changeOutreachStatus: 'Change outreach status',
  outreachStatusEnum: {
    pending: 'Pending',
    set: 'Consents to Provider Call',
    retry: 'Retry',
    not_eligible: 'Not Eligible',
    declined: 'Declined',
  },
  extendedOutreachStatusEnum: {
    rpmOrderPending: 'RPM Order Pending',
    rpmOrderApproved: 'RPM Order Approved',
    ineligible: 'Ineligible',
    patientOutreachInProcess: 'Patient Outreach in Process',
    deferred: 'Deferred',
    patientDeclined: 'Patient Declined',
    unableToReach: 'Unable to Reach',
    rpmOrderDeclined: 'RPM Order Declined',
    noProviderRpmOrderReponse: 'No Provider RPM Order Reponse',
  },
  outreachStatusForEnrollmentWarning: 'Must be set to "{0}" before enrolling patient',
  patientStateChangeWarning: 'Patient will be moved to "{0}" state',
  reasonForUnregisteringPatient: 'Reason for unregistering patient',
  reasonForChangingOutreachStatus: 'Reason for changing outreach status',
  activate: 'Activate',
  assignKit: 'Assign Kit',
  assignKitAndActivationSchedule: 'Assign Kit and Activation Schedule',
  enrollmentKit: 'Enrollment Kit',
  consentUploadInstruction: 'Signed consent can be uploaded via "Documents"',
  patientRegisteredInfo: '{0} has been registered',
  patientEnrolledInfo: '{0} has been enrolled to the system',
  patientActivatedInfo: 'Patient {0} has been activated',
  endDateSet: 'Enrollment end date for patient {0} has beed set',
  welcomeSmsSent: 'Welcome SMS was scheduled to be sent to patient {0}',
  kitAssignedInfo: 'Kit {0} has been assigned to patient {1}',
  wheresKitIdText:
    'You will find a 20 digit alphanumeric code printed here on the kit packaging. You should only need to enter the first few letters.',
  noCapAvailable: 'No cap available',
  avgTimeDelta: 'Avg. Time Delta',
  tutorial: 'Tutorial',
  onboarding: 'Onboarding',
  enrollment: 'Enrollment',
  enrollments: 'Enrollments',
  monitoring: 'Monitoring',
  sendTo: 'Send to',
  from: 'From',
  message: 'Message',
  standardMessage: 'Standard Message',
  phiSafeMessage: 'PHI Safe Message',
  isPhiSafe: 'Is PHI Safe',
  messageUnchanged: 'Message unchanged',
  SMSSent: 'Text sent successfully',
  SMSFailed: 'Unable to send Text',
  sendText: 'Send Text',
  uploadPatientList: 'Upload Patient List',
  patientListFiles: 'Patient List Files',
  perfusionIndex: 'Perfusion Index',
  maxAndRemainingChars: 'Max characters: {0} ({1} remaining)',
  maxAndOverflowChars: 'Max characters: {0} (too long by {1})',
  remainingChar: '{0} character remaining',
  remainingChars: '{0} characters remaining',
  selectTheme: 'Please select theme',
  theme: {
    blue: 'Blue',
    red: 'Red',
    petrol: 'Petrol',
    white: 'White (esi)',
  },
  selectBrand: 'Please select brand',
  lteUserInstructions: 'LTE User Instructions',
  rpmQuickGuide: 'RPM Quick Guide',
  rxcapPortal: 'RxCap Portal',
  smartCapPatientInstVideo: 'Smart Cap Patient Instruction Video',
  role: 'Role',
  selectRole: 'Select role',
  orgConfigUpdated: 'Org config updated',
  noPermissionsForModule: 'No permissions for this module.',
  modules: 'Modules',
  deviceMappings: 'Device Mappings',
  deviceMappingsUpdated: 'Device mappings updated',
  disableDeviceTitle: 'Disable device',
  disableDeviceMappingsWarning:
    'Disabling this device may prevent automatic fulfillment for organizations that use or inherit it. '
    + 'Configured mappings remain visible, but this device will no longer be selected for new orders.',
  noDevicesForVital: 'No devices measure this vital.',
  selectModuleToConfigure: 'Select a module to configure.',
  deviceMappingSourceOrg: 'Custom for this organization',
  deviceMappingSourceInherited: 'Inherited from {0}',
  deviceMappingSourceParentOrg: 'a parent organization',
  deviceMappingSourceGlobal: 'Platform default',
  deviceMappingDivergingVitals:
    'The vitals in this module are configured differently; saving applies the list below to all of them.',
  deviceMappingSourceNotConfigured: 'Not configured',
  deviceMappingNoDeviceWarning:
    'No device configured — enrollments that select this module will be rejected.',
  deviceMappingNoAvailableDeviceWarning:
    'No orderable device — enrollments that select this module will be rejected.',
  deviceUnavailableDeleted: 'device no longer exists',
  deviceUnavailableNotOrderable: 'withdrawn by RxCap',
  deviceUnavailableOrgDisabled: 'disabled in this organization catalog',
  deviceUnavailableOrgDisabledInherited: 'disabled by a parent organization',
  deviceUnavailableSmartmeterUnconfigured: 'SmartMeter SKU not configured',
  deviceUnavailableVitalNotSupported: 'does not measure this vital',
  deviceMappingCrossGroupAdvisory:
    'Patients enrolled for {0} and {1} may receive two separate devices: '
    + '{2} for {0} and {3} for {1}. The {0} device can also measure {1}; '
    + 'add {2} to the {1} preference list to allow one device to cover both.',
  deviceMappingHeartRateNote:
    'Patients whose order already has a device that measures heart rate (a blood-pressure cuff, pulse oximeter or wrist band) get heart rate from it. '
    + 'This list is used when heart rate needs its own device: heart-rate-only patients, or a clinician\'s request for a separate heart-rate device, '
    + 'which never picks a blood-pressure cuff or pulse oximeter.',
  deviceMappingsCopyFromParent: 'Copy parent settings',
  deviceMappingsCopyFromParentTooltip:
    'Merge the parent\'s effective preference list into this module. Existing order is kept, missing devices are appended, and the result becomes this organization\'s setting.',
  deviceMappingsCopyFromGlobal: 'Copy global settings',
  deviceMappingsCopyFromGlobalTooltip:
    'Merge the platform default preference list into this module. Existing order is kept, missing devices are appended, and the result becomes this organization\'s setting.',
  deviceMappingsResetToInherited: 'Reset to inherited',
  deviceMappingsResetToInheritedTooltip:
    'Delete this organization\'s setting for this module and resume inheritance from its parent, or from platform defaults when no parent mapping exists.',
  deviceMappingsCopied: '{0} device(s) added to this organization',
  deviceMappingsCopiedNothingNew: 'Now managed by this organization',
  deviceMappingsCopiedDivergent:
    'Copied {0} settings from {1} and normalized this organization. The source remains configured differently.',
  deviceMappingsReset: 'Device mappings reset to inherited',
  deviceMappingsResetDivergentTitle: 'Inherited settings differ',
  deviceMappingsResetAnyway: 'Reset anyway',
  deviceMappingsSaveFailed: 'Failed to save device mappings',
  deviceMappingsCopyFailed: 'Failed to copy device mappings',
  deviceMappingsResetFailed: 'Failed to reset device mappings',
  userPermissionsSaved: 'User permissions saved',
  contactUs: 'Contact Us',
  videos: 'Videos',
  gettingStart: 'Getting started using the portal',
  gettingStartDesc:
    'Just joined? Watch here to cover all the key areas you will need to learn to successfully manage your patients.',
  onboardingDesc: 'Watch this if you need a quick review of how to onboard new patients to the portal.',
  enrollementDesc: 'Watch this if you need a quick review of how to enroll new patients to the portal.',
  monitoringDesc: 'Watch this if you need a quick review of how to monitor your patients metrics.',
  billingDesc: 'Watch this if you need a quick review of how to manage your billing for your billing clinician.',
  smartCapRTMDesc:
    'You can send this video to your patients, so they can quickly learn about how to use their smart cap',
  SmartCapRTM: 'Smart Cap for RTM',
  network: 'Network',
  networkTime: 'Last network time',
  rxcapLaunchOutlineExternal: 'RxCap Launch Outline',
  setDefault: 'Set default',
  authenticationHeader: 'Authentication Header',
  authHeader: 'Auth Header',
  pauseAPI: 'Pause API',
  successfieldRequired: 'Success Field Required',
  maxTimeWithoutEvents: 'Maximum Time Without Event',
  maxBatchSize: 'Max Batch Size',
  errorMaxBatchSize: 'Must be greater than 0',
  successFieldRequired: 'Success Field',
  required: 'Required',
  notRequired: 'Not Required',
  apiStatus: {
    active: 'Active',
    paused: 'Paused',
  },
  missedDoses: 'Missed doses',
  alertCleared: 'Alert successfully cleared',
  size: 'Size',
  online: 'Online',
  offline: 'Offline',
  blocked: 'Blocked',
  suspended: 'Suspended',
  unassigned: 'Unassigned',
  manufactured: 'Manufactured',
  manufacturer: 'Manufacturer',
  deleted: 'Deleted',
  missedReadingsTreshold: '{0} saved successfully',
  manage: 'Manage',
  atmocubeValues: {
    tvoc: 'TVOC',
    vocIndex: 'VOC Index',
    noxIndex: 'NOx Index',
    relativeHumidity: 'Relative Humidity',
    atmosphericPressure: 'Atmospheric Pressure',
    noiseLevels: 'Noise Levels',
    lightIntensity: 'Light Intensity',
    formaldehyde: 'Formaldehyde',
    occupancy: 'Occupancy',
  },
  hailieEventSubTypes: {
    inhalation: 'Inhalation',
    shakeDetection: 'Shake Detection',
    respirationFlow: 'Respiration Flow',
    respirationTiming: 'Respiration Timing',
  },
  passwordTexts: {
    yourPasswordShouldBe: 'Su contraseña debe tener',
    eightTo32Characters: 'de 8 a 32 caracteres',
    atLeastOneDigit: 'lo menos uno número',
    atLeastOneUpperCase: 'lo menos uno mayúscula',
    atLeastOneLowerCase: 'lo menos uno minúscula',
    atLeastOneSpecialCharacter: 'lo menos uno símbolo (~!*^@#$%&)',
    matchWithConfirmField: 'coincidir con el campo de confirmación',
    oldPasswordIsRequired: 'Se requiere contraseña antigua',
    notAllowedCharacters: 'Caracteres no permitidos',
  },
  startDateShouldBeBeforeEndDate: 'Start date should be before end date',
  allowedDataRangeIs6Months: 'Maximum allowed data range is 6 months',
  allowedDataRangeIsXMonths: 'Maximum allowed data range is {0} months',
  noDataInGivenPeriod: 'No data was available in the chosen period. Please select different time period.',
  timeThisMonth: 'Time this Month',
  todaysMedications: "Today's Medications",
  statusEnum: {
    pending: 'Pending',
    submitted: 'Submitted',
    onhold: 'On-Hold',
    enabled: 'Enabled',
    disabled: 'Disabled',
    active: 'Active',
    inactive: 'Inactive',
    forbidden: 'No access',
    invited: 'Invited',
    configured: 'Enabled',
  },
  copy: 'Copy',
  copyToClipboard: 'Copy to clipboard',
  copiedToClipboard: 'Copied to clipboard',
  publicKeyHasBeenDeleted: 'Public key has been deleted, all tokens are now revoked',
  publicKeyIsInvalid: 'Public key is invalid',
  noticeSaveCredentials: 'Notice: Please save those credentials. It will not be possible to obtain them again.',
  credentialsCopiedToClipboard: 'Credentials copied to clipboard',
  applyFilters: 'Apply page filters',
  billableTime: 'Billable time',
  pm25: 'PM 2.5',
  healthCenter: 'Health Center',
  yourDevices: 'Your Devices',
  yourMedications: 'Your Medications',
  year: 'Year',
  unitsEnum: {
    lbs: 'lbs',
    kg: 'kg',
    minutes: 'mins',
    hours: 'hours',
  },
  dailyAverage: 'Daily Average',
  hourlyAverage: 'Hourly Average',
  dateRange: 'Date Range',
  portalAccess: 'Portal Access',
  editUser: 'Edit User',
  addUser: 'Add User',
  addRemoveUsers: 'Add / Remove Users',
  userName: 'User Name',
  resetPasswordMethodPrompt: 'How would you like to reset your password?',
  changePasswordWarning: 'Do you want to change your password? We will send the password reset link to ',
  userSaved: 'User Details for {0} have been saved',
  rolesEnum: {
    organization_manager: 'Organization Manager',
    capmanager: 'Cap Manager',
    doctor: 'Admin',
  },
  rolesPluralEnum: {
    organization_manager: 'Organization Managers',
    capmanager: 'Cap Managers',
    doctor: 'Admins',
  },
  confirmPasswordReset: 'Confirm Password Reset',
  confirmReinvite: 'Confirm Invite Resend',
  dateRangeAdjustedWarning:
    'The maximum date range allowed for download is 6 months. The start date of your selected date range has been adjusted to fit within this limit.',
  maximumDateRangeAllowedMonths: 'The maximum date range allowed is {0} months.',
  selectDateRangeOrLeaveBlank: 'Select date range or leave blank to get all data',
  scheduleEnded: 'Schedule Ended',
  assignedDate: 'Assigned Date',
  unassignedDate: 'Unassigned Date',
  invalidTimezone: 'Invalid Timezone',
  dataRangeAberraviations: {
    day: 'D',
    week: 'W',
    twoWeeks: '2W',
    month: 'M',
    sixMonths: '6M',
    year: 'Y',
  },
  invalidTag: 'Invalid tag',
  insertTag: 'Insert tag',
  replaceMessage: 'Replace message',
  insertIntoMessage: 'Insert into message',
  messageTagHelp: {
    Name: 'Patient name from the patient profile.',
    PatientName: 'Patient name from the patient profile.',
    CaregiverName: 'Caregiver name from the patient record.',
    Medicine: 'Medication name from the patient schedule.',
    Time: 'Scheduled notification time from the patient schedule.',
    MinutesToTake: 'Minutes remaining before the scheduled dose.',
    MinutesAfterTake: 'Minutes since the scheduled dose.',
    Code: 'One-time verification code.',
    Alert: 'Text of the alert that triggered this message.',
    Link: 'Link to the scheduled video visit.',
    DateTime: 'Date and time of the scheduled video visit.',
    PharmacyName: 'Organization name used in SMS branding.',
    ExpectedDelivery: 'Shipment delivery date: estimated before delivery or actual after delivery.',
    SupportNumber: 'SMS sender phone number currently used as the contact number.',
    StreakCount: 'Number of consecutive days in the current streak.',
    MilestoneName: 'Name of the milestone reached.',
    EncouragementEmoji: 'Emoji chosen for the milestone message.',
    CompliantDays: 'Number of days the patient was compliant.',
    TotalDays: 'Total number of days in the milestone period.',
    ThresholdDays: 'Day threshold configured for this milestone.',
    ProgramName: 'Name of the patient program.',
    CompletionDate: 'Date the enrollment was completed.',
    DeviceName: 'Name of the device involved in the alert.',
    NearestDose: 'Time of the nearest scheduled dose.',
    PatientPortalURL: 'Patient portal link from organization branding.',
    NextDoseTime: 'Time of the next dose in schedules linked to this enrollment.',
    NextDoseMedication: 'Medication for the next dose in this enrollment.',
    NextDoseDate: 'Date of the next dose in this enrollment.',
    DeviceInstructions: 'Instruction video links for devices in this enrollment. Configure them under Admin → Devices → Files or Organization → Configuration → Files.',
    MissedDays: 'Number of consecutive days without a reading.',
    VitalName: 'Name of the vital sign that was not measured.',
  },
  awaitingBleReset: 'Awaiting BLE Reset',
  resetBle: 'Reset BLE chip',
  enableDexcomIntegration: 'Enable Dexcom integration',
  resetDexcomIntegration: 'Re-enable Dexcom integration',
  disableDexcomIntegration: 'Disable Dexcom integration',
  enableDexcomIntegrationConfirm: 'Are you sure you want to enable Dexcom integration for patient {0}?',
  enableDexcomIntegrationSuccess: 'Dexcom integration enabled successfully',
  disableDexcomIntegrationConfirm: 'Are you sure you want to disable Dexcom integration for patient {0}?',
  disableDexcomIntegrationSuccess: 'Dexcom integration disabled successfully',
  authorizeRxcapForDexcom:
    'To configure your device, please authorize RxCap to access your Dexcom data. We will redirect you to Dexcom website, where you will need to log in and accept our authorization.',
  reAuthorizeRxcapForDexcom:
    'Our authorization to access your Dexcom data has expired or was revoked. Please authorize RxCap to access your Dexcom data. We will redirect you to Dexcom website, where you will need to log in and accept our authorization.',
  notNow: 'Not now',
  dexcomDeviceConfiguration: 'Dexcom Device Configuration',
  selectDexcomKit: 'Seleccione el kit para el dispositivo Dexcom',
  dexcomDeviceConfigured: 'Dexcom Device Configured',
  dexcomDeviceConfiguredSuccess:
    'Your Dexcom device has been configured successfully. Now, the data synced with your dexcom app on your phone will be available to your care provider',
  dexcomInvalidCode: 'Invalid code',
  dexcomCodeNotMatchingPatient:
    'The code obtained from Dexcom was not issued for this patient. Please contact your care provider for assistance.',
  dexcomConfigurationFailed: 'Dexcom configuration failed',
  dexcomConfigurationFailedText:
    'There was a problem configuring your Dexcom device. Please contact your care provider for assistance.',
  noReadingsSince: 'No readings since',
  newNotesSince: 'New notes since',
  numberOfDays: 'Number of days',
  allowedRangeWarning: 'Allowed range is {0}-{1}',
  coagulation: 'Coagulación',
  bulkAddTexts: {
    selectSheet: 'Select Excel sheet to upload',
    multipleSheets: 'Excel Sheet',
    noRows: 'No rows found in the selected sheet',
    columns: 'Columns',
    matchedColumns: 'Matched column headers for import:',
    unmatchedColumns: 'Unmatched column headers excluded from import:',
    newConditionsFound: 'New conditions found',
    unknownConditionsFound: 'Unknown conditions found',
    patientsWithNoCondition: 'Patients with no condition',
    conditionsToAdd: 'Following ICD10 conditions have been found that will be added to the organization',
    unrecognizedConditions:
      'The following conditions are not valid ICD10 codes and will be replaced as ‘Unknown’. Please adjust the conditions in the file or in patient record after import',
    unknownCondition: '{0} patient(s) have no conditions. They will be assigned to ‘{1}’ condition.',
    missingColumns: 'The following columns are missing from the selected sheet:',
    noFacility:
      '{0} patients have no facility or their facility is not added to organization. They will be assigned to ‘{1}’ facility',
    newFacilitiesInfo: '{0} new facilities have been found that will be added to the organization',
    patientsWithNoFacility: 'Patients with no facility',
    unknownFacilitiesFound: 'Unknown facilities found',
    errorReadingFile: 'Error while reading file',
    noPatientsInFile: 'No patients found in the file',
    duplicatePhoneNumberWarning: 'Patient with phone number {0} already exists. New patient will be created without phone number.',
    patientsWithPhoneNumberRemovedWarning: '{0} patient(s) had their phone numbers removed due to duplication.',
    patientPhoneRemovedNote: 'Patient phone number was removed during import due to duplication. The phone number was {0}.',
  },
  bulkUploadReview: {
    patients: 'Patients',
    state: 'State',
    tier: 'Tier',
    sourceRows: 'Source Rows',
    targetOrg: 'Target Organization',
    changedFields: 'Changed Fields',
    track: 'Programa',
    errors: 'Errors',
    details: 'Details',
    noPatients: 'No patients found',
    before: 'Before',
    after: 'After',
    patientPreview: 'Patient Preview',
    total: 'Total',
    byState: 'By state',
    byTier: 'By tier',
    filterState: 'Filter by state',
    filterTier: 'Filter by tier',
    name: 'Nombre',
    action: 'Acción',
    field: 'Campo',
    requested: 'Solicitado',
    openPatient: 'Abrir paciente',
    changed: 'Cambiado',
    fields: {
      mrn: 'MRN',
      pharmacyPatientId: 'ID de paciente de farmacia',
      medicareBeneficiaryId: 'MBI',
      firstName: 'Nombre',
      lastName: 'Apellido',
      dateOfBirth: 'Fecha de nacimiento',
      gender: 'Género',
      language: 'Idioma',
      timezone: 'Zona horaria',
      primaryPhoneNo: 'Teléfono principal',
      textPhoneNo: 'Teléfono móvil',
      email: 'Correo electrónico',
      homeAddress: 'Dirección',
      address: 'Dirección',
      conditions: 'Condiciones',
      insurance: 'Seguro',
      centerDetails: 'Detalles del centro',
      transplantDetails: 'Detalles del trasplante',
      medications: 'Medicamentos',
    },
    actions: {
      create: 'Crear',
      update: 'Actualizar',
    },
    states: {
      refining: 'En verificación',
      proposed: 'Propuesto',
      unchanged: 'Sin cambios',
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      applied: 'Aplicado',
      error: 'Error',
    },
    sheetStatuses: {
      awaiting_confirmation: 'Pendiente de confirmación',
      in_progress: 'En curso',
      awaiting_review: 'Pendiente de revisión',
      finished: 'Finalizado',
    },
    reasons: {
      name_dob_only_merge: 'Filas unidas solo por nombre y fecha de nacimiento: confirme que son la misma persona',
      phone_will_be_removed: 'El teléfono móvil pertenece a otro paciente: puede ser ese paciente o un familiar que comparte el teléfono. Al aceptar se crea un paciente nuevo sin el teléfono y se añade como nota',
      mbi_conflict: 'El MBI pertenece a otro paciente',
      mrn_conflict: 'El MRN pertenece a otro paciente',
      source_no_match: 'No encontrado en {source}: el paciente no se vinculará',
      source_unavailable: 'No se pudo contactar con {source}: vuelva a verificar el paciente más tarde para vincularlo',
      filled_from_source: 'Tomado de {source}: {fields}',
      source_conditions_skipped: '{count} problema(s) de {source} omitidos: la organización no tiene una condición correspondiente',
      source_conditions_unavailable: '{source} no devolvió la lista de problemas: no se tomaron condiciones de él',
      missing_first_name: 'Falta el nombre',
      missing_last_name: 'Falta el apellido',
      missing_date_of_birth: 'Falta la fecha de nacimiento',
      pcp_missing: 'Sin proveedor de atención primaria: el PCP de la hoja necesita un NPI válido que el Registro NPI conozca',
      pcp_incomplete: 'El proveedor de atención primaria no tiene dirección Direct ni fax: complételo antes de enviar actualizaciones de atención',
      pcp_npi_invalid: 'El NPI del PCP de la hoja no es un NPI válido: se ignoró',
      pcp_not_found: '{source} no conoce el NPI del PCP de la hoja',
      pcp_change: 'La hoja reemplaza el proveedor de atención primaria del paciente por otro: acepte este paciente por separado',
      pcp_not_individual: 'El NPI del PCP de la hoja es de una organización, no de un proveedor: se ignoró',
      source_record_not_found: '{source} no conoce el ID de paciente de la hoja: revise el ID y la práctica',
      source_not_configured: 'La hoja indica un paciente de {source}, pero la organización no tiene {source} configurado',
      source_identity_mismatch: 'El paciente de {source} tiene otro nombre o fecha de nacimiento',
      source_link_conflict: 'El paciente de {source} está vinculado a otro paciente, o este paciente a otro paciente de {source}',
      source_request_failed: '{source} rechazó la solicitud',
      athena_practice_ambiguous: 'La organización tiene varias prácticas de athenaOne: añada una columna de práctica a la hoja',
      invalid_value: 'Una celda contiene un valor que su columna no admite',
      identity_change: 'La hoja cambia {fields} del paciente elegido',
      phone_owner_changed: 'Otro paciente tomó el teléfono móvil desde la revisión: vuelva a verificar el paciente',
      target_org_has_sub_orgs: 'La organización tiene suborganizaciones: un paciente nuevo debe ir a una de ellas. Asigne la fila con el mapeo de organizaciones',
    },
    sources: {
      local: 'Nuestros pacientes',
      athena: 'athenaOne',
      nppes: 'NPPES',
    },
    andMore: '(y {0} más)',
    level: 'Nivel',
    levels: {
      error: 'Error',
      warning: 'Advertencia',
      note: 'Nota',
    },
    rowNumber: 'Fila',
    columnMappedTo: 'Asignada a {0} (#{1}): {2}',
    columnNotUsed: 'La carga no la usa',
    dataOutcomes: {
      matched: 'Encontrado',
      no_match: 'No encontrado',
      choice_pending: 'Elegir',
      unavailable: 'No disponible',
      not_applicable: 'No comprobado',
      failed: 'Falló',
    },
    outcomes: {
      matched: 'Paciente encontrado',
      no_match: 'Paciente no encontrado',
      choice_pending: 'Elija el paciente',
      unavailable: 'No disponible',
      not_applicable: 'No verificado',
      failed: 'Error',
    },
    verdicts: {
      certain: 'El mismo paciente',
      unresolved: 'Posiblemente el mismo paciente',
      eliminated: 'Otro paciente',
      conflict: 'Conflicto',
    },
    evidence: {
      same: 'Igual que en la hoja',
      different: 'Distinto de la hoja',
      unknown: 'Nada que comparar',
    },
    chooseNone: {
      local: 'Ninguno: crear un paciente nuevo',
      athena: 'No está en athenaOne',
      other: 'Ninguno',
    },
    noneChosen: {
      local: 'Se eligió un paciente nuevo',
      athena: 'Se eligió que no está en athenaOne',
      other: 'Se eligió ninguno',
    },
    openOwner: {
      mbi_conflict: 'Abrir el paciente que tiene el MBI',
      mrn_conflict: 'Abrir el paciente que tiene el MRN',
    },
    choicePending: 'Elija el paciente',
    choicePendingHint: 'Varios registros podrían ser este paciente: abra los detalles y elija uno antes de aceptar',
    sourcePending: 'En verificación',
    record: 'Registro',
    evidenceHeader: 'Comparado con la hoja',
    verdict: 'Veredicto',
    chosen: 'Elegido',
    thisIsThePatient: 'Este es el paciente',
    confirmCreateNew: '¿Crear un paciente nuevo en lugar de actualizar uno de estos? Si el paciente nuevo coincide con otro paciente (p. ej. el MBI), la creación falla y puede corregir ese paciente y volver a verificar.',
    recheck: 'Volver a verificar',
    stillChecking: '{0} sigue verificando: {1}',
    choicesWaiting: 'Esperando su elección: {0}',
    prepareForReview: 'Preparar pacientes para revisión',
    retryFailed: 'Reintentar pacientes fallidos',
    issues: 'Mensajes',
    uncertain: 'Incierto',
    filterAction: 'Filtrar por acción',
    reviewed: 'Revisado',
    accept: 'Aceptar',
    reject: 'Rechazar',
    acceptMatched: 'Aceptar coincidentes ({0})',
    acceptNew: 'Aceptar pacientes nuevos ({0})',
    rejectRemaining: 'Rechazar restantes ({0})',
    confirmAcceptMatched: '¿Aceptar {0} pacientes coincidentes? Sus registros se actualizarán como se muestra.',
    confirmAcceptNew: '¿Aceptar {0} pacientes nuevos? Se crearán como se muestra.',
    confirmRejectRemaining: '¿Rechazar {0} propuestas restantes? No se escribirá nada para ellas.',
    uncertainNotIncluded: 'Los pacientes inciertos no se incluyen; acéptelos uno por uno.',
    decisionDone: 'Aceptados: {0}. Rechazados: {1}.',
    decisionAppliedLater: 'Los pacientes aceptados se guardan en segundo plano; los que cambiaron desde la planificación vuelven a revisión.',
  },
  lastLogin: 'Last login',
  validUntil: 'Valid until',
  changeDeviceState: 'Change device state',
  events: 'Eventos',
  changeOrgState: 'Change organization state',
  changeState: 'Change state',
  analytics: 'Analytics',
  maskPHIData: 'Mask PHI data',
  addEditConditions: 'Add / Edit Conditions',
  importedData: 'Imported Data',
  providerVisitSummary: 'Provider Visit Summary',
  answers: 'Answers',
  property: 'Property',
  record: 'Record',
  showExtendedData: 'Show Extended Data',
  prescriber: 'Prescriber',
  now: 'Now',
  shipping: {
    terminationShippingWarning: 'Esta inscripción tiene pedidos o envíos pendientes. Finalizar la inscripción no detendrá su tramitación. Contacte a la persona responsable de los envíos.',
    terminationOrders: 'Pedido(s)',
    terminationShipments: 'Envío(s)',
    endedEnrollmentWarning: 'Una inscripción vinculada ha finalizado. Revise si debe continuar la tramitación.',
    endedEnrollmentPatient: 'ID del paciente: {0}',
    endedEnrollments: 'Inscripción: {0}',
    endedEnrollmentSummary: '{0} — finalizada el {1}',

    shipments: 'Shipments',
    showInactivePatients: 'Mostrar pacientes inactivos',
    inactivePatientsTooltip: 'Los pacientes inactivos están pausados o eliminados de forma lógica. Esta opción incluye únicamente sus envíos históricos; no los reactiva ni modifica el acceso en otras partes.',
    patientsAwaitingKit: 'Patients Awaiting Kit',
    shipping: 'Shipping',
    recent: 'Recent',
    recentDeliveries: 'Recent Deliveries',
    deviceModels: 'Device Models',
    deliveriesCount: 'Deliveries',
    latestDelivered: 'Latest Delivered',
    markDeliveryReviewed: 'Mark as Reviewed',
    markDeliveryReviewedQuestion: 'Do you want to mark this delivery as reviewed?',
    deliveryReviewedSuccessfully: 'Delivery marked as reviewed',
    unmarkDeliveryReviewed: 'Un-mark as Reviewed',
    unmarkDeliveryReviewedQuestion: 'Do you want to move this delivery back to pending?',
    deliveryUnreviewedSuccessfully: 'Delivery moved back to pending',
    shippingStatus: 'Shipping Status',
    shippingAddress: 'Shipping Address',
    shippingMethod: 'Shipping Method',
    trackingNumber: 'Tracking Number',
    createShipment: 'Create Shipment',
    editShipment: 'Edit Shipment',
    sendPackage: 'Send Package',
    markAsDelivered: 'Mark as Delivered',
    markAsDeliveredQuestion: 'Do you want to mark shipment to {0} as delivered?',
    shippedDevices: 'Shipped Devices',
    shipmentStatuses: {
      new: 'In Progress',
      created: 'Created',
      in_transit: 'In Transit',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    orderStatuses: {
      pending_review: 'Pending Review',
      rejected_by_doctor: 'Rejected by Doctor',
      draft: 'Draft',
      open: 'Open',
      in_fulfillment: 'In Fulfillment',
      partially_delivered: 'Partially Delivered',
      cancelled: 'Cancelled',
      delivered: 'Delivered',
    },
    billingStatuses: {
      billable: 'Billable',
      unbillable: 'Unbillable',
      post_billable: 'Post-billable',
      sample: 'Sample',
      reassigned: 'Reassigned',
    },
    billingStatus: 'Billing Status',
    shipmentId: 'Shipment ID',
    order: 'Order',
    orderDetails: 'Order details',
    orderId: 'Order ID',
    orderNumber: 'Order Number',
    orderCategory: 'Order Category',
    providerOrderNumber: 'Provider Order Number',
    salesOrderNumber: 'Sales Order Number',
    shippingDate: 'Shipping Date',
    shippingCreated: 'Shipping created',
    deliveryDate: 'Delivered Date',
    eta: 'ETA',
    shippingCost: 'Shipping Cost',
    selectExistingKit: 'Select existing kit',
    createNewKit: 'Create new kit',
    creatingShipmentSuccess: 'Shipment created successfully',
    shipmentDetails: 'Shipment details',
    deliveryMethod: 'Delivery Method',
    shipDirectlyToPatient: 'Ship directly to patient',
    pickupAtPharmacy: 'Pickup at pharmacy',
    shippedByPharmacy: 'Shipped by pharmacy',
    prepareShipment: 'Prepare shipment',
    prepareAnotherShipment: 'Prepare another shipment',
    deliveryMethodLabels: {
      not_set: '-',
      ship_to_patient: 'Ship directly to patient',
      pickup_at_pharmacy: 'Pickup at pharmacy',
      shipped_by_pharmacy: 'Shipped by pharmacy',
    },
    prepareShipments: 'Prepare shipments',
    prepareShipmentsQuestion: 'Do you want to prepare shipments for {0} order(s)?',
    prepareShipmentDisabledTooltip: 'Patient already has shipment in progress',
    shipmentsCreatedSuccess: 'Shipments created successfully',
    printShipmentDetails: 'Print Shipment Details',
    cancelShipment: 'Cancel Shipment',
    cancelShipmentQuestion: 'Do you want to cancel shipment to {0}?',
    cancelSmartmeterOrder: 'Cancel SmartMeter Order',
    cancelSmartmeterOrderQuestion: 'Do you want to cancel the SmartMeter order for {0}? SmartMeter will stop fulfillment and this shipment will be cancelled.',
    cancelSmartmeterOrderNotCancellable: 'This SmartMeter fulfillment is not in a cancellable state',
    kitShippedMessage: 'SMS to patient',
    orders: 'Orders',
    createOrder: 'Create Order',
    unlinkedHardwareWarning: 'This patient has hardware on {0} order(s) that are not tied to any program — check before creating another.',
    unlinkedHardwareShipped: 'shipment {0}',
    selectProgramsForOrder: 'Select the programs for this order',
    oneKitPerOrder: 'one order ships one kit - select several programs only when a single kit covers them all',
    editOrder: 'Edit Order',
    deleteOrder: 'Delete Order',
    cancelOrder: 'Cancel Order',
    deleteOrderQuestion: 'Do you want to delete order {0}?',
    cancelOrderQuestion: 'Do you want to cancel order {0}?',
    placeOrderQuestion: 'Do you want to place order {0}?',
    placeOrder: 'Place Order',
    smartmeterOrder: 'Smartmeter Order',
    smartmeterOrderId: 'Smartmeter Order ID',
    placeSmartmeterOrder: 'Place order with Smartmeter',
    placeSmartmeterOrderQuestion: 'Do you want to place order for devices: {0} for patient {1} with Smartmeter?',
    smartmeterOrderPlacedSuccessfully: 'Pedido de Smartmeter realizado correctamente',
    variants: 'Variantes',
    smartmeterSku: 'SKU de Smartmeter',
    smartmeterConfigureSkuFor: 'Configurar SKU de Smartmeter para {0}',
    smartmeterConfigureSkuFailed: 'No se pudo configurar el SKU de Smartmeter',
    smartmeterSaveAnyway: '¿Guardar de todos modos?',
    smartmeterProposedSkusForModel: 'SKUs propuestos para {0}',
    smartmeterOtherTypeKits: 'Otros kits de {0}',
    smartmeterDifferentDeviceKits: 'Kits de otros dispositivos (requiere anulación)',
    smartmeterAccessorySkus: 'Accesorios / servicios (no incluyen dispositivo)',
    smartmeterOverrideSku: 'Anular SKU (opcional)',
    smartmeterNoOverride: 'Sin anulación',
    smartmeterAckSkuWithoutDevice: 'Confirmo que este pedido envía intencionalmente artículos de accesorio/servicio sin dispositivo.',
    smartmeterAckSkuModelMismatch: 'Confirmo que la sustitución por una categoría de dispositivo diferente es intencional.',
    smartmeterAddress2Rejected: 'I confirm the address line 2 is correct and should be used for shipping.',
    fixAddress2OrConfirm: 'Please fix address line 2 or confirm it is correct.',
    smartmeterOrderAlreadyPlaced: 'Smartmeter order already placed',
    smartmeterItems: 'Artículos de SmartMeter',
    smartmeterItemSku: 'SKU',
    smartmeterItemName: 'Artículo',
    smartmeterItemQuantity: 'Cant.',
    smartmeterSkuOverride: 'Anulado — pedido: {0}',
    smartmeterOrderStatusEnum: {
      submitted: 'Submitted',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      error: 'Error',
    },
    fulfillmentProvider: 'Fulfillment Provider',
    vendorStatus: 'Vendor Status',
    recipientName: 'Recipient Name',
    recipientPhone: 'Recipient Phone',
    recipientEmail: 'Recipient Email',
    orderType: 'Order Type',
    orderTypes: {
      standard: 'Standard',
      sample: 'Sample',
      replacement: 'Replacement',
    },
    orderCategories: {
      bulk: 'Bulk',
      direct: 'Direct',
    },
    shippingFlows: {
      outbound: 'Outbound',
      return: 'Return',
    },
    shippingFlow: 'Shipping Flow',
    patientAddress: 'Patient Address',
    contactDetails: 'Contact Details',
    organizationAddress: 'Organization Address',
    patientContactDetails: 'Patient Contact Details',
    organizationContactDetails: 'Organization Contact Details',
    targetOrganization: 'Target Organization',
    billedOrganization: 'Billed Organization',
    isPatientBilled: 'Is patient billed?',
    invoices: 'Invoices',
    itemsCount: 'Items Count',
    customer: 'Customer',
    invoiceDate: 'Invoice Date',
    shipmentDate: 'Shipment Date',
    assignedOrganizationDate: 'Assigned to Organization Date',
    unassignedOrganizationDate: 'Unassigned from Organization Date',
    orderNotes: 'Order Notes',
    deliveryDateBeforeInTransit: 'Delivery date cannot be before in transit date ({0})',
    deliveryDateBeforeCreatedAt: 'Delivery date cannot be before shipment creation date ({0})',
    acceptOrder: 'Accept Order',
    rejectOrder: 'Reject Order',
    acceptOrderQuestion: 'Do you want to accept order for patient {0}?',
    rejectOrderQuestion: 'Do you want to reject order for patient {0}?',
    orderAcceptedSuccessfully: 'Order accepted successfully',
    orderRejectedSuccessfully: 'Order rejected successfully',
    rejectOrderReason: 'Reason for rejecting order',
    orderCreated: 'Order created',
    smartOrderCreatedInfo: 'We`ve created a device order for patient {0}. Before we can ship the devices, the order needs to be accepted by your organization. Oders can be accepted or rejected in the "Shipping" → "Orders" tab. Click "Go to Orders" to navigate to Orders page.',
    goToOrders: 'Go to Orders',
    sendToReview: 'Send to review',
    createReturnShipmentOrder: 'Create return shipment order',
    pendingReturns: 'Pending Returns',
    devicesToReturn: 'Devices to return',
    newOrder: 'New Order',
    newReturnOrder: 'New Return Order',
    returnOrder: 'Return Order',
    markAsReturnedByPatient: 'Mark as Returned by Patient to Pharmacy',
    markAsReturnedByPatientQuestion: 'Do you want to mark kit {0} as returned by patient to pharmacy?',
    markAsReturnedByPatientSuccess: 'Kit marked as returned by patient to pharmacy successfully',
    droppedOffDate: 'Dropped off date',
    kitsToReturn: 'Kits to Return',
    sharedKitReturnWarning: 'Otro enrollment activo también utiliza este kit. No se creará una devolución automática mientras ese enrollment permanezca activo.',
    whatHappensToKit: 'What should happen to patient`s kit? ',
    returnToWarehouse: 'Return to warehouse',
    keepWithPatient: 'Keep with patient',
    waiveReturn: 'Waive Return',
    waiveReturnQuestion: 'Do you want to waive return for kit {0}?',
    waiveReturnSuccess: 'Kit return waived successfully',
    waiveReturnReason: 'Reason for waiving return',
    waivedDate: 'Waived date',
    waivedBy: 'Waived by',
    revokeWaiverReturn: 'Revoke Return Waiver',
    revokeWaiverReturnQuestion: 'Do you want to revoke return waiver for kit {0}?',
    revokeWaiverReturnSuccess: 'Kit return waiver revoked successfully',
    receivedAt: 'Received at',
    releaseFromInspection: 'Release from Inspection',
    releaseFromInspectionQuestion: 'Do you want to release kit {0} from inspection?',
    releaseFromInspectionSuccess: 'Kit released from inspection successfully',
    selectVariant: 'Select Variant',
    selectVariantForDevice: 'Select Variant for {0} Device(s)',
    variantFor: 'Variant for {0}',
    deviceUnavailable: 'No disponible',
    deviceUnavailableRemove: 'Ya no está disponible; elimínelo del pedido o reduzca su cantidad a 0',
    catalogLoadFailed: 'No se pudo cargar el catálogo de dispositivos. El pedido no se puede guardar hasta que se cargue el catálogo.',
    catalogRetry: 'Reintentar',
  },
  print: 'Print',
  printAll: 'Print All',
  inProgress: 'In Progress',
  defaultReminders: 'Default Reminders',
  files: 'Archivos',
  deviceInstructionVideoSection: 'Vídeos de instrucciones de dispositivos',
  deviceInstructionHelpLabel: 'Acerca de los vídeos de instrucciones de dispositivos',
  deviceInstructionHelp: 'Los enlaces a estos vídeos se envían en los SMS que usan la etiqueta [DeviceInstructions]. La configuración de la organización tiene prioridad sobre la global.',
  deviceInstructionAddFile: 'Añadir archivo',
  deviceInstructionAllLanguages: 'Todos los idiomas',
  deviceInstructionSource: 'Origen',
  deviceInstructionGlobal: 'Valores globales',
  deviceInstructionOrgLevels: { global: 'Global', partner: 'Socio', client: 'Cliente', location: 'Ubicación' },
  deviceInstructionNotConfigured: 'Sin configurar',
  deviceInstructionOwnSetting: 'Configuración propia',
  deviceInstructionTryAgain: 'Reintentar',
  deviceInstructionAssignedFile: 'Nombre del archivo',
  deviceInstructionVideoLanguage: 'Idioma del vídeo: {0}',
  deviceInstructionRemoveAssignment: 'Eliminar asignación',
  deviceInstructionRemoveAssignmentConfirm: '¿Eliminar la asignación de vídeo de {0} ({1})? Puede aparecer un vídeo heredado en su lugar.',
  deviceInstructionSelectPurpose: 'Seleccionar finalidad del archivo',
  deviceInstructionVideoPurpose: 'Vídeo de instrucciones del dispositivo',
  deviceInstructionUploadFile: 'Subir archivo',
  deviceInstructionAssignAt: 'Asignar en',
  deviceInstructionSelectOrganization: 'Seleccionar una organización',
  deviceInstructionOrganizationsError: 'No se pudieron cargar las organizaciones.',
  deviceInstructionAssignStored: 'Asignar vídeo',
  deviceInstructionPurpose: 'Finalidad',
  deviceInstructionDeviceType: 'Tipo de dispositivo',
  deviceInstructionNoTypes: 'No hay vídeos de instrucciones asignados aquí ni heredados.',
  deviceInstructionNoAssignments: 'No hay vídeos de instrucciones asignados.',
  deviceInstructionInherited: 'Heredado',
  deviceInstructionSelector: 'Dispositivo',
  deviceInstructionSelectorKind: 'Aplicar a',
  deviceInstructionModel: 'Modelo',
  deviceInstructionModelLabel: '{0} {1} ({2})',
  deviceInstructionTypeLabel: '{0}',
  deviceInstructionModelFallsBackToType: 'Este modelo utiliza el vídeo del tipo de dispositivo {0}.',
  deviceInstructionSelectKind: 'Seleccionar tipo de dispositivo o modelo',
  deviceInstructionSelectType: 'Seleccionar un tipo de dispositivo',
  deviceInstructionSearchModels: 'Buscar fabricante o modelo',
  deviceInstructionAlreadyConfigured: 'Este dispositivo ya tiene un vídeo en este nivel. Usa Sustituir vídeo en la fila inferior.',
  deviceInstructionChooseFileFirst: 'Elige un vídeo antes de subirlo.',
  deviceInstructionTargetsError: 'No se pudieron cargar los dispositivos disponibles.',
  deviceInstructionPreview: 'Vista previa',
  deviceInstructionHidePreview: 'Ocultar vista previa',
  deviceInstructionChooseFile: 'Elegir vídeo',
  deviceInstructionReplace: 'Sustituir vídeo',
  deviceInstructionUploading: 'Subiendo…',
  deviceInstructionLocalPreview: 'Vídeo seleccionado para {0}',
  deviceInstructionCurrentPreview: 'Vídeo actual para {0}',
  deviceInstructionInvalidFile: 'Elige un vídeo MP4 o WebM con la extensión correspondiente.',
  deviceInstructionFileTooLarge: 'Elige un vídeo no vacío de menos de 250 MiB.',
  deviceInstructionLoadError: 'No se pudieron cargar los vídeos de instrucciones.',
  deviceInstructionPreviewError: 'No se pudo mostrar la vista previa del vídeo.',
  deviceInstructionUploadError: 'No se pudo subir el vídeo.',
  deviceInstructionFileAlreadyExists: 'Ya existe un archivo con este nombre en el almacenamiento.',
  deviceInstructionCompleteUploadError: 'El archivo se subió, pero no se pudo registrar.',
  deviceInstructionReplaceTarget: 'Sustituir vídeo de {0} ({1})',
  deviceInstructionStorageFiles: 'Archivos del almacenamiento',
  deviceInstructionObjectName: 'Nombre del objeto',
  deviceInstructionFileType: 'Tipo',
  deviceInstructionFileSize: 'Tamaño',
  deviceInstructionCreated: 'Creado',
  deviceInstructionStorageStatus: 'Estado y uso',
  deviceInstructionAvailable: 'Disponible',
  deviceInstructionMissingStorage: 'Falta en el almacenamiento',
  deviceInstructionMissingStorageLabel: 'Advertencia: falta el archivo en el almacenamiento',
  deviceInstructionMissingStorageHelp: 'Este archivo de la base de datos no tiene un objeto correspondiente en el almacenamiento.',
  deviceInstructionUnregistered: 'No registrado',
  deviceInstructionUnregisteredLabel: 'Archivo de almacenamiento desconocido',
  deviceInstructionUnregisteredHelp: 'Este objeto del almacenamiento no está registrado en la base de datos.',
  deviceInstructionUsedOnce: 'Usado por 1 asignación',
  deviceInstructionUsedCount: 'Usado por {0} asignaciones',
  deviceInstructionNoStorageFiles: 'No se encontraron archivos en el almacenamiento ni en la base de datos.',
  deviceInstructionLoadingStorage: 'Cargando archivos del almacenamiento…',
  deviceInstructionStorageLoadError: 'No se pudieron cargar los archivos del almacenamiento.',
  deviceInstructionStoredVideo: 'Vídeo almacenado',
  deviceInstructionSelectStoredVideo: 'Seleccionar un vídeo almacenado',
  deviceInstructionNoStoredVideos: 'No hay vídeos asignables disponibles en el almacenamiento.',
  deviceInstructionAssigning: 'Asignando…',
  deviceInstructionStoredPreview: 'Vídeo almacenado {0}',
  deviceInstructionStoredPreviewError: 'No se pudo mostrar la vista previa del vídeo almacenado.',
  deviceInstructionStoredAssignError: 'No se pudo asignar el vídeo almacenado.',
  deviceInstructionDeleteStored: 'Eliminar archivo almacenado',
  deviceInstructionDeleteStoredFile: 'Eliminar archivo almacenado {0}',
  deviceInstructionDeleteStoredConfirm: '¿Eliminar {0} del almacenamiento?',
  defaultRemindersEnum: {
    "early_sms": 'Early SMS',
    "late_sms": 'Late SMS',
    "on_time_sms": 'On Time SMS',
    "low_battery_sms": 'Low Battery SMS',
    "missed_doses_sms": 'Missed Doses SMS',
    "missed_meas_sms": 'Missed Measurements SMS',
    "welcome_rtm_msg_sms": 'Welcome RTM Message SMS',
    "welcome_rpm_msg_sms": 'Welcome RPM Message SMS',
    "prepackage_rtm_msg_sms": 'Prepackage RTM Message SMS',
    "prepackage_rpm_msg_sms": 'Prepackage RPM Message SMS',
    "shipment_delivered_sms": 'Shipment Delivered SMS',
    "return_shipment_patient_sms": 'Return Shipment Patient SMS',
    "caregiver_invitation_sms": 'Caregiver Invitation SMS',
    "caregiver_deleted_sms": 'Caregiver Deleted SMS',
    "caregiver_subscribed_sms": 'Caregiver Subscribed SMS',
    "caregiver_unsubscribed_sms": 'Caregiver Unsubscribed SMS',
    "patient_alert_sms": 'Patient Alert SMS',
    "caregiver_alert_sms": 'Caregiver Alert SMS',
    "careprovider_alert_sms": 'Care Provider Alert SMS',
    "televisit_sms": 'Televisit SMS',
    "televisit_no_link_sms": 'Televisit No Link SMS',
    "first_take_congratulations_sms": 'First Take Congratulations SMS',
    "streak_achievement_sms": 'Streak Achievement SMS',
    "back_on_track_sms": 'Back on Track SMS',
    "dose_confirmed_sms": 'Dose Confirmed SMS',
    "first_dose_reminder_sms": 'First Dose Reminder SMS',
    "daily_evening_missed_dose_sms": 'Daily Evening Missed Dose SMS',
    "enrollment_completed_sms": 'Enrollment Completed SMS',
    "unused_device_sms": 'Unused Device SMS',
    "fault_cap_left_open_sms": 'Cap Left Open SMS',
    "communication_lost_sms": 'Communication Lost SMS',
    "sms_auto_reply": 'Auto Reply SMS',
    "caregiver_missed_meas_sms": 'Caregiver Missed Measurement SMS',
    "careprovider_missed_meas_sms": 'Care Provider Missed Measurement SMS',
  },
  milestoneReminderResetInfo: 'Restablecer un mensaje de hito elimina todos los mensajes de hitos personalizados de la organización para ese idioma. Se aplicarán los mensajes heredados.',
  defaultRemindersSaved: 'Recordatorios predeterminados guardados.',
  editDefaultReminders: 'Edit Default Reminders',
  printedAt: 'Printed at: {0}',
  thresholds: 'Thresholds',
  actionOptionOff: '{0} (OFF)',
  actionOptionOn: '{0} (ON)',
  isOrderable: 'Se puede pedir',
  allSelectedDefaultsEnabled: 'Todos los tipos de trabajo seleccionados ya están activados de forma predeterminada.',
  allSelectedDefaultsDisabled: 'Todos los tipos de trabajo seleccionados ya están desactivados de forma predeterminada.',
  allSelectedTasksEnabled: 'Todas las tareas seleccionadas ya están activadas.',
  allSelectedTasksDisabled: 'Todas las tareas seleccionadas ya están desactivadas.',
  globalTaskDefault: 'Predeterminado para nuevas organizaciones',
  systemWorkTypeMetadataExplanation: 'Tipo de trabajo del sistema: su nombre, secuencia y configuración de registro de tiempo están protegidos y no se pueden cambiar.',
  globalTaskDefaultExplanation: 'Se aplica solo a las organizaciones nuevas. Las organizaciones existentes no cambian.',
  enableTaskByDefault: 'Activar de forma predeterminada',
  disableTaskByDefault: 'Desactivar de forma predeterminada',
  workTypeMandatoryOrganizations: 'Obligatorio en las organizaciones: {0}.',
  workTypeAutoStartOrganizations: 'Tarea de inicio automático en las organizaciones: {0}.',
  workTypeDefaultsUpdated: 'Tareas actualizadas',
  workTypeDeleted: 'Tarea eliminada',
  unableToUpdateWorkTypeDefaults: 'No se pudieron actualizar los tipos de trabajo predeterminados',
  unableToDeleteWorkType: 'No se pudo eliminar la tarea',
  unableToSaveWorkType: 'No se pudo guardar la tarea',
  mandatoryTasks: 'Mandatory Tasks',
  missingMandatoryTasks: 'Missing Mandatory Task(s)',
  missingCPTCodes: 'Missing CPT code(s)',
  missingXMandatoryTasks: 'Missing {0} Mandatory Task(s)',
  cannotDisableMandatoryTasks: 'Las tareas obligatorias no se pueden desactivar.',
  selectMandatoryTasksFor: 'Select Mandatory Tasks for {0}',
  selectTask: 'Select Task',
  recentlyUsedTasks: 'Recently Used Tasks',
  otherTasks: 'Other Tasks',
  comments: 'Comments',
  dateOfEariestAlert: 'Date of earliest alert',
  reviewChart: 'Review Chart',
  selected: 'Selected',
  workTypes: 'Work Types',
  workType: 'Work Type',
  changeStatus: 'Change Status',
  eligibility: 'Eligibility',
  checkEligibility: 'Check Eligibility',
  refreshEligibilityStatus: 'Refresh Eligibility Status',
  eligibilityStatus: 'Eligibility Status',
  eligibilityCheckInProgress: 'Eligibility check in progress',
  noInsurancePlansFound: 'No insurance plans found',
  confidenceScore: 'Confidence Score',
  insurancePlans: 'Insurance Plans',
  lastChecked: 'Last Checked',
  planName: 'Plan Name',
  serviceStatus: 'Service Status',
  coverageDates: 'Coverage Dates',
  insuranceType: 'Insurance type',
  // Two-factor authentication settings
  twoFactorSettings: {
    title: 'Seguridad',
    status: 'Autenticación de dos factores',
    enable: 'Habilitar 2FA',
    disable: 'Deshabilitar 2FA',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    backupCodesRemaining: 'Códigos de respaldo restantes',
    regenerateCodes: 'Regenerar',
    setupTitle: 'Configurar autenticación de dos factores',
    setupInstructions: 'Escanee este código QR con su aplicación de autenticación (como Google Authenticator o Authy):',
    manualEntry: 'O ingrese este código manualmente:',
    enterCode: 'Ingrese el código de 6 dígitos de su aplicación:',
    disableTitle: 'Deshabilitar autenticación de dos factores',
    disableWarning: 'Ingrese su contraseña para deshabilitar la autenticación de dos factores. Esto hará que su cuenta sea menos segura.',
    regenerateTitle: 'Regenerar códigos de respaldo',
    regenerateWarning: 'Ingrese su contraseña para regenerar los códigos de respaldo. Sus códigos anteriores ya no funcionarán.',
    backupCodesTitle: 'Sus códigos de respaldo',
    backupCodesWarning: 'Guarde estos códigos en un lugar seguro. Cada código solo se puede usar una vez.',
    passwordRequired: 'Se requiere contraseña',
    loadError: 'Error al cargar el estado de 2FA',
    enableError: 'Error al iniciar la configuración de 2FA',
    disableError: 'Error al deshabilitar 2FA',
    regenerateError: 'Error al regenerar códigos de respaldo',
  },
  timerInactivityWarning: 'The timer detected no patient monitoring activity and will stop in {0} seconds unless you click "Continue Timer."',
  timerStoppedDueToInactivity: 'The timer has stopped because no patient monitoring activity was detected for 5:00 minutes. To start the timer again, click "Start Timer."',
  patientNotActivatedTimerWarning: 'Este paciente no tiene un dispositivo activado. Haga clic en "Iniciar temporizador" para registrar la tarea actual, o deje el temporizador detenido si no desea registrar el tiempo. Al hacer clic en "Iniciar temporizador", reconoce que el tiempo de la tarea se registrará y puede contribuir a un código de facturación basado en tiempo para el mes de facturación aplicable. El envío de cualquier código resultante para su reembolso queda a discreción del usuario.',
  recordedBeforeActivation: 'Preactivación',
  recordedBeforeActivationTooltip: 'Esta tarea se registró antes de que se activara la inscripción.',
  recordedAfterActivationTooltip: 'Esta tarea se registró después de que se activara la inscripción.',
  billingDayTooltip:
    'El día que cuenta para la facturación, según la zona horaria del paciente en el momento del registro. Puede diferir de la fecha de las horas de inicio y fin, que se muestran en su zona horaria.',
  timeInPortalTimezoneTooltip: 'Se muestra en su zona horaria ({0}).',
  roleSwitcher: {
    title: 'Cambiar Rol',
    switchRole: 'Cambiar Rol',
    switching: 'Cambiando...',
    resetToNative: 'Restablecer Rol Original',
    resetting: 'Restableciendo...',
    currentRole: 'Actual',
    switched: 'Cambiado',
    defaultRole: 'Rol',
    allFacilities: 'Todas las Instalaciones',
    notAvailable: 'El cambio de rol no está disponible para su cuenta.',
    noRolesAvailable: 'No hay roles disponibles para cambiar.',
    errorLoading: 'Error al cargar las opciones de cambio de rol.',
    errorSwitching: 'Error al cambiar de rol. Por favor, inténtelo de nuevo.',
    errorResetting: 'Error al restablecer el rol original. Por favor, inténtelo de nuevo.',
    patientRoleCannotBeExtended: 'El rol de paciente no se puede extender a otra organización.',
    inherentSwitchableRoles: 'Los roles pueden aparecer en el menú desplegable de cambio de rol por diseño, incluso si no se asignaron explícitamente. Los administradores de organización tienen roles intercambiables inherentes que permiten cambiar a roles adicionales dentro de la organización.',
  },
  removeRole: 'Remove Role',
  removeRoleWarning: 'Are you sure you want to remove the role "{0}" from user {1}?',
  copyCellToClipboard: 'Copy cell to clipboard',
  copyRowToClipboard: 'Copy row to clipboard',
  sequence: 'Sequence',
  sequenceMustBeInteger: 'Sequence must be an integer',
  editWorkType: 'Edit Work Type',
  addWorkType: 'Add Work Type',
  isDefaultTask: 'Is default task',
  isTimerDefaultTask: 'Is default task for timer',
  tracksTime: 'Tracks time',
  previousTimerDefaultTaskWarning: 'Setting this task as default for timer will unset previously set task "{0}"',
  newTimerDefaultTask: 'New default task for timer',
  setAsDefaultTaskForTimer: 'Set as default task for timer',
  setAsDefaultTaskForTimerWarning: 'Do you want to set "{0}" as default task for timer? This will unset previously set task "{1}"',
  clearDefaultTaskForTimer: 'Quitar la tarea predeterminada del temporizador',
  clearDefaultTaskForTimerWarning: '¿Desea quitar "{0}" como tarea predeterminada del temporizador? Es posible que se utilice la tarea alternativa de la organización.',
  timerDefaultTaskCleared: 'Se quitó la tarea predeterminada del temporizador',
  enabledForOrg: 'Enabled for organization',
  includeEmptyDataInExport: 'Export data for all device types and CPT codes, including those with no data in the selected date range',
  notSet: 'Not set',
  annotations: 'Annotations',
  editAnnotations: 'Edit Annotations',
  color: 'Color',
  quantity: 'Quantity',
  requiresHub: 'Requires Hub',
  changedBy: 'Changed by',
  oldValue: 'Old value',
  newValue: 'New value',
  timelineEventTypesEnum: {
    status_changed: 'Status changed',
    kit_added: 'Kit added',
    kit_removed: 'Kit removed',
    org_assigned: 'Organization assigned',
    org_unassigned: 'Organization unassigned',
    billing_record_created: 'Billing record created',
    shipment_new: 'New Shipment',
    shipment_created: 'Shipment created',
    shipment_in_transit: 'Shipment in transit',
    shipment_delivered: 'Shipment delivered',
    shipment_cancelled: 'Shipment cancelled',
  },
  saveSettings: 'Save Settings',
  deviceInvoices: {
    deviceInvoices: 'Device Invoices',
    deviceInvoice: 'Device Invoice',
    initial: 'Initial Cost',
    recurring: 'Recurring Cost',
    invoiceData: 'Invoice Data',
    pricing: 'Pricing',
    billingOrg: 'Billing Org',
    item: 'Item',
    shippingItemPrefix: 'Shipping',
    shippingItemSummary: 'Shipping ({0} devices)',
    kittingFee: 'Tarifa de preparación',
    fixedShippingFee: 'Tarifa fija de envío',
    dataFee: 'Tarifa de datos',
    price: 'Price',
    readyForApproval: 'Ready for approval',
    approved: 'Approved',
    actionRequired: 'Action required',
    canceled: 'Canceled',
    markReady: 'Mark as ready for approval',
    billingMonth: 'Billing month',
    invoiceUuid: 'Invoice UUID',
    sourceDeviceId: 'Source device ID',
    billingEndDate: 'Billing end date',
    invoiceDate: 'Invoice date',
    isSample: 'Is sample',
    sample: 'Sample',
    regular: 'Regular',
    editSampleStatus: 'Edit sample status',
    markDeviceAsSampleWarning: 'Mark this device as sample? Editable device invoices will be recalculated.',
    markDeviceAsRegularWarning: 'Mark this device as regular? Editable device invoices will be recalculated.',
    sampleStatusChangeWarning: 'Editable device invoices will be recalculated.',
    sampleStatusUpdated: 'Sample status updated successfully',
    invoiceIssuesEnum: {
      pricing_definition_missing: 'Missing pricing',
      multiple_assignments: 'Multiple assignments',
      automatic_assignment: 'Device added automatically outside the official process',
      missing_program: 'Missing program',
      multiple_programs_in_kit_month: 'Multiple programs',
      new_enrollment_assigned: 'New enrollment assigned',
      multiple_base_devices_in_kit_month: 'Multiple base devices',
      missing_kit_assignment_timestamp: 'Missing kit assignment timestamp',
      missing_kit_assignment: 'Missing kit assignment',
      missing_enrollment: 'Missing enrollment',
      'enrollment terminated but kit still assigned to organization': 'Enrollment terminated but kit still assigned',
    },
    invoiceUpdated: 'Invoice updated successfully',
    invoiceUpdateFailed: 'Failed to update invoice',
    setInvoiceDate: 'Set Invoice Date',
    changeInvoiceDate: 'Change Invoice Date',
    clearInvoiceDate: 'Clear Invoice Date',
    clearInvoiceDateWarning: 'You are going to clear the invoice date for the selected approved invoices.',
    invoiceDateUpdated: 'Invoice date updated successfully',
    invoiceDateCleared: 'Invoice date cleared successfully',
    invoiceDateUpdateFailed: 'Failed to update invoice date',
    invoiceDateRequired: 'Invoice date is required',
    invoicesCanceled: 'Invoices canceled successfully',
    cancelInvoices: 'Cancel Invoices',
    restoreInvoice: 'Restore Invoice',
    restoreInvoices: 'Restore Invoices',
    invoicesRestored: 'Invoices restored successfully',
    restoreInvoicesWarning: 'Are you sure you want to restore the selected canceled invoices? Restored invoices will re-enter the review flow.',
    batchActionWarning: 'You are going to modify {0} elements.',
    batchActionSingleWarning: 'You are going to modify 1 element.',
    markInvoicesReady: 'Mark Invoices as Ready for Approval',
    invoicesMarkedReady: 'Invoices marked as ready for approval successfully',
    approveInvoices: 'Approve Invoices',
    invoicesApproved: 'Invoices approved successfully',
    requestAction: 'Request Action',
    actionRequested: 'Action requested successfully',
    recalculateInvoices: 'Recalculate Invoices',
    recalculateInvoice: 'Recalculate Invoice',
    invoicesRecalculated: 'Invoices recalculated successfully',
    batchActionAllActionRequiredWarning: 'This may modify all Action required invoices.',
    recalculateInvoicesWarning: 'Are you sure you want to recalculate selected invoices? This will update invoice amounts based on current device assignments and pricing, and may change invoice issues.',
    recalculateAllActionRequiredInvoicesWarning: 'You are going to recalculate invoices in Action required. This will update invoice amounts based on current device assignments and pricing, and may change invoice issues.',
    initialDownloadDateRangeInfo: 'The selected date range applies to the shipment date. For invoices without a shipment, the date added to org is used.',
    recurringDownloadDateRangeInfo: 'The selected date range applies to the billing period shown on the invoice.',
    generateInvoicesForMonth: 'Generate Invoices for Month',
    recurringStartedMonthRequired: 'Select current or past month.',
    invoiceHistoryEntryTypes: {
      commented: 'Commented',
      field_edit: 'Field Edit',
      generated: 'Generated',
      recalculated: 'Recalculated',
      approved: 'Approved',
      canceled: 'Canceled',
      ready_for_approval: 'Ready for Approval',
      action_required: 'Action Required',
      marked_ready: 'Marked Ready for Approval',
      restored: 'Restored',
    },
    relationTypes: {
      same_device: 'Same device',
      same_billing_source: 'Same billing source',
    },
    pricingScope: 'Pricing Scope',
    defaultPrice: 'Default Price',
    organizationPrice: 'Organization Price',
    addPrice: 'Add Price',
    editPrice: 'Edit Price',
    deletePrice: 'Delete Price',
    deletePriceWarning: 'Are you sure you want to delete this price?',
    priceDeleted: 'Price deleted successfully',
    pricingType: "Pricing Type",
    priceHistory: 'Price History',
    viewPricesHistory: 'View Prices History',
    noPricesHistory: 'No price changes history available for this price',
    setNewPrice: 'Set new price',
    itemDescription: 'Item description',
  },
  issues: 'Issues',
  continueWithSSO: 'Continue with SSO',
  checking: 'Checking...',
  enterEmailOrUsername: 'Enter your email or username to continue with SSO.',
  operationCompleted: 'Operation completed successfully',
  updated: 'Updated',
  baselined: 'Baselined',
  relatedItems: 'Related Items',
  effectiveFrom: 'Effective from',
  effectiveTo: 'Effective to',
  editPrice: 'Edit Price',
  addComment: 'Add Comment',
  invalidUsernameOrPassword: 'Invalid username or password',
  internalError: 'Something went wrong. Please try again.',
  submittedDate: 'Submitted date',
  cancelledDate: 'Cancelled date',
  attempts: 'Attempts',
  errorMessage: 'Error message',
  timerStoppedReasons: {
    active: 'Timer is currently running',
    manual: 'Timer was stopped manually',
    inactivity: 'Timer was stopped due to inactivity',
    interrupted: 'Timer session was interrupted',
  },
  saveConfiguration: 'Save Configuration',
  searchByNameAndDob: 'Search in Athena by Name and DOB',
  searchByAthenaPatientId: 'Search in Athena by Athena Patient ID',
  searchResults: 'Search Results',
  noPatientsFound: 'No patients found',
  selectPatient: 'Select Patient',
  mismatchBetweenPatientAndAthena: 'Mismatch between patient and Athena record',
  patientOverrideWarning: 'After selecting patient, the edited record will be overridden by data from Athena',
  vitalValue: 'Vital Value',
  globalDefaults: 'Global defaults',
  restrictedOrganization: 'Restricted organization',
  orgLevels: { global: 'Global', partner: 'Partner', client: 'Client', location: 'Location' },
  sourceLanguage: '{0} ({1})',
  reminderPreviewError: 'No se pudo cargar la vista previa del impacto. Inténtalo de nuevo antes de guardar.',
  reminderPreviewRetry: 'Reintentar vista previa',
  reminderImpactApplies: 'This change will affect {0}:',
  reminderImpactOverridden: 'This change will not affect {0} because they use a more specific template:',
  reminderImpactFallback: 'The reset will also affect {0}:',
  reminderImpactOneClient: '1 client',
  reminderImpactManyClients: '{0} clients',
  reminderImpactOneLocation: '1 location',
  reminderImpactManyLocations: '{0} locations',
  createOrgSpecificTemplate: 'Create Organization Specific Template',
  createLanguageSpecificTemplate: 'Create Language Specific Template',
  clearOrgSpecificTemplate: 'Clear Organization Specific Template',
  clearLanguageSpecificTemplate: 'Clear Language Specific Template',
  insufficientPermissionsToEditTemplate: 'No tiene permisos suficientes para editar esta plantilla.',
  editCurrentlyUsedTemplate: 'Edit Currently Used Template: {0}',
  tags: 'Etiquetas',
  patientActions: {
    notHidden: 'No ocultas',
    title: 'Acciones',
    assignedTo: 'Asignadas a',
    unassigned: 'Sin asignar',
    me: 'Mí',
    anyone: 'Cualquiera',
    assignee: 'Responsable',
    patient: 'Paciente',
    action: 'Acción',
    state: 'Estado',
    open: 'Abierta',
    completed: 'Completada',
    allStatuses: 'Abiertas y completadas',
    allPriorities: 'Todas las prioridades',
    priority: 'Prioridad',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    deadline: 'Fecha límite',
    overdue: 'Vencida',
    overdueOnly: 'Solo vencidas',
    showHidden: 'Solo ocultas',
    hiddenUntil: 'Oculta hasta {0}',
    edit: 'Editar acción',
    assignToMe: 'Asignarme',
    hide: 'Ocultar',
    hideNo: 'No ocultar',
    hideDay: 'Durante 1 día',
    hideWeek: 'Durante 1 semana',
    hideUntil: 'Hasta la fecha',
    unhide: 'Mostrar de nuevo',
    complete: 'Completar',
    reopen: 'Reabrir',
    closedAutomatically: 'Esta acción se cierra automáticamente cuando deja de aplicar. Puede asignarla u ocultarla.',
    completedByChartReview: 'Complétela con Revisar en la página del paciente.',
    completedByCareUpdate: 'Esta acción se cierra cuando se completa su Care Update.',
    completeWarning: 'Esta acción normalmente se cierra automáticamente. ¿Completarla de todos modos?',
    history: 'Historial',
    noHistory: 'No hay cambios registrados',
    historyStart: 'Aquí empieza el historial',
    unknownActor: 'Desconocido',
    completedBy: 'Completada por {0}',
    completedAutomatically: 'Completada automáticamente',
    createdBy: 'Creada por {0}',
    saved: 'Acción guardada',
    requestFailed: 'La solicitud falló',
    fields: {
      content: 'Texto',
      viewable_by: 'Visible para',
      is_action: 'Acción',
      completed_at: 'Completada el',
      completed_by: 'Completada por',
      priority: 'Prioridad',
      assignee: 'Responsable',
      due_at: 'Fecha límite',
      past_deadline: 'Vencida',
      hidden_until: 'Oculta hasta',
      closable_by: 'La cierra',
    },
    closableBy: {
      system: 'El sistema',
      human_with_warning: 'Personas (normalmente automático)',
      human: 'Personas',
    },
    accessType: 'Acción ACCESS',
    allAccessTypes: 'Todas las acciones',
    track: 'Programa',
    allTracks: 'Todos los programas',
    type: 'Tipo',
    resultCode: 'Resultado de CMS',
    resolution: 'Resolución',
    resolutionHint: 'Opcional: qué se hizo o por qué se cerró el proceso',
    recheckEligibility: 'Verificar elegibilidad de nuevo',
    recheckSubmitted: 'Verificación de elegibilidad enviada; esta acción se cierra cuando CMS ya no informe una discrepancia',
    accessTypes: {
      access_care_initiation: 'Inicio de atención',
      access_care_escalation: 'Escalamiento de atención',
      access_care_completion: 'Finalización de atención',
      not_eligible_ack: 'No elegible – confirmar',
      proceed_to_alignment: 'Elegible – continuar con la alineación',
      proceed_to_switch: 'Elegible para cambiar – continuar con el cambio',
      data_mismatch: 'Datos no coinciden – corregir datos',
      recheck_window_expired: 'Periodo de reverificación vencido',
    },
  },
  surveys: {
    surveys: 'Encuestas',
    createSurvey: 'Crear encuesta',
    newSurveyTitle: 'Nueva encuesta',
    untitledSurvey: 'Encuesta sin título',
    untitledQuestion: 'Pregunta sin título',
    title: 'Título',
    description: 'Descripción',
    statusDraft: 'Borrador, no publicada',
    publishedVersion: 'Publicada, versión {0}',
    unpublishedChanges: 'cambios sin publicar',
    unsavedChanges: 'cambios sin guardar',
    sent: 'Enviadas',
    completed: 'Completadas',
    lastChanged: 'Último cambio',
    builder: 'Editor',
    responses: 'Respuestas',
    archive: 'Archivar',
    archived: 'Encuesta archivada',
    archiveConfirm: '¿Archivar la encuesta "{0}"? Los enlaces ya enviados funcionan hasta que caduquen.',
    publish: 'Publicar',
    publishedNotification: 'Versión {0} publicada',
    publishFailed: 'No se pudo publicar la encuesta',
    publishBeforeSending: 'Publique la encuesta antes de enviarla',
    send: 'Enviar encuesta',
    sendNow: 'Enviar',
    sendTitle: 'Enviar encuesta (versión {0})',
    sendFailed: 'No se pudo enviar la encuesta',
    sentNotification: 'La encuesta se está enviando a {0} paciente(s)',
    draftSaved: 'Borrador guardado',
    saveFailed: 'No se pudo guardar el cambio',
    loadFailed: 'No se pudieron cargar las encuestas',
    downloadFailed: 'No se pudo descargar el archivo',
    pageN: 'Página {0}',
    pageTitlePlaceholder: 'Título de la página (opcional)',
    deletePage: 'Eliminar página',
    addPage: 'Añadir página',
    deleteQuestion: 'Eliminar pregunta',
    dragToReorder: 'Arrastre para reordenar',
    information: 'Información',
    informationText: 'Texto informativo',
    questionText: 'Pregunta',
    questionId: 'ID de la pregunta (columna de exportación)',
    required: 'Respuesta obligatoria',
    options: 'Opciones',
    optionN: 'Opción {0}',
    addOption: 'Añadir opción',
    removeOption: 'Quitar opción',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    maxLength: 'Longitud máxima',
    showOnlyIf: 'Mostrar esta pregunta solo si',
    showPageOnlyIf: 'Mostrar esta página solo si',
    addCondition: 'Mostrar solo si…',
    addPageCondition: 'Mostrar esta página solo si…',
    conditionMatch: 'Cumplir',
    behaviorAll: 'todas las reglas',
    behaviorAny: 'alguna de las reglas',
    question: 'Pregunta',
    operator: 'Condición',
    value: 'Valor',
    addRule: 'Añadir regla',
    removeRule: 'Quitar regla',
    patientPreview: 'Vista del paciente',
    problemsToFix: 'Corregir antes de publicar',
    itemTypes: {
      single_choice: 'Opción única',
      multi_choice: 'Opción múltiple',
      scale: 'Escala',
      boolean: 'Sí / No',
      integer: 'Número entero',
      decimal: 'Número decimal',
      date: 'Fecha',
      short_text: 'Texto corto',
      long_text: 'Texto largo',
      display: 'Texto informativo',
    },
    operators: {
      answered: 'está respondida',
      not_answered: 'no está respondida',
      equals: 'es',
      not_equals: 'no es',
      contains: 'incluye',
      not_contains: 'no incluye',
      gt: 'es mayor que',
      gte: 'es al menos',
      lt: 'es menor que',
      lte: 'es como máximo',
    },
    channel: 'Enviar por',
    channels: { sms: 'SMS', email: 'Correo electrónico' },
    recipients: 'Destinatarios',
    recipientsByFilter: 'Pacientes que cumplen los filtros',
    recipientsSelected: 'Pacientes seleccionados',
    patients: 'Pacientes',
    searchPatients: 'Buscar pacientes',
    conditions: 'Condiciones',
    anyCondition: 'Cualquier condición',
    facilities: 'Centros',
    anyFacility: 'Cualquier centro',
    medication: 'Medicamento',
    medicationPlaceholder: 'Cualquier medicamento, o parte de su nombre',
    linkValidDays: 'Enlace válido durante (días)',
    linkValidDaysRange: 'Entre 1 y 60 días',
    countingRecipients: 'Contando destinatarios…',
    willReceive: '{0} paciente(s) recibirán la encuesta.',
    nobodyToSend: 'Nadie puede recibir la encuesta con esta configuración. Cambie los destinatarios o el canal.',
    publishedTypeLocked: 'Esta pregunta ya se publicó, por lo que su tipo no puede cambiar. Añada una pregunta nueva.',
    sendSurveyTitle: 'Enviar una encuesta',
    patientField: 'Paciente',
    survey: 'Encuesta',
    surveyWithVersion: '{0} (versión {1})',
    chooseSurvey: 'Elija una encuesta publicada',
    noPublishedSurveys: 'Aún no hay encuestas publicadas',
    chooseSurveyFirst: 'Elija una encuesta para enviar.',
    timepoint: 'Momento (opcional)',
    timepointPlaceholder: 'p. ej. Inicio, Día 90',
    timepointColumn: 'Momento',
    patientTab: 'Encuestas',
    noPatientSurveys: 'Aún no se enviaron encuestas a este paciente. Use Acciones → Enviar encuesta.',
    archivedSuffix: '(archivada)',
    notAnswered: '-',
    skipped: {
      already_open: '{0} omitido(s): tienen un enlace de encuesta sin terminar.',
      no_mobile_phone: '{0} omitido(s): sin teléfono móvil.',
      no_email: '{0} omitido(s): sin correo electrónico.',
      sms_opted_out: '{0} omitido(s): no aceptan SMS.',
    },
    version: 'Versión',
    sentAt: 'Enviada',
    completedAt: 'Completada',
    expiresAt: 'El enlace caduca',
    viewResponse: 'Ver respuestas',
    revokeLink: 'Revocar enlace',
    revokeConfirm: '¿Revocar el enlace de la encuesta de {0}? El enlace dejará de funcionar.',
    linkRevoked: 'Enlace revocado',
    downloadResponses: 'Descargar respuestas (CSV)',
    downloadCodebook: 'Descargar guía de columnas (libro de códigos)',
    answersSummary: 'Respuestas (preguntas de la versión {0}, respuestas completadas)',
    answeredN: '{0} respondieron',
    numberSummary: 'Mín {0} · Media {1} · Máx {2}',
    countLabels: {
      waiting: 'Pendientes de envío',
      sent: 'Enviadas, sin abrir',
      in_progress: 'Abiertas, sin terminar',
      completed: 'Completadas',
      expired: 'Caducadas',
      failed: 'No entregadas o revocadas',
    },
    assignmentStatus: {
      pending: 'Pendiente de envío',
      sending: 'Enviando',
      sent: 'Enviada',
      in_progress: 'En curso',
      completed: 'Completada',
      failed: 'No entregada',
      revoked: 'Revocada',
      expired: 'Caducada',
    },
    addQuestionToPage: 'Añadir una pregunta a la página {0}',
    chooseQuestionType: 'Elija el tipo de pregunta…',
    previewHint: 'Pruebe la encuesta como lo haría un paciente. Las respuestas de prueba se mantienen mientras edita y nunca se guardan.',
    previewValid: 'Todas las respuestas son válidas: esto es lo que enviaría el paciente.',
    checkAnswers: 'Comprobar respuestas',
    archiveTooltip: 'Oculta esta encuesta de la lista y detiene nuevos envíos. Los enlaces ya enviados funcionan hasta que caduquen.',
    saveTooltip: 'Guarda los cambios como borrador. Los pacientes solo ven versiones publicadas.',
    publishTooltip: 'Guarda y bloquea el borrador actual como una nueva versión. Los nuevos envíos usan la última versión; las respuestas anteriores conservan la versión con la que se enviaron.',
    sendTooltip: 'Envía la última versión publicada a pacientes por SMS o correo electrónico.',
    editInBuilder: 'Editar en el editor',
    viewResponses: 'Ver respuestas',
    openedAt: 'Abierta',
    startedAt: 'Iniciada',
    downloadResponsesTooltip: 'Una fila por paciente que abrió la encuesta, una columna por pregunta. Las respuestas son códigos; la guía de columnas los explica.',
    downloadCodebookTooltip: 'Explica cada columna del archivo de respuestas y el significado de cada código (p. ej. qué opción es "c4").',
    countTooltips: {
      waiting: 'Creada y esperando el siguiente envío (aproximadamente cada minuto).',
      sent: 'El mensaje se envió; el paciente aún no ha abierto el enlace.',
      in_progress: 'El paciente abrió el enlace pero aún no la envió. Puede continuar más tarde.',
      completed: 'El paciente envió la encuesta.',
      expired: 'El enlace caducó antes de que el paciente la enviara.',
      failed: 'No se pudo entregar (sin teléfono o correo, no acepta SMS, error del proveedor) o el enlace fue revocado.',
    },
    patient: {
      loading: 'Cargando su encuesta…',
      invalidLink: 'Este enlace de encuesta no es válido o ha caducado. Contacte con su equipo de atención para recibir uno nuevo.',
      thankYou: '¡Gracias!',
      submitted: 'Sus respuestas se enviaron a su equipo de atención. Puede cerrar esta página.',
      alreadySubmitted: 'Esta encuesta ya fue completada. Puede cerrar esta página.',
      resumeHint: 'Sus respuestas se guardan sobre la marcha. Puede cerrar esta página y continuar más tarde con el mismo enlace.',
      saved: 'Sus respuestas están guardadas. Puede cerrar esta página y continuar más tarde con el mismo enlace.',
      submitFailed: 'No se pudieron enviar sus respuestas. Compruebe su conexión e inténtelo de nuevo.',
    },
  },
};

export default spanish;
